var _s = Object.defineProperty;
var ws = (e, t, r) => t in e ? _s(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var It = (e, t, r) => ws(e, typeof t != "symbol" ? t + "" : t, r);
var Jr = function(e, t) {
  return Jr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Jr(e, t);
};
function De(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Jr(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var v = function() {
  return v = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, v.apply(this, arguments);
};
function Pe(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function xe(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (h) {
        a(h);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (h) {
        a(h);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function Me(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = s(0), a.throw = s(1), a.return = s(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (r = 0)), r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function se(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Rr = "Invariant Violation", Yn = Object.setPrototypeOf, Es = Yn === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : Yn, bo = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = Rr);
      var n = e.call(this, typeof r == "number" ? Rr + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = Rr, Es(n, t.prototype), n;
    }
    return t;
  })(Error)
);
function Ye(e, t) {
  if (!e)
    throw new bo(t);
}
var _o = ["debug", "log", "warn", "error", "silent"], ks = _o.indexOf("log");
function Gt(e) {
  return function() {
    if (_o.indexOf(e) >= ks) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = Gt("debug"), e.log = Gt("log"), e.warn = Gt("warn"), e.error = Gt("error");
})(Ye || (Ye = {}));
var wn = "3.14.1";
function Oe(e) {
  try {
    return e();
  } catch {
  }
}
const ur = Oe(function() {
  return globalThis;
}) || Oe(function() {
  return window;
}) || Oe(function() {
  return self;
}) || Oe(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Oe(function() {
  return Oe.constructor("return this")();
});
var Xn = /* @__PURE__ */ new Map();
function Gr(e) {
  var t = Xn.get(e) || 1;
  return Xn.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function wo(e, t) {
  t === void 0 && (t = 0);
  var r = Gr("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function Kt(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = En(i), t || (t = kn(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var D = Object.assign(function(t, r) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  t || Ye(t, En(r, n) || kn(r, n));
}, {
  debug: Kt(Ye.debug),
  log: Kt(Ye.log),
  warn: Kt(Ye.warn),
  error: Kt(Ye.error)
});
function ve(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new bo(En(e, t) || kn(e, t));
}
var ei = Symbol.for("ApolloErrorMessageHandler_" + wn);
function Eo(e) {
  if (typeof e == "string")
    return e;
  try {
    return wo(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function En(e, t) {
  if (t === void 0 && (t = []), !!e)
    return ur[ei] && ur[ei](e, t.map(Eo));
}
function kn(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: wn,
      message: e,
      args: t.map(Eo)
    })));
}
var K = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function Ss(e, t) {
  var r = !!e;
  if (!r)
    throw new Error("Unexpected invariant triggered.");
}
var Kr = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function ko(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || Ss(0), e.prototype.inspect = t, Kr && (e.prototype[Kr] = t);
}
var Os = /* @__PURE__ */ (function() {
  function e(r, n, i) {
    this.start = r.start, this.end = n.end, this.startToken = r, this.endToken = n, this.source = i;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
})();
ko(Os);
var Ts = /* @__PURE__ */ (function() {
  function e(r, n, i, o, a, s, u) {
    this.kind = r, this.start = n, this.end = i, this.line = o, this.column = a, this.value = u, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
})();
ko(Ts);
function ti(e) {
  return e != null && typeof e.kind == "string";
}
function tr(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? tr = function(r) {
    return typeof r;
  } : tr = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, tr(e);
}
var Ds = 10, So = 2;
function Is(e) {
  return gr(e, []);
}
function gr(e, t) {
  switch (tr(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : zs(e, t);
    default:
      return String(e);
  }
}
function zs(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var r = [].concat(t, [e]), n = Fs(e);
  if (n !== void 0) {
    var i = n.call(e);
    if (i !== e)
      return typeof i == "string" ? i : gr(i, r);
  } else if (Array.isArray(e))
    return Ps(e, r);
  return Rs(e, r);
}
function Rs(e, t) {
  var r = Object.keys(e);
  if (r.length === 0)
    return "{}";
  if (t.length > So)
    return "[" + Cs(e) + "]";
  var n = r.map(function(i) {
    var o = gr(e[i], t);
    return i + ": " + o;
  });
  return "{ " + n.join(", ") + " }";
}
function Ps(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > So)
    return "[Array]";
  for (var r = Math.min(Ds, e.length), n = e.length - r, i = [], o = 0; o < r; ++o)
    i.push(gr(e[o], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push("... ".concat(n, " more items")), "[" + i.join(", ") + "]";
}
function Fs(e) {
  var t = e[String(Kr)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function Cs(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
function Ns(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = e.indexOf(`
`) === -1, i = e[0] === " " || e[0] === "	", o = e[e.length - 1] === '"', a = e[e.length - 1] === "\\", s = !n || o || a || r, u = "";
  return s && !(n && i) && (u += `
` + t), u += t ? e.replace(/\n/g, `
` + t) : e, s && (u += `
`), '"""' + u.replace(/"""/g, '\\"""') + '"""';
}
var As = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, br = Object.freeze({});
function Te(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : As, n = void 0, i = Array.isArray(e), o = [e], a = -1, s = [], u = void 0, c = void 0, l = void 0, h = [], d = [], f = e;
  do {
    a++;
    var p = a === o.length, m = p && s.length !== 0;
    if (p) {
      if (c = d.length === 0 ? void 0 : h[h.length - 1], u = l, l = d.pop(), m) {
        if (i)
          u = u.slice();
        else {
          for (var g = {}, y = 0, b = Object.keys(u); y < b.length; y++) {
            var w = b[y];
            g[w] = u[w];
          }
          u = g;
        }
        for (var k = 0, S = 0; S < s.length; S++) {
          var T = s[S][0], P = s[S][1];
          i && (T -= k), i && P === null ? (u.splice(T, 1), k++) : u[T] = P;
        }
      }
      a = n.index, o = n.keys, s = n.edits, i = n.inArray, n = n.prev;
    } else {
      if (c = l ? i ? a : o[a] : void 0, u = l ? l[c] : f, u == null)
        continue;
      l && h.push(c);
    }
    var R = void 0;
    if (!Array.isArray(u)) {
      if (!ti(u))
        throw new Error("Invalid AST Node: ".concat(Is(u), "."));
      var x = xs(t, u.kind, p);
      if (x) {
        if (R = x.call(t, u, c, l, h, d), R === br)
          break;
        if (R === !1) {
          if (!p) {
            h.pop();
            continue;
          }
        } else if (R !== void 0 && (s.push([c, R]), !p))
          if (ti(R))
            u = R;
          else {
            h.pop();
            continue;
          }
      }
    }
    if (R === void 0 && m && s.push([c, u]), p)
      h.pop();
    else {
      var L;
      n = {
        inArray: i,
        index: a,
        keys: o,
        edits: s,
        prev: n
      }, i = Array.isArray(u), o = i ? u : (L = r[u.kind]) !== null && L !== void 0 ? L : [], a = -1, s = [], l && d.push(l), l = u;
    }
  } while (n !== void 0);
  return s.length !== 0 && (f = s[s.length - 1][1]), f;
}
function xs(e, t, r) {
  var n = e[t];
  if (n) {
    if (!r && typeof n == "function")
      return n;
    var i = r ? n.leave : n.enter;
    if (typeof i == "function")
      return i;
  } else {
    var o = r ? e.leave : e.enter;
    if (o) {
      if (typeof o == "function")
        return o;
      var a = o[t];
      if (typeof a == "function")
        return a;
    }
  }
}
function Ms(e) {
  return Te(e, {
    leave: $s
  });
}
var js = 80, $s = {
  Name: function(t) {
    return t.value;
  },
  Variable: function(t) {
    return "$" + t.name;
  },
  // Document
  Document: function(t) {
    return z(t.definitions, `

`) + `
`;
  },
  OperationDefinition: function(t) {
    var r = t.operation, n = t.name, i = G("(", z(t.variableDefinitions, ", "), ")"), o = z(t.directives, " "), a = t.selectionSet;
    return !n && !o && !i && r === "query" ? a : z([r, z([n, i]), o, a], " ");
  },
  VariableDefinition: function(t) {
    var r = t.variable, n = t.type, i = t.defaultValue, o = t.directives;
    return r + ": " + n + G(" = ", i) + G(" ", z(o, " "));
  },
  SelectionSet: function(t) {
    var r = t.selections;
    return Se(r);
  },
  Field: function(t) {
    var r = t.alias, n = t.name, i = t.arguments, o = t.directives, a = t.selectionSet, s = G("", r, ": ") + n, u = s + G("(", z(i, ", "), ")");
    return u.length > js && (u = s + G(`(
`, rr(z(i, `
`)), `
)`)), z([u, z(o, " "), a], " ");
  },
  Argument: function(t) {
    var r = t.name, n = t.value;
    return r + ": " + n;
  },
  // Fragments
  FragmentSpread: function(t) {
    var r = t.name, n = t.directives;
    return "..." + r + G(" ", z(n, " "));
  },
  InlineFragment: function(t) {
    var r = t.typeCondition, n = t.directives, i = t.selectionSet;
    return z(["...", G("on ", r), z(n, " "), i], " ");
  },
  FragmentDefinition: function(t) {
    var r = t.name, n = t.typeCondition, i = t.variableDefinitions, o = t.directives, a = t.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(r).concat(G("(", z(i, ", "), ")"), " ") + "on ".concat(n, " ").concat(G("", z(o, " "), " ")) + a
    );
  },
  // Value
  IntValue: function(t) {
    var r = t.value;
    return r;
  },
  FloatValue: function(t) {
    var r = t.value;
    return r;
  },
  StringValue: function(t, r) {
    var n = t.value, i = t.block;
    return i ? Ns(n, r === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(t) {
    var r = t.value;
    return r ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(t) {
    var r = t.value;
    return r;
  },
  ListValue: function(t) {
    var r = t.values;
    return "[" + z(r, ", ") + "]";
  },
  ObjectValue: function(t) {
    var r = t.fields;
    return "{" + z(r, ", ") + "}";
  },
  ObjectField: function(t) {
    var r = t.name, n = t.value;
    return r + ": " + n;
  },
  // Directive
  Directive: function(t) {
    var r = t.name, n = t.arguments;
    return "@" + r + G("(", z(n, ", "), ")");
  },
  // Type
  NamedType: function(t) {
    var r = t.name;
    return r;
  },
  ListType: function(t) {
    var r = t.type;
    return "[" + r + "]";
  },
  NonNullType: function(t) {
    var r = t.type;
    return r + "!";
  },
  // Type System Definitions
  SchemaDefinition: ke(function(e) {
    var t = e.directives, r = e.operationTypes;
    return z(["schema", z(t, " "), Se(r)], " ");
  }),
  OperationTypeDefinition: function(t) {
    var r = t.operation, n = t.type;
    return r + ": " + n;
  },
  ScalarTypeDefinition: ke(function(e) {
    var t = e.name, r = e.directives;
    return z(["scalar", t, z(r, " ")], " ");
  }),
  ObjectTypeDefinition: ke(function(e) {
    var t = e.name, r = e.interfaces, n = e.directives, i = e.fields;
    return z(["type", t, G("implements ", z(r, " & ")), z(n, " "), Se(i)], " ");
  }),
  FieldDefinition: ke(function(e) {
    var t = e.name, r = e.arguments, n = e.type, i = e.directives;
    return t + (ri(r) ? G(`(
`, rr(z(r, `
`)), `
)`) : G("(", z(r, ", "), ")")) + ": " + n + G(" ", z(i, " "));
  }),
  InputValueDefinition: ke(function(e) {
    var t = e.name, r = e.type, n = e.defaultValue, i = e.directives;
    return z([t + ": " + r, G("= ", n), z(i, " ")], " ");
  }),
  InterfaceTypeDefinition: ke(function(e) {
    var t = e.name, r = e.interfaces, n = e.directives, i = e.fields;
    return z(["interface", t, G("implements ", z(r, " & ")), z(n, " "), Se(i)], " ");
  }),
  UnionTypeDefinition: ke(function(e) {
    var t = e.name, r = e.directives, n = e.types;
    return z(["union", t, z(r, " "), n && n.length !== 0 ? "= " + z(n, " | ") : ""], " ");
  }),
  EnumTypeDefinition: ke(function(e) {
    var t = e.name, r = e.directives, n = e.values;
    return z(["enum", t, z(r, " "), Se(n)], " ");
  }),
  EnumValueDefinition: ke(function(e) {
    var t = e.name, r = e.directives;
    return z([t, z(r, " ")], " ");
  }),
  InputObjectTypeDefinition: ke(function(e) {
    var t = e.name, r = e.directives, n = e.fields;
    return z(["input", t, z(r, " "), Se(n)], " ");
  }),
  DirectiveDefinition: ke(function(e) {
    var t = e.name, r = e.arguments, n = e.repeatable, i = e.locations;
    return "directive @" + t + (ri(r) ? G(`(
`, rr(z(r, `
`)), `
)`) : G("(", z(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + z(i, " | ");
  }),
  SchemaExtension: function(t) {
    var r = t.directives, n = t.operationTypes;
    return z(["extend schema", z(r, " "), Se(n)], " ");
  },
  ScalarTypeExtension: function(t) {
    var r = t.name, n = t.directives;
    return z(["extend scalar", r, z(n, " ")], " ");
  },
  ObjectTypeExtension: function(t) {
    var r = t.name, n = t.interfaces, i = t.directives, o = t.fields;
    return z(["extend type", r, G("implements ", z(n, " & ")), z(i, " "), Se(o)], " ");
  },
  InterfaceTypeExtension: function(t) {
    var r = t.name, n = t.interfaces, i = t.directives, o = t.fields;
    return z(["extend interface", r, G("implements ", z(n, " & ")), z(i, " "), Se(o)], " ");
  },
  UnionTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.types;
    return z(["extend union", r, z(n, " "), i && i.length !== 0 ? "= " + z(i, " | ") : ""], " ");
  },
  EnumTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.values;
    return z(["extend enum", r, z(n, " "), Se(i)], " ");
  },
  InputObjectTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.fields;
    return z(["extend input", r, z(n, " "), Se(i)], " ");
  }
};
function ke(e) {
  return function(t) {
    return z([t.description, e(t)], `
`);
  };
}
function z(e) {
  var t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e == null ? void 0 : e.filter(function(n) {
    return n;
  }).join(r)) !== null && t !== void 0 ? t : "";
}
function Se(e) {
  return G(`{
`, rr(z(e, `
`)), `
}`);
}
function G(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + r : "";
}
function rr(e) {
  return G("  ", e.replace(/\n/g, `
  `));
}
function Ls(e) {
  return e.indexOf(`
`) !== -1;
}
function ri(e) {
  return e != null && e.some(Ls);
}
function ni(e) {
  return e.kind === K.FIELD || e.kind === K.FRAGMENT_SPREAD || e.kind === K.INLINE_FRAGMENT;
}
function Wt(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : Zs(r).every(function(n) {
    var i = n.directive, o = n.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = t && t[o.value.name.value], D(a !== void 0, 105, i.name.value)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function Vt(e, t, r) {
  var n = new Set(e), i = n.size;
  return Te(t, {
    Directive: function(o) {
      if (n.delete(o.name.value) && (!r || !n.size))
        return br;
    }
  }), r ? !n.size : n.size < i;
}
function Vs(e) {
  return e && Vt(["client", "export"], e, !0);
}
function qs(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function Zs(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (qs(r)) {
      var n = r.arguments, i = r.name.value;
      D(n && n.length === 1, 106, i);
      var o = n[0];
      D(o.name && o.name.value === "if", 107, i);
      var a = o.value;
      D(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 108, i), t.push({ directive: r, ifArgument: o });
    }
  }), t;
}
function Qs(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(o) {
    var a = o.name;
    return a.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(o) {
    var a = o.name;
    return a.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === K.VARIABLE ? globalThis.__DEV__ !== !1 && D.warn(109) : i.value.kind !== K.STRING ? globalThis.__DEV__ !== !1 && D.warn(110) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && D.warn(111, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const Us = () => /* @__PURE__ */ Object.create(null), { forEach: Bs, slice: ii } = Array.prototype, { hasOwnProperty: Ws } = Object.prototype;
class Ne {
  constructor(t = !0, r = Us) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return Bs.call(t, (n) => r = r.getChildTrie(n)), Ws.call(r, "data") ? r.data : r.data = this.makeData(ii.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const o = r.mapFor(t[n], !1);
      r = o && o.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), o = i && i.get(n);
      o && (r = o.removeArray(ii.call(t, 1)), !o.data && !o.weak && !(o.strong && o.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new Ne(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && Js(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function Js(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var Gs = Oe(function() {
  return navigator.product;
}) == "ReactNative", nt = typeof WeakMap == "function" && !(Gs && !global.HermesInternal), Sn = typeof WeakSet == "function", Oo = typeof Symbol == "function" && typeof Symbol.for == "function", _r = Oo && Symbol.asyncIterator;
Oe(function() {
  return window.document.createElement;
});
Oe(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function W(e) {
  return e !== null && typeof e == "object";
}
function Ks(e, t) {
  var r = t, n = [];
  e.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw ve(
        112,
        o.operation,
        o.name ? " named '".concat(o.name.value, "'") : ""
      );
    o.kind === "FragmentDefinition" && n.push(o);
  }), typeof r > "u" && (D(n.length === 1, 113, n.length), r = n[0].name.value);
  var i = v(v({}, e), { definitions: se([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: r
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function Et(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function wr(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return D(n, 114, r), n || null;
    }
    default:
      return null;
  }
}
function Hs(e) {
  var t = !0;
  return Te(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return br;
    }
  }), t;
}
function Ys() {
}
class Hr {
  constructor(t = 1 / 0, r = Ys) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function Yr() {
}
const Xs = Yr, eu = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, tu = typeof WeakMap < "u" ? WeakMap : Map, ru = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: Yr,
    unregister: Yr
  };
}, nu = 10024;
class cr {
  constructor(t = 1 / 0, r = Xs) {
    this.max = t, this.dispose = r, this.map = new tu(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < nu; i++) {
        const o = n.next().value;
        if (!o)
          break;
        this.unfinalizedNodes.delete(o);
        const a = o.key;
        delete o.key, o.keyRef = new eu(a), this.registry.register(a, o, o);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new ru(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var Pr = /* @__PURE__ */ new WeakSet();
function To(e) {
  e.size <= (e.max || -1) || Pr.has(e) || (Pr.add(e), setTimeout(function() {
    e.clean(), Pr.delete(e);
  }, 100));
}
var Do = function(e, t) {
  var r = new cr(e, t);
  return r.set = function(n, i) {
    var o = cr.prototype.set.call(this, n, i);
    return To(this), o;
  }, r;
}, iu = function(e, t) {
  var r = new Hr(e, t);
  return r.set = function(n, i) {
    var o = Hr.prototype.set.call(this, n, i);
    return To(this), o;
  }, r;
}, ou = Symbol.for("apollo.cacheSize"), Fe = v({}, ur[ou]), Ke = {};
function Io(e, t) {
  Ke[e] = t;
}
var au = globalThis.__DEV__ !== !1 ? lu : void 0, su = globalThis.__DEV__ !== !1 ? fu : void 0, uu = globalThis.__DEV__ !== !1 ? zo : void 0;
function cu() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      Fe[r] || n
    ];
  }));
}
function lu() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: cu(),
    sizes: v({ print: (e = Ke.print) === null || e === void 0 ? void 0 : e.call(Ke), parser: (t = Ke.parser) === null || t === void 0 ? void 0 : t.call(Ke), canonicalStringify: (r = Ke.canonicalStringify) === null || r === void 0 ? void 0 : r.call(Ke), links: en(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: Po(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function zo() {
  return {
    cache: {
      fragmentQueryDocuments: je(this.getFragmentDoc)
    }
  };
}
function fu() {
  var e = this.config.fragments;
  return v(v({}, zo.apply(this)), { addTypenameDocumentTransform: Po(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: je(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: je(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: je(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: je(e == null ? void 0 : e.findFragmentSpreads),
    lookup: je(e == null ? void 0 : e.lookup),
    transform: je(e == null ? void 0 : e.transform)
  } });
}
function hu(e) {
  return !!e && "dirtyKey" in e;
}
function je(e) {
  return hu(e) ? e.size : void 0;
}
function Ro(e) {
  return e != null;
}
function Po(e) {
  return Xr(e).map(function(t) {
    return { cache: t };
  });
}
function Xr(e) {
  return e ? se(se([
    je(e == null ? void 0 : e.performWork)
  ], Xr(e == null ? void 0 : e.left), !0), Xr(e == null ? void 0 : e.right), !0).filter(Ro) : [];
}
function en(e) {
  var t;
  return e ? se(se([
    (t = e == null ? void 0 : e.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], en(e == null ? void 0 : e.left), !0), en(e == null ? void 0 : e.right), !0).filter(Ro) : [];
}
var Ve = Object.assign(function(t) {
  return JSON.stringify(t, du);
}, {
  reset: function() {
    ut = new iu(
      Fe.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && Io("canonicalStringify", function() {
  return ut.size;
});
var ut;
Ve.reset();
function du(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(pu))
        return t;
      var i = JSON.stringify(n), o = ut.get(i);
      if (!o) {
        n.sort();
        var a = JSON.stringify(n);
        o = ut.get(a) || n, ut.set(i, o), ut.set(a, o);
      }
      var s = Object.create(r);
      return o.forEach(function(u) {
        s[u] = t[u];
      }), s;
    }
  }
  return t;
}
function pu(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function dt(e) {
  return { __ref: String(e) };
}
function q(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function vu(e) {
  return W(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function mu(e) {
  return e.kind === "StringValue";
}
function yu(e) {
  return e.kind === "BooleanValue";
}
function gu(e) {
  return e.kind === "IntValue";
}
function bu(e) {
  return e.kind === "FloatValue";
}
function _u(e) {
  return e.kind === "Variable";
}
function wu(e) {
  return e.kind === "ObjectValue";
}
function Eu(e) {
  return e.kind === "ListValue";
}
function ku(e) {
  return e.kind === "EnumValue";
}
function Su(e) {
  return e.kind === "NullValue";
}
function gt(e, t, r, n) {
  if (gu(r) || bu(r))
    e[t.value] = Number(r.value);
  else if (yu(r) || mu(r))
    e[t.value] = r.value;
  else if (wu(r)) {
    var i = {};
    r.fields.map(function(a) {
      return gt(i, a.name, a.value, n);
    }), e[t.value] = i;
  } else if (_u(r)) {
    var o = (n || {})[r.name.value];
    e[t.value] = o;
  } else if (Eu(r))
    e[t.value] = r.values.map(function(a) {
      var s = {};
      return gt(s, t, a, n), s[t.value];
    });
  else if (ku(r))
    e[t.value] = r.value;
  else if (Su(r))
    e[t.value] = null;
  else
    throw ve(123, t.value, r.kind);
}
function Ou(e, t) {
  var r = null;
  e.directives && (r = {}, e.directives.forEach(function(i) {
    r[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return gt(r[i.name.value], a, s, t);
    });
  }));
  var n = null;
  return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return gt(n, o, a, t);
  })), Fo(e.name.value, n, r);
}
var Tu = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], zt = Ve, Fo = Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(zt(i), ")");
    } else
      return r.connection.key;
  var o = e;
  if (t) {
    var a = zt(t);
    o += "(".concat(a, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    Tu.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? o += "@".concat(s, "(").concat(zt(r[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(e) {
    var t = zt;
    return zt = e, t;
  }
});
function Er(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, o = n.value;
      return gt(r, i, o, t);
    }), r;
  }
  return null;
}
function Ce(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function tn(e, t, r) {
  for (var n, i = 0, o = t.selections; i < o.length; i++) {
    var a = o[i];
    if (qe(a)) {
      if (a.name.value === "__typename")
        return e[Ce(a)];
    } else n ? n.push(a) : n = [a];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (n)
    for (var s = 0, u = n; s < u.length; s++) {
      var a = u[s], c = tn(e, wr(a, r).selectionSet, r);
      if (typeof c == "string")
        return c;
    }
}
function qe(e) {
  return e.kind === "Field";
}
function Du(e) {
  return e.kind === "InlineFragment";
}
function kt(e) {
  D(e && e.kind === "Document", 115);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw ve(116, r.kind);
    return r;
  });
  return D(t.length <= 1, 117, t.length), e;
}
function et(e) {
  return kt(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function Nt(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function St(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function Co(e) {
  var t = et(e);
  return D(t && t.operation === "query", 118), t;
}
function No(e) {
  D(e.kind === "Document", 119), D(e.definitions.length <= 1, 120);
  var t = e.definitions[0];
  return D(t.kind === "FragmentDefinition", 121), t;
}
function Ot(e) {
  kt(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw ve(122);
}
function On(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && gt(t, n.variable.name, n.defaultValue);
  }), t;
}
let ae = null;
const oi = {};
let Iu = 1;
const zu = () => class {
  constructor() {
    this.id = [
      "slot",
      Iu++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let t = ae; t; t = t.parent)
      if (this.id in t.slots) {
        const r = t.slots[this.id];
        if (r === oi)
          break;
        return t !== ae && (ae.slots[this.id] = r), !0;
      }
    return ae && (ae.slots[this.id] = oi), !1;
  }
  getValue() {
    if (this.hasValue())
      return ae.slots[this.id];
  }
  withValue(t, r, n, i) {
    const o = {
      __proto__: null,
      [this.id]: t
    }, a = ae;
    ae = { parent: a, slots: o };
    try {
      return r.apply(i, n);
    } finally {
      ae = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(t) {
    const r = ae;
    return function() {
      const n = ae;
      try {
        return ae = r, t.apply(this, arguments);
      } finally {
        ae = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(t, r, n) {
    if (ae) {
      const i = ae;
      try {
        return ae = null, t.apply(n, r);
      } finally {
        ae = i;
      }
    } else
      return t.apply(n, r);
  }
};
function ai(e) {
  try {
    return e();
  } catch {
  }
}
const Fr = "@wry/context:Slot", Ru = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  ai(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  ai(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), si = Ru, Tt = si[Fr] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Fr] || (function(e) {
  try {
    Object.defineProperty(si, Fr, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(zu()), { bind: wm, noContext: Em } = Tt, kr = new Tt(), { hasOwnProperty: Pu } = Object.prototype, Tn = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function Dn(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const qt = [], Fu = 100;
function bt(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function Ao(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function xo(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function Mo(e) {
  return e.slice(0);
}
class Sr {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Sr.count;
  }
  peek() {
    if (this.value.length === 1 && !Ze(this))
      return ui(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return bt(!this.recomputing, "already recomputing"), ui(this), Ze(this) ? Cu(this, t) : xo(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, jo(this), Dn(this));
  }
  dispose() {
    this.setDirty(), Zo(this), In(this, (t, r) => {
      t.setDirty(), Qo(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = qt.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (Tn(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), qt.push(this.deps), this.deps = null);
  }
}
Sr.count = 0;
function ui(e) {
  const t = kr.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Ze(e) ? Lo(t, e) : Vo(t, e), t;
}
function Cu(e, t) {
  return Zo(e), kr.withValue(e, Nu, [e, t]), xu(e, t) && Au(e), xo(e.value);
}
function Nu(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = Mo(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !Ao(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Ze(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function Au(e) {
  e.dirty = !1, !Ze(e) && $o(e);
}
function jo(e) {
  In(e, Lo);
}
function $o(e) {
  In(e, Vo);
}
function In(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = Tn(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function Lo(e, t) {
  bt(e.childValues.has(t)), bt(Ze(t));
  const r = !Ze(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = qt.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && jo(e);
}
function Vo(e, t) {
  bt(e.childValues.has(t)), bt(!Ze(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, Mo(t.value)) : Ao(r, t.value) || e.setDirty(), qo(e, t), !Ze(e) && $o(e);
}
function qo(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (qt.length < Fu && qt.push(r), e.dirtyChildren = null));
}
function Zo(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    Qo(e, r);
  }), e.forgetDeps(), bt(e.dirtyChildren === null);
}
function Qo(e, t) {
  t.parents.delete(e), e.childValues.delete(t), qo(e, t);
}
function xu(e, t) {
  if (typeof e.subscribe == "function")
    try {
      Dn(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const Mu = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function Uo(e) {
  const t = /* @__PURE__ */ new Map();
  function r(n) {
    const i = kr.getValue();
    if (i) {
      let o = t.get(n);
      o || t.set(n, o = /* @__PURE__ */ new Set()), i.dependOn(o);
    }
  }
  return r.dirty = function(i, o) {
    const a = t.get(i);
    if (a) {
      const s = o && Pu.call(Mu, o) ? o : "setDirty";
      Tn(a).forEach((u) => u[s]()), t.delete(i), Dn(a);
    }
  }, r;
}
let ci;
function ju(...e) {
  return (ci || (ci = new Ne(typeof WeakMap == "function"))).lookupArray(e);
}
const Cr = /* @__PURE__ */ new Set();
function Zt(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = ju, normalizeResult: i, subscribe: o, cache: a = Hr } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof a == "function" ? new a(t, (d) => d.dispose()) : a, u = function() {
    const d = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (d === void 0)
      return e.apply(null, arguments);
    let f = s.get(d);
    f || (s.set(d, f = new Sr(e)), f.normalizeResult = i, f.subscribe = o, f.forget = () => s.delete(d));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return s.set(d, f), Cr.add(s), kr.hasValue() || (Cr.forEach((m) => m.clean()), Cr.clear()), p;
  };
  Object.defineProperty(u, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(u.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: o,
    cache: s
  });
  function c(d) {
    const f = d && s.get(d);
    f && f.setDirty();
  }
  u.dirtyKey = c, u.dirty = function() {
    c(n.apply(null, arguments));
  };
  function l(d) {
    const f = d && s.get(d);
    if (f)
      return f.peek();
  }
  u.peekKey = l, u.peek = function() {
    return l(n.apply(null, arguments));
  };
  function h(d) {
    return d ? s.delete(d) : !1;
  }
  return u.forgetKey = h, u.forget = function() {
    return h(n.apply(null, arguments));
  }, u.makeCacheKey = n, u.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(u);
}
function $u(e) {
  return e;
}
var Bo = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = Sn ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e($u, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var o = t(i) ? r : n;
          return o.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new Ne(nt);
        this.performWork = Zt(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return D(Array.isArray(i), 104), r.lookupArray(i);
          },
          max: Fe["documentTransform.cache"],
          cache: cr
        });
      }
    }, e.prototype.performWork = function(t) {
      return kt(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), Mt, Le = Object.assign(function(e) {
  var t = Mt.get(e);
  return t || (t = Ms(e), Mt.set(e, t)), t;
}, {
  reset: function() {
    Mt = new Do(
      Fe.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Le.reset();
globalThis.__DEV__ !== !1 && Io("print", function() {
  return Mt ? Mt.size : 0;
});
var X = Array.isArray;
function Ie(e) {
  return Array.isArray(e) && e.length > 0;
}
var li = {
  kind: K.FIELD,
  name: {
    kind: K.NAME,
    value: "__typename"
  }
};
function Wo(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === K.FRAGMENT_SPREAD && Wo(t[r.name.value], t);
  });
}
function Lu(e) {
  return Wo(et(e) || No(e), Et(St(e))) ? null : e;
}
function Vu(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(o, a) {
      a(n) && (i = o);
    }), i;
  };
}
function fi(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var i = t.get(n);
    return i || t.set(n, i = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function Jo(e, t) {
  kt(t);
  for (var r = fi(""), n = fi(""), i = function(y) {
    for (var b = 0, w = void 0; b < y.length && (w = y[b]); ++b)
      if (!X(w)) {
        if (w.kind === K.OPERATION_DEFINITION)
          return r(w.name && w.name.value);
        if (w.kind === K.FRAGMENT_DEFINITION)
          return n(w.name.value);
      }
    return globalThis.__DEV__ !== !1 && D.error(124), null;
  }, o = 0, a = t.definitions.length - 1; a >= 0; --a)
    t.definitions[a].kind === K.OPERATION_DEFINITION && ++o;
  var s = Vu(e), u = function(y) {
    return Ie(y) && y.map(s).some(function(b) {
      return b && b.remove;
    });
  }, c = /* @__PURE__ */ new Map(), l = !1, h = {
    enter: function(y) {
      if (u(y.directives))
        return l = !0, null;
    }
  }, d = Te(t, {
    // These two AST node types share the same implementation, defined above.
    Field: h,
    InlineFragment: h,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(y, b, w, k, S) {
        var T = i(S);
        T && T.variables.add(y.name.value);
      }
    },
    FragmentSpread: {
      enter: function(y, b, w, k, S) {
        if (u(y.directives))
          return l = !0, null;
        var T = i(S);
        T && T.fragmentSpreads.add(y.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(y, b, w, k) {
        c.set(JSON.stringify(k), y);
      },
      leave: function(y, b, w, k) {
        var S = c.get(JSON.stringify(k));
        if (y === S)
          return y;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          o > 0 && y.selectionSet.selections.every(function(T) {
            return T.kind === K.FIELD && T.name.value === "__typename";
          })
        )
          return n(y.name.value).removed = !0, l = !0, null;
      }
    },
    Directive: {
      leave: function(y) {
        if (s(y))
          return l = !0, null;
      }
    }
  });
  if (!l)
    return t;
  var f = function(y) {
    return y.transitiveVars || (y.transitiveVars = new Set(y.variables), y.removed || y.fragmentSpreads.forEach(function(b) {
      f(n(b)).transitiveVars.forEach(function(w) {
        y.transitiveVars.add(w);
      });
    })), y;
  }, p = /* @__PURE__ */ new Set();
  d.definitions.forEach(function(y) {
    y.kind === K.OPERATION_DEFINITION ? f(r(y.name && y.name.value)).fragmentSpreads.forEach(function(b) {
      p.add(b);
    }) : y.kind === K.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    o === 0 && !n(y.name.value).removed && p.add(y.name.value);
  }), p.forEach(function(y) {
    f(n(y)).fragmentSpreads.forEach(function(b) {
      p.add(b);
    });
  });
  var m = function(y) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(y) || n(y).removed);
  }, g = {
    enter: function(y) {
      if (m(y.name.value))
        return null;
    }
  };
  return Lu(Te(d, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: g,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: g,
    OperationDefinition: {
      leave: function(y) {
        if (y.variableDefinitions) {
          var b = f(
            // If an operation is anonymous, we use the empty string as its key.
            r(y.name && y.name.value)
          ).transitiveVars;
          if (b.size < y.variableDefinitions.length)
            return v(v({}, y), { variableDefinitions: y.variableDefinitions.filter(function(w) {
              return b.has(w.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var zn = Object.assign(function(e) {
  return Te(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === K.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var o = i.some(function(s) {
              return qe(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = n;
              if (!(qe(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return v(v({}, t), { selections: se(se([], i, !0), [li], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === li;
  }
});
function qu(e) {
  var t = Ot(e), r = t.operation;
  if (r === "query")
    return e;
  var n = Te(e, {
    OperationDefinition: {
      enter: function(i) {
        return v(v({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function Go(e) {
  kt(e);
  var t = Jo([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function Zu(e) {
  return kt(e), Te(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return v(v({}, t), { directives: se(se([], t.directives || [], !0), [
          {
            kind: K.DIRECTIVE,
            name: { kind: K.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var Qu = Object.prototype.hasOwnProperty;
function hi() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Or(e);
}
function Or(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new Qe(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var Uu = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, Qe = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = Uu), this.reconciler = t, this.isObject = W, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], o = 2; o < arguments.length; o++)
        i[o - 2] = arguments[o];
      return W(r) && W(t) ? (Object.keys(r).forEach(function(a) {
        if (Qu.call(t, a)) {
          var s = t[a];
          if (r[a] !== s) {
            var u = n.reconciler.apply(n, se([
              t,
              r,
              a
            ], i, !1));
            u !== s && (t = n.shallowCopyForMerge(t), t[a] = u);
          }
        } else
          t = n.shallowCopyForMerge(t), t[a] = r[a];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return W(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = v({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function Bu(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Wu(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wu(e, t) {
  if (e) {
    if (typeof e == "string") return di(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return di(e, t);
  }
}
function di(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function pi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Rn(e, t, r) {
  return t && pi(e.prototype, t), r && pi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Pn = function() {
  return typeof Symbol == "function";
}, Fn = function(e) {
  return Pn() && !!Symbol[e];
}, Cn = function(e) {
  return Fn(e) ? Symbol[e] : "@@" + e;
};
Pn() && !Fn("observable") && (Symbol.observable = Symbol("observable"));
var Ju = Cn("iterator"), rn = Cn("observable"), Ko = Cn("species");
function lr(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function Rt(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[Ko], t === null && (t = void 0)), t !== void 0 ? t : Q;
}
function Gu(e) {
  return e instanceof Q;
}
function _t(e) {
  _t.log ? _t.log(e) : setTimeout(function() {
    throw e;
  });
}
function nr(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      _t(t);
    }
  });
}
function Ho(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = lr(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      _t(n);
    }
}
function nn(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function Ku(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (Yo(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function Yo(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = lr(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (nn(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        nn(e), i && i.call(n);
        break;
    }
  } catch (o) {
    _t(o);
  }
  e._state === "closed" ? Ho(e) : e._state === "running" && (e._state = "ready");
}
function Nr(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], nr(function() {
        return Ku(e);
      });
      return;
    }
    Yo(e, t, r);
  }
}
var Hu = /* @__PURE__ */ (function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new Yu(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (nn(this), Ho(this));
  }, Rn(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), Yu = /* @__PURE__ */ (function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(n) {
    Nr(this._subscription, "next", n);
  }, t.error = function(n) {
    Nr(this._subscription, "error", n);
  }, t.complete = function() {
    Nr(this._subscription, "complete");
  }, Rn(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), Q = /* @__PURE__ */ (function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new Hu(n, this._subscriber);
  }, t.forEach = function(n) {
    var i = this;
    return new Promise(function(o, a) {
      if (typeof n != "function") {
        a(new TypeError(n + " is not a function"));
        return;
      }
      function s() {
        u.unsubscribe(), o();
      }
      var u = i.subscribe({
        next: function(c) {
          try {
            n(c, s);
          } catch (l) {
            a(l), u.unsubscribe();
          }
        },
        error: a,
        complete: o
      });
    });
  }, t.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Rt(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            s = n(s);
          } catch (u) {
            return a.error(u);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Rt(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            if (!n(s)) return;
          } catch (u) {
            return a.error(u);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Rt(this), a = arguments.length > 1, s = !1, u = arguments[1], c = u;
    return new o(function(l) {
      return i.subscribe({
        next: function(h) {
          var d = !s;
          if (s = !0, !d || a)
            try {
              c = n(c, h);
            } catch (f) {
              return l.error(f);
            }
          else
            c = h;
        },
        error: function(h) {
          l.error(h);
        },
        complete: function() {
          if (!s && !a) return l.error(new TypeError("Cannot reduce an empty sequence"));
          l.next(c), l.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    var s = Rt(this);
    return new s(function(u) {
      var c, l = 0;
      function h(d) {
        c = d.subscribe({
          next: function(f) {
            u.next(f);
          },
          error: function(f) {
            u.error(f);
          },
          complete: function() {
            l === o.length ? (c = void 0, u.complete()) : h(s.from(o[l++]));
          }
        });
      }
      return h(n), function() {
        c && (c.unsubscribe(), c = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Rt(this);
    return new o(function(a) {
      var s = [], u = i.subscribe({
        next: function(l) {
          if (n)
            try {
              l = n(l);
            } catch (d) {
              return a.error(d);
            }
          var h = o.from(l).subscribe({
            next: function(d) {
              a.next(d);
            },
            error: function(d) {
              a.error(d);
            },
            complete: function() {
              var d = s.indexOf(h);
              d >= 0 && s.splice(d, 1), c();
            }
          });
          s.push(h);
        },
        error: function(l) {
          a.error(l);
        },
        complete: function() {
          c();
        }
      });
      function c() {
        u.closed && s.length === 0 && a.complete();
      }
      return function() {
        s.forEach(function(l) {
          return l.unsubscribe();
        }), u.unsubscribe();
      };
    });
  }, t[rn] = function() {
    return this;
  }, e.from = function(n) {
    var i = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var o = lr(n, rn);
    if (o) {
      var a = o.call(n);
      if (Object(a) !== a) throw new TypeError(a + " is not an object");
      return Gu(a) && a.constructor === i ? a : new i(function(s) {
        return a.subscribe(s);
      });
    }
    if (Fn("iterator") && (o = lr(n, Ju), o))
      return new i(function(s) {
        nr(function() {
          if (!s.closed) {
            for (var u = Bu(o.call(n)), c; !(c = u()).done; ) {
              var l = c.value;
              if (s.next(l), s.closed) return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(s) {
        nr(function() {
          if (!s.closed) {
            for (var u = 0; u < n.length; ++u)
              if (s.next(n[u]), s.closed) return;
            s.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    var a = typeof this == "function" ? this : e;
    return new a(function(s) {
      nr(function() {
        if (!s.closed) {
          for (var u = 0; u < i.length; ++u)
            if (s.next(i[u]), s.closed) return;
          s.complete();
        }
      });
    });
  }, Rn(e, null, [{
    key: Ko,
    get: function() {
      return this;
    }
  }]), e;
})();
Pn() && Object.defineProperty(Q, Symbol("extensions"), {
  value: {
    symbol: rn,
    hostReportError: _t
  },
  configurable: !0
});
function Xu(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var at;
typeof self < "u" ? at = self : typeof window < "u" ? at = window : typeof global < "u" ? at = global : typeof module < "u" ? at = module : at = Function("return this")();
Xu(at);
var vi = Q.prototype, mi = "@@observable";
vi[mi] || (vi[mi] = function() {
  return this;
});
function ec(e) {
  return e.catch(function() {
  }), e;
}
var tc = Object.prototype.toString;
function Xo(e) {
  return on(e);
}
function on(e, t) {
  switch (tc.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, o) {
        r[o] = on(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = on(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function rc(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    W(r) && nc(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      W(r[n]) && t.add(r[n]);
    });
  }), e;
}
function nc(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function fr(e) {
  return globalThis.__DEV__ !== !1 && rc(e), e;
}
function jt(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function Ar(e, t, r) {
  return new Q(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(u) {
        return new Promise(function(c) {
          return c(u());
        });
      }
    };
    function o(u, c) {
      return function(l) {
        if (u) {
          var h = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : u(l);
          };
          i = i.then(h, h).then(function(d) {
            return n.next(d);
          }, function(d) {
            return n.error(d);
          });
        } else
          n[c](l);
      };
    }
    var a = {
      next: o(t, "next"),
      error: o(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(a);
    return function() {
      return s.unsubscribe();
    };
  });
}
function ea(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Q });
  }
  return Oo && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function yi(e) {
  return e && typeof e.then == "function";
}
var st = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, o) {
        n.resolve = i, n.reject = o;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), jt(n.observers, "next", i));
        },
        error: function(i) {
          var o = n.sub;
          o !== null && (o && setTimeout(function() {
            return o.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), jt(n.observers, "error", i));
        },
        complete: function() {
          var i = n, o = i.sub, a = i.sources, s = a === void 0 ? [] : a;
          if (o !== null) {
            var u = s.shift();
            u ? yi(u) ? u.then(function(c) {
              return n.sub = c.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = u.subscribe(n.handlers) : (o && setTimeout(function() {
              return o.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), jt(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new Q(r)]), yi(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
        return o(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, o) {
        n || (n = !0, r(i, o));
      });
    }, t;
  })(Q)
);
ea(st);
function pt(e) {
  return "incremental" in e;
}
function ic(e) {
  return "hasNext" in e && "data" in e;
}
function oc(e) {
  return pt(e) || ic(e);
}
function ac(e) {
  return W(e) && "payload" in e;
}
function ta(e, t) {
  var r = e, n = new Qe();
  return pt(t) && Ie(t.incremental) && t.incremental.forEach(function(i) {
    for (var o = i.data, a = i.path, s = a.length - 1; s >= 0; --s) {
      var u = a[s], c = !isNaN(+u), l = c ? [] : {};
      l[u] = o, o = l;
    }
    r = n.merge(r, o);
  }), r;
}
function ir(e) {
  var t = an(e);
  return Ie(t);
}
function an(e) {
  var t = Ie(e.errors) ? e.errors.slice(0) : [];
  return pt(e) && Ie(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function wt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var o = n[i];
      o !== void 0 && (r[i] = o);
    });
  }), r;
}
function xr(e, t) {
  return wt(e, t, t.variables && {
    variables: wt(v(v({}, e && e.variables), t.variables))
  });
}
var Mr, sc = Symbol.for("apollo.deprecations"), gi = Symbol.for("apollo.deprecations.slot"), sn = ur, un = (Mr = sn[gi]) !== null && Mr !== void 0 ? Mr : sn[gi] = new Tt();
function uc(e) {
  return sn[sc] || (un.getValue() || []).includes(e);
}
function fe(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return un.withValue.apply(un, se([Array.isArray(e) ? e : [e]], t, !1));
}
function ee(e, t, r, n) {
  n === void 0 && (n = "Please remove this option."), Xe(t, function() {
    t in e && globalThis.__DEV__ !== !1 && D.warn(103, r, t, n);
  });
}
function Xe(e, t) {
  uc(e) || t();
}
function jr(e) {
  return new Q(function(t) {
    t.error(e);
  });
}
var ra = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function cc(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw ve(58, i);
  }
  return e;
}
function lc(e, t) {
  var r = v({}, e), n = function(o) {
    typeof o == "function" ? r = v(v({}, r), o(r)) : r = v(v({}, r), o);
  }, i = function() {
    return v({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function fc(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? Nt(t.query) || void 0 : ""), t;
}
function hc(e, t) {
  var r = v({}, e), n = new Set(Object.keys(e));
  return Te(t, {
    Variable: function(i, o, a) {
      a && a.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
function bi(e, t) {
  return t ? t(e) : Q.of();
}
function Pt(e) {
  return typeof e == "function" ? new Be(e) : e;
}
function Ht(e) {
  return e.request.length <= 1;
}
var Be = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Q.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(Pt).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = Pt(r), o = Pt(n || new e(bi)), a;
      return Ht(i) && Ht(o) ? a = new e(function(s) {
        return t(s) ? i.request(s) || Q.of() : o.request(s) || Q.of();
      }) : a = new e(function(s, u) {
        return t(s) ? i.request(s, u) || Q.of() : o.request(s, u) || Q.of();
      }), Object.assign(a, { left: i, right: o });
    }, e.execute = function(t, r) {
      return t.request(lc(r.context, fc(cc(r)))) || Q.of();
    }, e.concat = function(t, r) {
      var n = Pt(t);
      if (Ht(n))
        return globalThis.__DEV__ !== !1 && D.warn(47, n), n;
      var i = Pt(r), o;
      return Ht(i) ? o = new e(function(a) {
        return n.request(a, function(s) {
          return i.request(s) || Q.of();
        }) || Q.of();
      }) : o = new e(function(a, s) {
        return n.request(a, function(u) {
          return i.request(u, s) || Q.of();
        }) || Q.of();
      }), Object.assign(o, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(bi)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw ve(48);
    }, e.prototype.onError = function(t, r) {
      if (globalThis.__DEV__ !== !1 && Xe("onError", function() {
        globalThis.__DEV__ !== !1 && D.warn(49);
      }), r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && D.warn(50), this.onError = t, this;
    }, e;
  })()
), dc = Be.from, pc = Be.split, cn = Be.execute;
function vc(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function mc(e) {
  var t = null, r = null, n = !1, i = [], o = [];
  function a(h) {
    if (!r) {
      if (o.length) {
        var d = o.shift();
        if (Array.isArray(d) && d[0])
          return d[0]({ value: h, done: !1 });
      }
      i.push(h);
    }
  }
  function s(h) {
    r = h;
    var d = o.slice();
    d.forEach(function(f) {
      f[1](h);
    }), !t || t();
  }
  function u() {
    n = !0;
    var h = o.slice();
    h.forEach(function(d) {
      d[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", a), e.removeListener("error", s), e.removeListener("end", u), e.removeListener("finish", u), e.removeListener("close", u);
  }, e.on("data", a), e.on("error", s), e.on("end", u), e.on("finish", u), e.on("close", u);
  function c() {
    return new Promise(function(h, d) {
      if (r)
        return d(r);
      if (i.length)
        return h({ value: i.shift(), done: !1 });
      if (n)
        return h({ value: void 0, done: !0 });
      o.push([h, d]);
    });
  }
  var l = {
    next: function() {
      return c();
    }
  };
  return _r && (l[Symbol.asyncIterator] = function() {
    return this;
  }), l;
}
function yc(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(o) {
          n({ value: o, done: !1 });
        }).catch(i);
      }));
    }
  };
  return _r && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function _i(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return _r && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function gc(e) {
  return !!e.body;
}
function bc(e) {
  return !!e.getReader;
}
function _c(e) {
  return !!(_r && e[Symbol.asyncIterator]);
}
function wc(e) {
  return !!e.stream;
}
function Ec(e) {
  return !!e.arrayBuffer;
}
function kc(e) {
  return !!e.pipe;
}
function Sc(e) {
  var t = e;
  if (gc(e) && (t = e.body), _c(t))
    return vc(t);
  if (bc(t))
    return _i(t.getReader());
  if (wc(t))
    return _i(t.stream().getReader());
  if (Ec(t))
    return yc(t.arrayBuffer());
  if (kc(t))
    return mc(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Nn = Symbol();
function Oc(e) {
  return e.extensions ? Array.isArray(e.extensions[Nn]) : !1;
}
function na(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var Tc = function(e) {
  var t = se(se(se([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return W(r) && r.message || "Error message not found.";
  }).join(`
`);
}, $e = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, o = r.clientErrors, a = r.networkError, s = r.errorMessage, u = r.extraInfo, c = e.call(this, s) || this;
      return c.name = "ApolloError", c.graphQLErrors = n || [], c.protocolErrors = i || [], c.clientErrors = o || [], c.networkError = a || null, c.message = s || Tc(c), c.extraInfo = u, c.cause = se(se(se([
        a
      ], n || [], !0), i || [], !0), o || [], !0).find(function(l) {
        return !!l;
      }) || null, c.__proto__ = t.prototype, c;
    }
    return t;
  })(Error)
), wi = Object.prototype.hasOwnProperty;
function Dc(e, t) {
  return xe(this, void 0, void 0, function() {
    var r, n, i, o, a, s, u, c, l, h, d, f, p, m, g, y, b, w, k, S, T, P, R, x;
    return Me(this, function(L) {
      switch (L.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (x = e.headers) === null || x === void 0 ? void 0 : x.get("content-type"), i = "boundary=", o = n != null && n.includes(i) ? n == null ? void 0 : n.substring((n == null ? void 0 : n.indexOf(i)) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", a = `\r
--`.concat(o), s = "", u = Sc(e), c = !0, L.label = 1;
        case 1:
          return c ? [4, u.next()] : [3, 3];
        case 2:
          for (l = L.sent(), h = l.value, d = l.done, f = typeof h == "string" ? h : r.decode(h), p = s.length - a.length + 1, c = !d, s += f, m = s.indexOf(a, p); m > -1; ) {
            if (g = void 0, P = [
              s.slice(0, m),
              s.slice(m + a.length)
            ], g = P[0], s = P[1], y = g.indexOf(`\r
\r
`), b = Ic(g.slice(0, y)), w = b["content-type"], w && w.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (k = g.slice(y), k) {
              if (S = ia(e, k), Object.keys(S).length > 1 || "data" in S || "incremental" in S || "errors" in S || "payload" in S)
                if (ac(S)) {
                  if (T = {}, "payload" in S) {
                    if (Object.keys(S).length === 1 && S.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    T = v({}, S.payload);
                  }
                  "errors" in S && (T = v(v({}, T), { extensions: v(v({}, "extensions" in T ? T.extensions : null), (R = {}, R[Nn] = S.errors, R)) })), t(T);
                } else
                  t(S);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(S).length === 1 && "hasNext" in S && !S.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            m = s.indexOf(a);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Ic(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), o = r.slice(n + 1).trim();
      t[i] = o;
    }
  }), t;
}
function ia(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    ra(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function zc(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function Rc(e) {
  return function(t) {
    return t.text().then(function(r) {
      return ia(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !wi.call(r, "data") && !wi.call(r, "errors") && ra(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var ln = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = ve(54, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, Pc = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, Fc = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, Cc = {
  method: "POST"
}, Nc = {
  http: Pc,
  headers: Fc,
  options: Cc
}, Ac = function(e, t) {
  return t(e);
};
function xc(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, o = {};
  r.forEach(function(h) {
    i = v(v(v({}, i), h.options), { headers: v(v({}, i.headers), h.headers) }), h.credentials && (i.credentials = h.credentials), o = v(v({}, o), h.http);
  }), i.headers && (i.headers = Mc(i.headers, o.preserveHeaderCase));
  var a = e.operationName, s = e.extensions, u = e.variables, c = e.query, l = { operationName: a, variables: u };
  return o.includeExtensions && (l.extensions = s), o.includeQuery && (l.query = t(c, Le)), {
    options: i,
    body: l
  };
}
function Mc(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(o) {
      r[o.toLowerCase()] = e[o];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(o) {
    n[o.toLowerCase()] = {
      originalName: o,
      value: e[o]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(o) {
    i[n[o].originalName] = n[o].value;
  }), i;
}
var jc = function(e) {
  if (!e && typeof fetch > "u")
    throw ve(51);
}, $c = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function Lc(e, t) {
  var r = [], n = function(h, d) {
    r.push("".concat(h, "=").concat(encodeURIComponent(d)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = ln(t.variables, "Variables map");
    } catch (h) {
      return { parseError: h };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var o = void 0;
    try {
      o = ln(t.extensions, "Extensions map");
    } catch (h) {
      return { parseError: h };
    }
    n("extensions", o);
  }
  var a = "", s = e, u = e.indexOf("#");
  u !== -1 && (a = e.substr(u), s = e.substr(0, u));
  var c = s.indexOf("?") === -1 ? "?" : "&", l = s + c + r.join("&") + a;
  return { newURI: l };
}
var Ei = Oe(function() {
  return fetch;
}), Vc = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, o = i === void 0 ? Ac : i, a = e.includeExtensions, s = e.preserveHeaderCase, u = e.useGETForQueries, c = e.includeUnusedVariables, l = c === void 0 ? !1 : c, h = Pe(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && jc(n || Ei);
  var d = {
    http: { includeExtensions: a, preserveHeaderCase: s },
    options: h.fetchOptions,
    credentials: h.credentials,
    headers: h.headers
  };
  return new Be(function(f) {
    var p = $c(f, r), m = f.getContext(), g = {};
    if (m.clientAwareness) {
      var y = m.clientAwareness, b = y.name, w = y.version;
      b && (g["apollographql-client-name"] = b), w && (g["apollographql-client-version"] = w);
    }
    var k = v(v({}, g), m.headers), S = {
      http: m.http,
      options: m.fetchOptions,
      credentials: m.credentials,
      headers: k
    };
    if (Vt(["client"], f.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && D.warn(52);
      var T = Go(f.query);
      if (!T)
        return jr(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = T;
    }
    var P = xc(f, o, Nc, d, S), R = P.options, x = P.body;
    x.variables && !l && (x.variables = hc(x.variables, f.query));
    var L;
    !R.signal && typeof AbortController < "u" && (L = new AbortController(), R.signal = L.signal);
    var Ee = function(A) {
      return A.kind === "OperationDefinition" && A.operation === "mutation";
    }, me = function(A) {
      return A.kind === "OperationDefinition" && A.operation === "subscription";
    }, Y = me(Ot(f.query)), he = Vt(["defer"], f.query);
    if (u && !f.query.definitions.some(Ee) && (R.method = "GET"), he || Y) {
      R.headers = R.headers || {};
      var N = "multipart/mixed;";
      Y && he && globalThis.__DEV__ !== !1 && D.warn(53), Y ? N += "boundary=graphql;subscriptionSpec=1.0,application/json" : he && (N += "deferSpec=20220824,application/json"), R.headers.accept = N;
    }
    if (R.method === "GET") {
      var U = Lc(p, x), C = U.newURI, M = U.parseError;
      if (M)
        return jr(M);
      p = C;
    } else
      try {
        R.body = ln(x, "Payload");
      } catch (A) {
        return jr(A);
      }
    return new Q(function(A) {
      var ce = n || Oe(function() {
        return fetch;
      }) || Ei, $ = A.next.bind(A);
      return ce(p, R).then(function(de) {
        var Re;
        f.setContext({ response: de });
        var Ge = (Re = de.headers) === null || Re === void 0 ? void 0 : Re.get("content-type");
        return Ge !== null && /^multipart\/mixed/i.test(Ge) ? Dc(de, $) : Rc(f)(de).then($);
      }).then(function() {
        L = void 0, A.complete();
      }).catch(function(de) {
        L = void 0, zc(de, A);
      }), function() {
        L && L.abort();
      };
    });
  });
}, oa = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, Vc(r).request) || this;
      return n.options = r, n;
    }
    return t;
  })(Be)
);
const { toString: ki, hasOwnProperty: qc } = Object.prototype, Si = Function.prototype.toString, fn = /* @__PURE__ */ new Map();
function B(e, t) {
  try {
    return hn(e, t);
  } finally {
    fn.clear();
  }
}
function hn(e, t) {
  if (e === t)
    return !0;
  const r = ki.call(e), n = ki.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (Ti(e, t))
        return !0;
      const i = Oi(e), o = Oi(t), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!qc.call(t, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const u = i[s];
        if (!hn(e[u], t[u]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (Ti(e, t))
        return !0;
      const i = e.entries(), o = r === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, u] = a.value;
        if (!t.has(s) || o && !hn(u, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = Si.call(e);
      return i !== Si.call(t) ? !1 : !Uc(i, Qc);
    }
  }
  return !1;
}
function Oi(e) {
  return Object.keys(e).filter(Zc, e);
}
function Zc(e) {
  return this[e] !== void 0;
}
const Qc = "{ [native code] }";
function Uc(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function Ti(e, t) {
  let r = fn.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    fn.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function aa(e, t, r, n) {
  var i = t.data, o = Pe(t, ["data"]), a = r.data, s = Pe(r, ["data"]);
  return B(o, s) && or(Ot(e).selectionSet, i, a, {
    fragmentMap: Et(St(e)),
    variables: n
  });
}
function or(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(o) {
    if (i.has(o) || (i.add(o), !Wt(o, n.variables)) || Di(o))
      return !0;
    if (qe(o)) {
      var a = Ce(o), s = t && t[a], u = r && r[a], c = o.selectionSet;
      if (!c)
        return B(s, u);
      var l = Array.isArray(s), h = Array.isArray(u);
      if (l !== h)
        return !1;
      if (l && h) {
        var d = s.length;
        if (u.length !== d)
          return !1;
        for (var f = 0; f < d; ++f)
          if (!or(c, s[f], u[f], n))
            return !1;
        return !0;
      }
      return or(c, s, u, n);
    } else {
      var p = wr(o, n.fragmentMap);
      if (p)
        return Di(p) ? !0 : or(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function Di(e) {
  return !!e.directives && e.directives.some(Bc);
}
function Bc(e) {
  return e.name.value === "nonreactive";
}
var sa = nt ? WeakMap : Map, ua = Sn ? WeakSet : Set, An = new Tt(), Ii = !1;
function ca() {
  Ii || (Ii = !0, globalThis.__DEV__ !== !1 && D.warn(64));
}
function la(e, t, r) {
  return An.withValue(!0, function() {
    var n = At(e, t, r, !1);
    return Object.isFrozen(e) && fr(n), n;
  });
}
function Wc(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function At(e, t, r, n, i) {
  var o, a = r.knownChanged, s = Wc(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var u = 0, c = Array.from(e.entries()); u < c.length; u++) {
      var l = c[u], h = l[0], d = l[1];
      if (d === null) {
        s[h] = null;
        continue;
      }
      var f = At(d, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(h, "]") : void 0);
      a.has(f) && a.add(s), s[h] = f;
    }
    return a.has(s) ? s : e;
  }
  for (var p = 0, m = t.selections; p < m.length; p++) {
    var g = m[p], y = void 0;
    if (n && a.add(s), g.kind === K.FIELD) {
      var b = Ce(g), w = g.selectionSet;
      if (y = s[b] || e[b], y === void 0)
        continue;
      if (w && y !== null) {
        var f = At(e[b], w, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(b) : void 0);
        a.has(f) && (y = f);
      }
      globalThis.__DEV__ === !1 && (s[b] = y), globalThis.__DEV__ !== !1 && (n && b !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((o = Object.getOwnPropertyDescriptor(s, b)) === null || o === void 0) && o.value) ? Object.defineProperty(s, b, Jc(b, y, i || "", r.operationName, r.operationType)) : (delete s[b], s[b] = y));
    }
    if (g.kind === K.INLINE_FRAGMENT && (!g.typeCondition || r.cache.fragmentMatches(g, e.__typename)) && (y = At(e, g.selectionSet, r, n, i)), g.kind === K.FRAGMENT_SPREAD) {
      var k = g.name.value, S = r.fragmentMap[k] || (r.fragmentMap[k] = r.cache.lookupFragment(k));
      D(S, 59, k);
      var T = Qs(g);
      T !== "mask" && (y = At(e, S.selectionSet, r, T === "migrate", i));
    }
    a.has(y) && a.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && a.add(s), a.has(s) ? s : e;
}
function Jc(e, t, r, n, i) {
  var o = function() {
    return An.getValue() || (globalThis.__DEV__ !== !1 && D.warn(60, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), o = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return o();
    },
    set: function(a) {
      o = function() {
        return a;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function fa(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && ca(), e;
  var i = t.definitions.filter(function(a) {
    return a.kind === K.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (D(i.length === 1, 61, i.length), n = i[0].name.value);
  var o = i.find(function(a) {
    return a.name.value === n;
  });
  return D(!!o, 62, n), e == null || B(e, {}) ? e : la(e, o.selectionSet, {
    operationType: "fragment",
    operationName: o.name.value,
    fragmentMap: Et(St(t)),
    cache: r,
    mutableTargets: new sa(),
    knownChanged: new ua()
  });
}
function Gc(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && ca(), e;
  var i = et(t);
  return D(i, 63), e == null ? e : la(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: Et(St(t)),
    cache: r,
    mutableTargets: new sa(),
    knownChanged: new ua()
  });
}
var ha = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Zt(Ks, {
        max: Fe["cache.fragmentQueryDocuments"] || 1e3,
        cache: cr
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var r = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(r);
      }, n), i;
    }, e.prototype.recordOptimisticTransaction = function(t, r) {
      this.performTransaction(t, r);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && ee(t, "canonizeResults", "cache.readQuery"), fe("canonizeResults", function() {
        return n.read(v(v({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
      });
    }, e.prototype.watchFragment = function(t) {
      var r = this, n = t.fragment, i = t.fragmentName, o = t.from, a = t.optimistic, s = a === void 0 ? !0 : a, u = Pe(t, ["fragment", "fragmentName", "from", "optimistic"]), c = this.getFragmentDoc(n, i), l = typeof o > "u" || typeof o == "string" ? o : this.identify(o), h = !!t[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var d = i || No(n).name.value;
        l || globalThis.__DEV__ !== !1 && D.warn(1, d);
      }
      var f = v(v({}, u), { returnPartialData: !0, id: l, query: c, optimistic: s }), p;
      return new Q(function(m) {
        return r.watch(v(v({}, f), { immediate: !0, callback: function(g) {
          var y = h ? fa(g.result, n, r, i) : g.result;
          if (
            // Always ensure we deliver the first result
            !(p && aa(
              c,
              { data: p.result },
              { data: y },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var b = {
              data: y,
              complete: !!g.complete
            };
            g.missing && (b.missing = Or(g.missing.map(function(w) {
              return w.missing;
            }))), p = v(v({}, g), { result: y }), m.next(b);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && ee(t, "canonizeResults", "cache.readFragment"), fe("canonizeResults", function() {
        return n.read(v(v({}, t), { query: n.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
      });
    }, e.prototype.writeQuery = function(t) {
      var r = t.id, n = t.data, i = Pe(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: r || "ROOT_QUERY",
        result: n
      }));
    }, e.prototype.writeFragment = function(t) {
      var r = t.id, n = t.data, i = t.fragment, o = t.fragmentName, a = Pe(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(a, {
        query: this.getFragmentDoc(i, o),
        dataId: r,
        result: n
      }));
    }, e.prototype.updateQuery = function(t, r) {
      return globalThis.__DEV__ !== !1 && ee(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(n) {
          var i = fe("canonizeResults", function() {
            return n.readQuery(t);
          }), o = r(i);
          return o == null ? i : (n.writeQuery(v(v({}, t), { data: o })), o);
        }
      });
    }, e.prototype.updateFragment = function(t, r) {
      return globalThis.__DEV__ !== !1 && ee(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(n) {
          var i = fe("canonizeResults", function() {
            return n.readFragment(t);
          }), o = r(i);
          return o == null ? i : (n.writeFragment(v(v({}, t), { data: o })), o);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (ha.prototype.getMemoryInternals = uu);
var da = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r, n, i, o) {
      var a, s = e.call(this, r) || this;
      if (s.message = r, s.path = n, s.query = i, s.variables = o, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var u = s.path.length - 1; u >= 0; --u)
          s.missing = (a = {}, a[s.path[u]] = s.missing, a);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), ie = Object.prototype.hasOwnProperty;
function Ft(e) {
  return e == null;
}
function pa(e, t) {
  var r = e.__typename, n = e.id, i = e._id;
  if (typeof r == "string" && (t && (t.keyObject = Ft(n) ? Ft(i) ? void 0 : { _id: i } : { id: n }), Ft(n) && !Ft(i) && (n = i), !Ft(n)))
    return "".concat(r, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var va = {
  dataIdFromObject: pa,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function Kc(e) {
  return wt(va, e);
}
function ma(e) {
  var t = e.canonizeResults;
  return t === void 0 ? va.canonizeResults : t;
}
function Hc(e, t) {
  return q(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var ya = /^[_a-z][_0-9a-z]*/i;
function Ue(e) {
  var t = e.match(ya);
  return t ? t[0] : e;
}
function dn(e, t, r) {
  return W(t) ? X(t) ? t.every(function(n) {
    return dn(e, n, r);
  }) : e.selections.every(function(n) {
    if (qe(n) && Wt(n, r)) {
      var i = Ce(n);
      return ie.call(t, i) && (!n.selectionSet || dn(n.selectionSet, t[i], r));
    }
    return !0;
  }) : !1;
}
function ct(e) {
  return W(e) && !q(e) && !X(e);
}
function Yc() {
  return new Qe();
}
function ga(e, t) {
  var r = Et(St(e));
  return {
    fragmentMap: r,
    lookupFragment: function(n) {
      var i = r[n];
      return !i && t && (i = t.lookup(n)), i || null;
    }
  };
}
var ar = /* @__PURE__ */ Object.create(null), $r = function() {
  return ar;
}, zi = /* @__PURE__ */ Object.create(null), Qt = (
  /** @class */
  (function() {
    function e(t, r) {
      var n = this;
      this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
        return fr(q(i) ? n.get(i.__ref, o) : i && i[o]);
      }, this.canRead = function(i) {
        return q(i) ? n.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, o) {
        if (typeof i == "string")
          return dt(i);
        if (q(i))
          return i;
        var a = n.policies.identify(i)[0];
        if (a) {
          var s = dt(a);
          return o && n.merge(a, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return v({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, r) {
      if (this.group.depend(t, r), ie.call(this.data, t)) {
        var n = this.data[t];
        if (n && ie.call(n, r))
          return n[r];
      }
      if (r === "__typename" && ie.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof Ae)
        return this.parent.get(t, r);
    }, e.prototype.lookup = function(t, r) {
      if (r && this.group.depend(t, "__exists"), ie.call(this.data, t))
        return this.data[t];
      if (this instanceof Ae)
        return this.parent.lookup(t, r);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, r) {
      var n = this, i;
      q(t) && (t = t.__ref), q(r) && (r = r.__ref);
      var o = typeof t == "string" ? this.lookup(i = t) : t, a = typeof r == "string" ? this.lookup(i = r) : r;
      if (a) {
        D(typeof i == "string", 2);
        var s = new Qe(el).merge(o, a);
        if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
          var u = /* @__PURE__ */ Object.create(null);
          o || (u.__exists = 1), Object.keys(a).forEach(function(c) {
            if (!o || o[c] !== s[c]) {
              u[c] = 1;
              var l = Ue(c);
              l !== c && !n.policies.hasKeyArgs(s.__typename, l) && (u[l] = 1), s[c] === void 0 && !(n instanceof Ae) && delete s[c];
            }
          }), u.__typename && !(o && o.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete u.__typename, Object.keys(u).forEach(function(c) {
            return n.group.dirty(i, c);
          });
        }
      }
    }, e.prototype.modify = function(t, r) {
      var n = this, i = this.lookup(t);
      if (i) {
        var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, u = {
          DELETE: ar,
          INVALIDATE: zi,
          isReference: q,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(c, l) {
            return n.policies.readField(typeof c == "string" ? {
              fieldName: c,
              from: l || dt(t)
            } : c, { store: n });
          }
        };
        if (Object.keys(i).forEach(function(c) {
          var l = Ue(c), h = i[c];
          if (h !== void 0) {
            var d = typeof r == "function" ? r : r[c] || r[l];
            if (d) {
              var f = d === $r ? ar : d(fr(h), v(v({}, u), { fieldName: l, storeFieldName: c, storage: n.getStorage(t, c) }));
              if (f === zi)
                n.group.dirty(t, c);
              else if (f === ar && (f = void 0), f !== h && (o[c] = f, a = !0, h = f, globalThis.__DEV__ !== !1)) {
                var p = function(S) {
                  if (n.lookup(S.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && D.warn(3, S), !0;
                };
                if (q(f))
                  p(f);
                else if (Array.isArray(f))
                  for (var m = !1, g = void 0, y = 0, b = f; y < b.length; y++) {
                    var w = b[y];
                    if (q(w)) {
                      if (m = !0, p(w))
                        break;
                    } else if (typeof w == "object" && w) {
                      var k = n.policies.identify(w)[0];
                      k && (g = w);
                    }
                    if (m && g !== void 0) {
                      globalThis.__DEV__ !== !1 && D.warn(4, g);
                      break;
                    }
                  }
              }
            }
            h !== void 0 && (s = !1);
          }
        }), a)
          return this.merge(t, o), s && (this instanceof Ae ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, r, n) {
      var i, o = this.lookup(t);
      if (o) {
        var a = this.getFieldValue(o, "__typename"), s = r && n ? this.policies.getStoreFieldName({ typename: a, fieldName: r, args: n }) : r;
        return this.modify(t, s ? (i = {}, i[s] = $r, i) : $r);
      }
      return !1;
    }, e.prototype.evict = function(t, r) {
      var n = !1;
      return t.id && (ie.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof Ae && this !== r && (n = this.parent.evict(t, r) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, r = this.toObject(), n = [];
      return this.getRootIdSet().forEach(function(i) {
        ie.call(t.policies.rootTypenamesById, i) || n.push(i);
      }), n.length && (r.__META = { extraRootIds: n.sort() }), r;
    }, e.prototype.replace = function(t) {
      var r = this;
      if (Object.keys(this.data).forEach(function(o) {
        t && ie.call(t, o) || r.delete(o);
      }), t) {
        var n = t.__META, i = Pe(t, ["__META"]);
        Object.keys(i).forEach(function(o) {
          r.merge(o, i[o]);
        }), n && n.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var r = --this.rootIds[t];
        return r || delete this.rootIds[t], r;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof Ae ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, r = this.getRootIdSet(), n = this.toObject();
      r.forEach(function(a) {
        ie.call(n, a) && (Object.keys(t.findChildRefIds(a)).forEach(r.add, r), delete n[a]);
      });
      var i = Object.keys(n);
      if (i.length) {
        for (var o = this; o instanceof Ae; )
          o = o.parent;
        i.forEach(function(a) {
          return o.delete(a);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!ie.call(this.refs, t)) {
        var r = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
        if (!n)
          return r;
        var i = /* @__PURE__ */ new Set([n]);
        i.forEach(function(o) {
          q(o) && (r[o.__ref] = !0), W(o) && Object.keys(o).forEach(function(a) {
            var s = o[a];
            W(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), ba = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? Uo() : null, this.keyMaker = new Ne(nt);
    }, e.prototype.depend = function(t, r) {
      if (this.d) {
        this.d(Lr(t, r));
        var n = Ue(r);
        n !== r && this.d(Lr(t, n)), this.parent && this.parent.depend(t, r);
      }
    }, e.prototype.dirty = function(t, r) {
      this.d && this.d.dirty(
        Lr(t, r),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        r === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function Lr(e, t) {
  return t + "#" + e;
}
function Ri(e, t) {
  $t(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(r) {
      De(n, r);
      function n(i) {
        var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, u = i.seed, c = r.call(this, o, new ba(s)) || this;
        return c.stump = new Xc(c), c.storageTrie = new Ne(nt), u && c.replace(u), c;
      }
      return n.prototype.addLayer = function(i, o) {
        return this.stump.addLayer(i, o);
      }, n.prototype.removeLayer = function() {
        return this;
      }, n.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, n;
    })(e)
  );
  e.Root = t;
})(Qt || (Qt = {}));
var Ae = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, n.policies, o) || this;
      return a.id = r, a.parent = n, a.replay = i, a.group = o, i(a), a;
    }
    return t.prototype.addLayer = function(r, n) {
      return new t(r, this, n, this.group);
    }, t.prototype.removeLayer = function(r) {
      var n = this, i = this.parent.removeLayer(r);
      return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
        var a = n.data[o], s = i.lookup(o);
        s ? a ? a !== s && Object.keys(a).forEach(function(u) {
          B(a[u], s[u]) || n.group.dirty(o, u);
        }) : (n.group.dirty(o, "__exists"), Object.keys(s).forEach(function(u) {
          n.group.dirty(o, u);
        })) : n.delete(o);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return v(v({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(r) {
      var n = this.parent.findChildRefIds(r);
      return ie.call(this.data, r) ? v(v({}, n), e.prototype.findChildRefIds.call(this, r)) : n;
    }, t.prototype.getStorage = function() {
      for (var r = this.parent; r.parent; )
        r = r.parent;
      return r.getStorage.apply(
        r,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(Qt)
), Xc = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      return e.call(this, "EntityStore.Stump", r, function() {
      }, new ba(r.group.caching, r.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(r, n) {
      return this.parent.merge(r, n);
    }, t;
  })(Ae)
);
function el(e, t, r) {
  var n = e[r], i = t[r];
  return B(n, i) ? n : i;
}
function $t(e) {
  return !!(e instanceof Qt && e.group.caching);
}
function tl(e) {
  return W(e) ? X(e) ? e.slice(0) : v({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var Pi = (
  /** @class */
  (function() {
    function e() {
      this.known = new (Sn ? WeakSet : Set)(), this.pool = new Ne(nt), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return W(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (W(t)) {
        var r = tl(t);
        return this.passes.set(r, t), r;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var r = this;
      if (W(t)) {
        var n = this.passes.get(t);
        if (n)
          return n;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var o = t.map(this.admit, this), a = this.pool.lookupArray(o);
            return a.array || (this.known.add(a.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), a.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), u = [s], c = this.sortedKeys(t);
            u.push(c.json);
            var l = u.length;
            c.sorted.forEach(function(f) {
              u.push(r.admit(t[f]));
            });
            var a = this.pool.lookupArray(u);
            if (!a.object) {
              var h = a.object = Object.create(s);
              this.known.add(h), c.sorted.forEach(function(f, p) {
                h[f] = u[l + p];
              }), globalThis.__DEV__ !== !1 && Object.freeze(h);
            }
            return a.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var r = Object.keys(t), n = this.pool.lookupArray(r);
      if (!n.keys) {
        r.sort();
        var i = JSON.stringify(r);
        (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: r, json: i });
      }
      return n.keys;
    }, e;
  })()
);
function Fi(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var rl = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.knownResults = new (nt ? WeakMap : Map)(), this.config = wt(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: ma(t)
      }), this.canon = t.canon || new Pi(), this.executeSelectionSet = Zt(function(n) {
        var i, o = n.context.canonizeResults, a = Fi(n);
        a[3] = !o;
        var s = (i = r.executeSelectionSet).peek.apply(i, a);
        return s ? o ? v(v({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: r.canon.admit(s.result)
        }) : s : (Ri(n.context.store, n.enclosingRef.__ref), r.execSelectionSetImpl(n));
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: Fi,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(n, i, o, a) {
          if ($t(o.store))
            return o.store.makeCacheKey(n, q(i) ? i.__ref : i, o.varString, a);
        }
      }), this.executeSubSelectedArray = Zt(function(n) {
        return Ri(n.context.store, n.enclosingRef.__ref), r.execSubSelectedArrayImpl(n);
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(n) {
          var i = n.field, o = n.array, a = n.context;
          if ($t(a.store))
            return a.store.makeCacheKey(i, o, a.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new Pi();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var r = t.store, n = t.query, i = t.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = t.variables, s = t.returnPartialData, u = s === void 0 ? !0 : s, c = t.canonizeResults, l = c === void 0 ? this.config.canonizeResults : c, h = this.config.cache.policies;
      a = v(v({}, On(Co(n))), a);
      var d = dt(o), f = this.executeSelectionSet({
        selectionSet: Ot(n).selectionSet,
        objectOrReference: d,
        enclosingRef: d,
        context: v({ store: r, query: n, policies: h, variables: a, varString: Ve(a), canonizeResults: l }, ga(n, this.config.fragments))
      }), p;
      if (f.missing && (p = [
        new da(nl(f.missing), f.missing, n, a)
      ], !u))
        throw p[0];
      return {
        result: f.result,
        complete: !p,
        missing: p
      };
    }, e.prototype.isFresh = function(t, r, n, i) {
      if ($t(i.store) && this.knownResults.get(t) === n) {
        var o = this.executeSelectionSet.peek(
          n,
          r,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (o && t === o.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var r = this, n = t.selectionSet, i = t.objectOrReference, o = t.enclosingRef, a = t.context;
      if (q(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = a.variables, u = a.policies, c = a.store, l = c.getFieldValue(i, "__typename"), h = [], d, f = new Qe();
      this.config.addTypename && typeof l == "string" && !u.rootIdsByTypename[l] && h.push({ __typename: l });
      function p(w, k) {
        var S;
        return w.missing && (d = f.merge(d, (S = {}, S[k] = w.missing, S))), w.result;
      }
      var m = new Set(n.selections);
      m.forEach(function(w) {
        var k, S;
        if (Wt(w, s))
          if (qe(w)) {
            var T = u.readField({
              fieldName: w.name.value,
              field: w,
              variables: a.variables,
              from: i
            }, a), P = Ce(w);
            T === void 0 ? zn.added(w) || (d = f.merge(d, (k = {}, k[P] = "Can't find field '".concat(w.name.value, "' on ").concat(q(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), k))) : X(T) ? T.length > 0 && (T = p(r.executeSubSelectedArray({
              field: w,
              array: T,
              enclosingRef: o,
              context: a
            }), P)) : w.selectionSet ? T != null && (T = p(r.executeSelectionSet({
              selectionSet: w.selectionSet,
              objectOrReference: T,
              enclosingRef: q(T) ? T : o,
              context: a
            }), P)) : a.canonizeResults && (T = r.canon.pass(T)), T !== void 0 && h.push((S = {}, S[P] = T, S));
          } else {
            var R = wr(w, a.lookupFragment);
            if (!R && w.kind === K.FRAGMENT_SPREAD)
              throw ve(10, w.name.value);
            R && u.fragmentMatches(R, l) && R.selectionSet.selections.forEach(m.add, m);
          }
      });
      var g = Or(h), y = { result: g, missing: d }, b = a.canonizeResults ? this.canon.admit(y) : fr(y);
      return b.result && this.knownResults.set(b.result, n), b;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var r = this, n = t.field, i = t.array, o = t.enclosingRef, a = t.context, s, u = new Qe();
      function c(l, h) {
        var d;
        return l.missing && (s = u.merge(s, (d = {}, d[h] = l.missing, d))), l.result;
      }
      return n.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(l, h) {
        return l === null ? null : X(l) ? c(r.executeSubSelectedArray({
          field: n,
          array: l,
          enclosingRef: o,
          context: a
        }), h) : n.selectionSet ? c(r.executeSelectionSet({
          selectionSet: n.selectionSet,
          objectOrReference: l,
          enclosingRef: q(l) ? l : o,
          context: a
        }), h) : (globalThis.__DEV__ !== !1 && il(a.store, n, l), l);
      }), {
        result: a.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function nl(e) {
  try {
    JSON.stringify(e, function(t, r) {
      if (typeof r == "string")
        throw r;
      return r;
    });
  } catch (t) {
    return t;
  }
}
function il(e, t, r) {
  if (!t.selectionSet) {
    var n = /* @__PURE__ */ new Set([r]);
    n.forEach(function(i) {
      W(i) && (D(
        !q(i),
        11,
        Hc(e, i),
        t.name.value
      ), Object.values(i).forEach(n.add, n));
    });
  }
}
var xn = new Tt(), Ci = /* @__PURE__ */ new WeakMap();
function Lt(e) {
  var t = Ci.get(e);
  return t || Ci.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: Uo()
  }), t;
}
function Ni(e) {
  Lt(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function ol(e) {
  Lt(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function al(e) {
  var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = function(o) {
    if (arguments.length > 0) {
      if (e !== o) {
        e = o, t.forEach(function(u) {
          Lt(u).dep.dirty(n), sl(u);
        });
        var a = Array.from(r);
        r.clear(), a.forEach(function(u) {
          return u(e);
        });
      }
    } else {
      var s = xn.getValue();
      s && (i(s), Lt(s).dep(n));
    }
    return e;
  };
  n.onNextChange = function(o) {
    return r.add(o), function() {
      r.delete(o);
    };
  };
  var i = n.attachCache = function(o) {
    return t.add(o), Lt(o).vars.add(n), n;
  };
  return n.forgetCache = function(o) {
    return t.delete(o);
  }, n;
}
function sl(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var Ai = /* @__PURE__ */ Object.create(null);
function Mn(e) {
  var t = JSON.stringify(e);
  return Ai[t] || (Ai[t] = /* @__PURE__ */ Object.create(null));
}
function xi(e) {
  var t = Mn(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(r, n) {
    var i = function(a, s) {
      return n.readField(s, a);
    }, o = n.keyObject = jn(e, function(a) {
      var s = vt(
        n.storeObject,
        a,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && r !== n.storeObject && ie.call(r, a[0]) && (s = vt(r, a, wa)), D(s !== void 0, 5, a.join("."), r), s;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(o));
  });
}
function Mi(e) {
  var t = Mn(e);
  return t.keyArgsFn || (t.keyArgsFn = function(r, n) {
    var i = n.field, o = n.variables, a = n.fieldName, s = jn(e, function(c) {
      var l = c[0], h = l.charAt(0);
      if (h === "@") {
        if (i && Ie(i.directives)) {
          var d = l.slice(1), f = i.directives.find(function(y) {
            return y.name.value === d;
          }), p = f && Er(f, o);
          return p && vt(
            p,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            c.slice(1)
          );
        }
        return;
      }
      if (h === "$") {
        var m = l.slice(1);
        if (o && ie.call(o, m)) {
          var g = c.slice(0);
          return g[0] = m, vt(o, g);
        }
        return;
      }
      if (r)
        return vt(r, c);
    }), u = JSON.stringify(s);
    return (r || u !== "{}") && (a += ":" + u), a;
  });
}
function jn(e, t) {
  var r = new Qe();
  return _a(e).reduce(function(n, i) {
    var o, a = t(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      n = r.merge(n, a);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function _a(e) {
  var t = Mn(e);
  if (!t.paths) {
    var r = t.paths = [], n = [];
    e.forEach(function(i, o) {
      X(i) ? (_a(i).forEach(function(a) {
        return r.push(n.concat(a));
      }), n.length = 0) : (n.push(i), X(e[o + 1]) || (r.push(n.slice(0)), n.length = 0));
    });
  }
  return t.paths;
}
function wa(e, t) {
  return e[t];
}
function vt(e, t, r) {
  return r = r || wa, Ea(t.reduce(function n(i, o) {
    return X(i) ? i.map(function(a) {
      return n(a, o);
    }) : i && r(i, o);
  }, e));
}
function Ea(e) {
  return W(e) ? X(e) ? e.map(Ea) : jn(Object.keys(e).sort(), function(t) {
    return vt(e, t);
  }) : e;
}
function pn(e) {
  return e.args !== void 0 ? e.args : e.field ? Er(e.field, e.variables) : null;
}
var ul = function() {
}, ji = function(e, t) {
  return t.fieldName;
}, $i = function(e, t, r) {
  var n = r.mergeObjects;
  return n(e, t);
}, Li = function(e, t) {
  return t;
}, cl = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = v({ dataIdFromObject: pa }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, r) {
      var n, i = this, o = r && (r.typename || ((n = r.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
      if (o === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var a = r && r.storeObject || t, s = v(v({}, r), { typename: o, storeObject: a, readField: r && r.readField || function() {
        var h = $n(arguments, a);
        return i.readField(h, {
          store: i.cache.data,
          variables: h.variables
        });
      } }), u, c = o && this.getTypePolicy(o), l = c && c.keyFn || this.config.dataIdFromObject;
      return An.withValue(!0, function() {
        for (; l; ) {
          var h = l(v(v({}, t), a), s);
          if (X(h))
            l = xi(h);
          else {
            u = h;
            break;
          }
        }
      }), u = u ? String(u) : void 0, s.keyObject ? [u, s.keyObject] : [u];
    }, e.prototype.addTypePolicies = function(t) {
      var r = this;
      Object.keys(t).forEach(function(n) {
        var i = t[n], o = i.queryType, a = i.mutationType, s = i.subscriptionType, u = Pe(i, ["queryType", "mutationType", "subscriptionType"]);
        o && r.setRootTypename("Query", n), a && r.setRootTypename("Mutation", n), s && r.setRootTypename("Subscription", n), ie.call(r.toBeAdded, n) ? r.toBeAdded[n].push(u) : r.toBeAdded[n] = [u];
      });
    }, e.prototype.updateTypePolicy = function(t, r, n) {
      var i = this.getTypePolicy(t), o = r.keyFields, a = r.fields;
      function s(u, c) {
        u.merge = typeof c == "function" ? c : c === !0 ? $i : c === !1 ? Li : u.merge;
      }
      s(i, r.merge), i.keyFn = // Pass false to disable normalization for this typename.
      o === !1 ? ul : X(o) ? xi(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(u) {
        var c = n[u];
        (!c || (c == null ? void 0 : c.typename) !== t) && (c = n[u] = { typename: t });
        var l = a[u];
        if (typeof l == "function")
          c.read = l;
        else {
          var h = l.keyArgs, d = l.read, f = l.merge;
          c.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          h === !1 ? ji : X(h) ? Mi(h) : typeof h == "function" ? h : c.keyFn, typeof d == "function" && (c.read = d), s(c, f);
        }
        c.read && c.merge && (c.keyFn = c.keyFn || ji);
      });
    }, e.prototype.setRootTypename = function(t, r) {
      r === void 0 && (r = t);
      var n = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[n];
      r !== i && (D(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[r] = n, this.rootTypenamesById[n] = r);
    }, e.prototype.addPossibleTypes = function(t) {
      var r = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
        r.getSupertypeSet(n, !0), t[n].forEach(function(i) {
          r.getSupertypeSet(i, !0).add(n);
          var o = i.match(ya);
          (!o || o[0] !== i) && r.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var r = this;
      if (!ie.call(this.typePolicies, t)) {
        var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        n.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(a, s) {
          if (a.test(t)) {
            var u = r.supertypeMap.get(s);
            u && u.forEach(function(c) {
              return i.add(c);
            });
          }
        })), i && i.size && i.forEach(function(a) {
          var s = r.getTypePolicy(a), u = s.fields, c = Pe(s, ["fields"]);
          Object.assign(n, c), Object.assign(n.fields, u);
        });
      }
      var o = this.toBeAdded[t];
      return o && o.length && o.splice(0).forEach(function(a) {
        r.updateTypePolicy(t, a, r.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, r) {
      if (t)
        return this.getTypePolicy(t).fields[r];
    }, e.prototype.getSupertypeSet = function(t, r) {
      var n = this.supertypeMap.get(t);
      return !n && r && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
    }, e.prototype.fragmentMatches = function(t, r, n, i) {
      var o = this;
      if (!t.typeCondition)
        return !0;
      if (!r)
        return !1;
      var a = t.typeCondition.name.value;
      if (r === a)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(a))
        for (var s = this.getSupertypeSet(r, !0), u = [s], c = function(p) {
          var m = o.getSupertypeSet(p, !1);
          m && m.size && u.indexOf(m) < 0 && u.push(m);
        }, l = !!(n && this.fuzzySubtypes.size), h = !1, d = 0; d < u.length; ++d) {
          var f = u[d];
          if (f.has(a))
            return s.has(a) || (h && globalThis.__DEV__ !== !1 && D.warn(7, r, a), s.add(a)), !0;
          f.forEach(c), l && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          d === u.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          dn(t.selectionSet, n, i) && (l = !1, h = !0, this.fuzzySubtypes.forEach(function(p, m) {
            var g = r.match(p);
            g && g[0] === r && c(m);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return !!(n && n.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var r = t.typename, n = t.fieldName, i = this.getFieldPolicy(r, n), o, a = i && i.keyFn;
      if (a && r)
        for (var s = {
          typename: r,
          fieldName: n,
          field: t.field || null,
          variables: t.variables
        }, u = pn(t); a; ) {
          var c = a(u, s);
          if (X(c))
            a = Mi(c);
          else {
            o = c || n;
            break;
          }
        }
      return o === void 0 && (o = t.field ? Ou(t.field, t.variables) : Fo(n, pn(t))), o === !1 ? n : n === Ue(o) ? o : n + ":" + o;
    }, e.prototype.readField = function(t, r) {
      var n = t.from;
      if (n) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var o = r.store.getFieldValue(n, "__typename");
            o && (t.typename = o);
          }
          var a = this.getStoreFieldName(t), s = Ue(a), u = r.store.getFieldValue(n, a), c = this.getFieldPolicy(t.typename, s), l = c && c.read;
          if (l) {
            var h = Vi(this, n, t, r, r.store.getStorage(q(n) ? n.__ref : n, a));
            return xn.withValue(this.cache, l, [
              u,
              h
            ]);
          }
          return u;
        }
      }
    }, e.prototype.getReadFunction = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return n && n.read;
    }, e.prototype.getMergeFunction = function(t, r, n) {
      var i = this.getFieldPolicy(t, r), o = i && i.merge;
      return !o && n && (i = this.getTypePolicy(n), o = i && i.merge), o;
    }, e.prototype.runMergeFunction = function(t, r, n, i, o) {
      var a = n.field, s = n.typename, u = n.merge;
      return u === $i ? ka(i.store)(t, r) : u === Li ? r : (i.overwrite && (t = void 0), u(t, r, Vi(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: a.name.value,
          field: a,
          variables: i.variables
        },
        i,
        o || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function Vi(e, t, r, n, i) {
  var o = e.getStoreFieldName(r), a = Ue(o), s = r.variables || n.variables, u = n.store, c = u.toReference, l = u.canRead;
  return {
    args: pn(r),
    field: r.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: q,
    toReference: c,
    storage: i,
    cache: e.cache,
    canRead: l,
    readField: function() {
      return e.readField($n(arguments, t, s), n);
    },
    mergeObjects: ka(n.store)
  };
}
function $n(e, t, r) {
  var n = e[0], i = e[1], o = e.length, a;
  return typeof n == "string" ? a = {
    fieldName: n,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: o > 1 ? i : t
  } : (a = v({}, n), ie.call(a, "from") || (a.from = t)), globalThis.__DEV__ !== !1 && a.from === void 0 && globalThis.__DEV__ !== !1 && D.warn(8, wo(Array.from(e))), a.variables === void 0 && (a.variables = r), a;
}
function ka(e) {
  return function(r, n) {
    if (X(r) || X(n))
      throw ve(9);
    if (W(r) && W(n)) {
      var i = e.getFieldValue(r, "__typename"), o = e.getFieldValue(n, "__typename"), a = i && o && i !== o;
      if (a)
        return n;
      if (q(r) && ct(n))
        return e.merge(r.__ref, n), r;
      if (ct(r) && q(n))
        return e.merge(r, n.__ref), n;
      if (ct(r) && ct(n))
        return v(v({}, r), n);
    }
    return n;
  };
}
function Vr(e, t, r) {
  var n = "".concat(t).concat(r), i = e.flavors.get(n);
  return i || e.flavors.set(n, i = e.clientOnly === t && e.deferred === r ? e : v(v({}, e), { clientOnly: t, deferred: r })), i;
}
var ll = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.cache = t, this.reader = r, this.fragments = n;
    }
    return e.prototype.writeToStore = function(t, r) {
      var n = this, i = r.query, o = r.result, a = r.dataId, s = r.variables, u = r.overwrite, c = et(i), l = Yc();
      s = v(v({}, On(c)), s);
      var h = v(v({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(f, p) {
        return l.merge(f, p);
      }, variables: s, varString: Ve(s) }, ga(i, this.fragments)), { overwrite: !!u, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), d = this.processSelectionSet({
        result: o || /* @__PURE__ */ Object.create(null),
        dataId: a,
        selectionSet: c.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: h
      });
      if (!q(d))
        throw ve(12, o);
      return h.incomingById.forEach(function(f, p) {
        var m = f.storeObject, g = f.mergeTree, y = f.fieldNodeSet, b = dt(p);
        if (g && g.map.size) {
          var w = n.applyMerges(g, b, m, h);
          if (q(w))
            return;
          m = w;
        }
        if (globalThis.__DEV__ !== !1 && !h.overwrite) {
          var k = /* @__PURE__ */ Object.create(null);
          y.forEach(function(P) {
            P.selectionSet && (k[P.name.value] = !0);
          });
          var S = function(P) {
            return k[Ue(P)] === !0;
          }, T = function(P) {
            var R = g && g.map.get(P);
            return !!(R && R.info && R.info.merge);
          };
          Object.keys(m).forEach(function(P) {
            S(P) && !T(P) && fl(b, m, P, h.store);
          });
        }
        t.merge(p, m);
      }), t.retain(d.__ref), d;
    }, e.prototype.processSelectionSet = function(t) {
      var r = this, n = t.dataId, i = t.result, o = t.selectionSet, a = t.context, s = t.mergeTree, u = this.cache.policies, c = /* @__PURE__ */ Object.create(null), l = n && u.rootTypenamesById[n] || tn(i, o, a.fragmentMap) || n && a.store.get(n, "__typename");
      typeof l == "string" && (c.__typename = l);
      var h = function() {
        var w = $n(arguments, c, a.variables);
        if (q(w.from)) {
          var k = a.incomingById.get(w.from.__ref);
          if (k) {
            var S = u.readField(v(v({}, w), { from: k.storeObject }), a);
            if (S !== void 0)
              return S;
          }
        }
        return u.readField(w, a);
      }, d = /* @__PURE__ */ new Set();
      this.flattenFields(
        o,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        a,
        l
      ).forEach(function(w, k) {
        var S, T = Ce(k), P = i[T];
        if (d.add(k), P !== void 0) {
          var R = u.getStoreFieldName({
            typename: l,
            fieldName: k.name.value,
            field: k,
            variables: w.variables
          }), x = qi(s, R), L = r.processFieldValue(
            P,
            k,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            k.selectionSet ? Vr(w, !1, !1) : w,
            x
          ), Ee = void 0;
          k.selectionSet && (q(L) || ct(L)) && (Ee = h("__typename", L));
          var me = u.getMergeFunction(l, k.name.value, Ee);
          me ? x.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: k,
            typename: l,
            merge: me
          } : Zi(s, R), c = w.merge(c, (S = {}, S[R] = L, S));
        } else globalThis.__DEV__ !== !1 && !w.clientOnly && !w.deferred && !zn.added(k) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !u.getReadFunction(l, k.name.value) && globalThis.__DEV__ !== !1 && D.error(13, Ce(k), i);
      });
      try {
        var f = u.identify(i, {
          typename: l,
          selectionSet: o,
          fragmentMap: a.fragmentMap,
          storeObject: c,
          readField: h
        }), p = f[0], m = f[1];
        n = n || p, m && (c = a.merge(c, m));
      } catch (w) {
        if (!n)
          throw w;
      }
      if (typeof n == "string") {
        var g = dt(n), y = a.written[n] || (a.written[n] = []);
        if (y.indexOf(o) >= 0 || (y.push(o), this.reader && this.reader.isFresh(i, g, o, a)))
          return g;
        var b = a.incomingById.get(n);
        return b ? (b.storeObject = a.merge(b.storeObject, c), b.mergeTree = vn(b.mergeTree, s), d.forEach(function(w) {
          return b.fieldNodeSet.add(w);
        })) : a.incomingById.set(n, {
          storeObject: c,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: hr(s) ? void 0 : s,
          fieldNodeSet: d
        }), g;
      }
      return c;
    }, e.prototype.processFieldValue = function(t, r, n, i) {
      var o = this;
      return !r.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? Xo(t) : t : X(t) ? t.map(function(a, s) {
        var u = o.processFieldValue(a, r, n, qi(i, s));
        return Zi(i, s), u;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: r.selectionSet,
        context: n,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, r, n, i) {
      i === void 0 && (i = tn(r, t, n.fragmentMap));
      var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new Ne(!1);
      return (function u(c, l) {
        var h = s.lookup(
          c,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          l.clientOnly,
          l.deferred
        );
        h.visited || (h.visited = !0, c.selections.forEach(function(d) {
          if (Wt(d, n.variables)) {
            var f = l.clientOnly, p = l.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(f && p) && Ie(d.directives) && d.directives.forEach(function(y) {
                var b = y.name.value;
                if (b === "client" && (f = !0), b === "defer") {
                  var w = Er(y, n.variables);
                  (!w || w.if !== !1) && (p = !0);
                }
              }), qe(d)
            ) {
              var m = o.get(d);
              m && (f = f && m.clientOnly, p = p && m.deferred), o.set(d, Vr(n, f, p));
            } else {
              var g = wr(d, n.lookupFragment);
              if (!g && d.kind === K.FRAGMENT_SPREAD)
                throw ve(14, d.name.value);
              g && a.fragmentMatches(g, i, r, n.variables) && u(g.selectionSet, Vr(n, f, p));
            }
          }
        }));
      })(t, n), o;
    }, e.prototype.applyMerges = function(t, r, n, i, o) {
      var a, s = this;
      if (t.map.size && !q(n)) {
        var u = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !X(n) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (q(r) || ct(r)) ? r : void 0
        ), c = n;
        u && !o && (o = [q(u) ? u.__ref : u]);
        var l, h = function(d, f) {
          return X(d) ? typeof f == "number" ? d[f] : void 0 : i.store.getFieldValue(d, String(f));
        };
        t.map.forEach(function(d, f) {
          var p = h(u, f), m = h(c, f);
          if (m !== void 0) {
            o && o.push(f);
            var g = s.applyMerges(d, p, m, i, o);
            g !== m && (l = l || /* @__PURE__ */ new Map(), l.set(f, g)), o && D(o.pop() === f);
          }
        }), l && (n = X(c) ? c.slice(0) : v({}, c), l.forEach(function(d, f) {
          n[f] = d;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(r, n, t.info, i, o && (a = i.store).getStorage.apply(a, o)) : n;
    }, e;
  })()
), Sa = [];
function qi(e, t) {
  var r = e.map;
  return r.has(t) || r.set(t, Sa.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
}
function vn(e, t) {
  if (e === t || !t || hr(t))
    return e;
  if (!e || hr(e))
    return t;
  var r = e.info && t.info ? v(v({}, e.info), t.info) : e.info || t.info, n = e.map.size && t.map.size, i = n ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, o = { info: r, map: i };
  if (n) {
    var a = new Set(t.map.keys());
    e.map.forEach(function(s, u) {
      o.map.set(u, vn(s, t.map.get(u))), a.delete(u);
    }), a.forEach(function(s) {
      o.map.set(s, vn(t.map.get(s), e.map.get(s)));
    });
  }
  return o;
}
function hr(e) {
  return !e || !(e.info || e.map.size);
}
function Zi(e, t) {
  var r = e.map, n = r.get(t);
  n && hr(n) && (Sa.push(n), r.delete(t));
}
var Qi = /* @__PURE__ */ new Set();
function fl(e, t, r, n) {
  var i = function(h) {
    var d = n.getFieldValue(h, r);
    return typeof d == "object" && d;
  }, o = i(e);
  if (o) {
    var a = i(t);
    if (a && !q(o) && !B(o, a) && !Object.keys(o).every(function(h) {
      return n.getFieldValue(a, h) !== void 0;
    })) {
      var s = n.getFieldValue(e, "__typename") || n.getFieldValue(t, "__typename"), u = Ue(r), c = "".concat(s, ".").concat(u);
      if (!Qi.has(c)) {
        Qi.add(c);
        var l = [];
        !X(o) && !X(a) && [o, a].forEach(function(h) {
          var d = n.getFieldValue(h, "__typename");
          typeof d == "string" && !l.includes(d) && l.push(d);
        }), globalThis.__DEV__ !== !1 && D.warn(15, u, s, l.length ? "either ensure all objects of type " + l.join(" and ") + " have an ID or a custom merge function, or " : "", c, v({}, o), v({}, a));
      }
    }
  }
}
var Oa = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this) || this;
      return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new Bo(zn), n.assumeImmutableResults = !0, n.makeVar = al, n.txCount = 0, globalThis.__DEV__ !== !1 && (ee(r, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), ee(r, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), n.config = Kc(r), n.addTypename = !!n.config.addTypename, n.policies = new cl({
        cache: n,
        dataIdFromObject: n.config.dataIdFromObject,
        possibleTypes: n.config.possibleTypes,
        typePolicies: n.config.typePolicies
      }), n.init(), n;
    }
    return t.prototype.init = function() {
      var r = this.data = new Qt.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = r.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(r) {
      var n = this, i = this.storeReader, o = this.config.fragments;
      this.addTypenameTransform.resetCache(), o == null || o.resetCaches(), this.storeWriter = new ll(this, this.storeReader = new rl({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: ma(this.config),
        canon: r ? void 0 : i && i.canon,
        fragments: o
      }), o), this.maybeBroadcastWatch = Zt(function(a, s) {
        return n.broadcastWatch(a, s);
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(a) {
          var s = a.optimistic ? n.optimisticData : n.data;
          if ($t(s)) {
            var u = a.optimistic, c = a.id, l = a.variables;
            return s.makeCacheKey(
              a.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              a.callback,
              Ve({ optimistic: u, id: c, variables: l })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(a) {
        return a.resetCaching();
      });
    }, t.prototype.restore = function(r) {
      return this.init(), r && this.data.replace(r), this;
    }, t.prototype.extract = function(r) {
      return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(r) {
      globalThis.__DEV__ !== !1 && ee(r, "canonizeResults", "cache.read");
      var n = r.returnPartialData, i = n === void 0 ? !1 : n;
      try {
        return this.storeReader.diffQueryAgainstStore(v(v({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (o) {
        if (o instanceof da)
          return null;
        throw o;
      }
    }, t.prototype.write = function(r) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(r) {
      if (ie.call(r, "id") && !r.id)
        return !1;
      var n = r.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, n.modify(r.id || "ROOT_QUERY", r.fields);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(r) {
      return globalThis.__DEV__ !== !1 && ee(r, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(v(v({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(r) {
      var n = this;
      return this.watches.size || ol(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
        n.watches.delete(r) && !n.watches.size && Ni(n), n.maybeBroadcastWatch.forget(r);
      };
    }, t.prototype.gc = function(r) {
      globalThis.__DEV__ !== !1 && ee(r || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), Ve.reset(), Le.reset();
      var n = this.optimisticData.gc();
      return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), n;
    }, t.prototype.retain = function(r, n) {
      return (n ? this.optimisticData : this.data).retain(r);
    }, t.prototype.release = function(r, n) {
      return (n ? this.optimisticData : this.data).release(r);
    }, t.prototype.identify = function(r) {
      if (q(r))
        return r.__ref;
      try {
        return this.policies.identify(r)[0];
      } catch (n) {
        globalThis.__DEV__ !== !1 && D.warn(n);
      }
    }, t.prototype.evict = function(r) {
      if (!r.id) {
        if (ie.call(r, "id"))
          return !1;
        r = v(v({}, r), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(r, this.data);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(r) {
      var n = this;
      return this.init(), Ve.reset(), r && r.discardWatches ? (this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), Ni(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(r) {
      var n = this.optimisticData.removeLayer(r);
      n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
    }, t.prototype.batch = function(r) {
      var n = this, i = r.update, o = r.optimistic, a = o === void 0 ? !0 : o, s = r.removeOptimistic, u = r.onWatchUpdated, c, l = function(d) {
        var f = n, p = f.data, m = f.optimisticData;
        ++n.txCount, d && (n.data = n.optimisticData = d);
        try {
          return c = i(n);
        } finally {
          --n.txCount, n.data = p, n.optimisticData = m;
        }
      }, h = /* @__PURE__ */ new Set();
      return u && !this.txCount && this.broadcastWatches(v(v({}, r), { onWatchUpdated: function(d) {
        return h.add(d), !1;
      } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, l) : a === !1 ? l(this.data) : l(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), u && h.size ? (this.broadcastWatches(v(v({}, r), { onWatchUpdated: function(d, f) {
        var p = u.call(this, d, f);
        return p !== !1 && h.delete(d), p;
      } })), h.size && h.forEach(function(d) {
        return n.maybeBroadcastWatch.dirty(d);
      })) : this.broadcastWatches(r), c;
    }, t.prototype.performTransaction = function(r, n) {
      return this.batch({
        update: r,
        optimistic: n || n !== null
      });
    }, t.prototype.transformDocument = function(r) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(r));
    }, t.prototype.fragmentMatches = function(r, n) {
      return this.policies.fragmentMatches(r, n);
    }, t.prototype.lookupFragment = function(r) {
      var n;
      return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(r)) || null;
    }, t.prototype.broadcastWatches = function(r) {
      var n = this;
      this.txCount || this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch(i, r);
      });
    }, t.prototype.addFragmentsToDocument = function(r) {
      var n = this.config.fragments;
      return n ? n.transform(r) : r;
    }, t.prototype.addTypenameToDocument = function(r) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
    }, t.prototype.broadcastWatch = function(r, n) {
      var i = this, o = r.lastDiff, a = fe("canonizeResults", function() {
        return i.diff(r);
      });
      n && (r.optimistic && typeof n.optimistic == "string" && (a.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, r, a, o) === !1) || (!o || !B(o.result, a.result)) && r.callback(r.lastDiff = a, o);
    }, t;
  })(ha)
);
globalThis.__DEV__ !== !1 && (Oa.prototype.getMemoryInternals = su);
var V;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(V || (V = {}));
function lt(e) {
  return e ? e < 7 : !1;
}
var Ui = Object.assign, hl = Object.hasOwnProperty, sr = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, o = r.options, a = this, s = t.inactiveOnCreation.getValue();
      a = e.call(this, function(y) {
        a._getOrCreateQuery();
        try {
          var b = y._subscription._observer;
          b && !b.error && (b.error = dl);
        } catch {
        }
        var w = !a.observers.size;
        a.observers.add(y);
        var k = a.last;
        return k && k.error ? y.error && y.error(k.error) : k && k.result && y.next && y.next(a.maskResult(k.result)), w && a.reobserve().catch(function() {
        }), function() {
          a.observers.delete(y) && !a.observers.size && a.tearDownQuery();
        };
      }) || this, a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.dirty = !1, a._getOrCreateQuery = function() {
        return s && (n.queries.set(a.queryId, i), s = !1), a.queryManager.getOrCreateQuery(a.queryId);
      }, a.queryInfo = i, a.queryManager = n, a.waitForOwnResult = qr(o.fetchPolicy), a.isTornDown = !1, a.subscribeToMore = a.subscribeToMore.bind(a), a.maskResult = a.maskResult.bind(a);
      var u = n.defaultOptions.watchQuery, c = u === void 0 ? {} : u, l = c.fetchPolicy, h = l === void 0 ? "cache-first" : l, d = o.fetchPolicy, f = d === void 0 ? h : d, p = o.initialFetchPolicy, m = p === void 0 ? f === "standby" ? h : f : p;
      a.options = v(v({}, o), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: m,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: f
      }), a.queryId = i.queryId || n.generateQueryId();
      var g = et(a.query);
      return a.queryName = g && g.name && g.name.value, a;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return globalThis.__DEV__ !== !1 && Xe("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && D.warn(23);
      }), new Promise(function(n, i) {
        var o = {
          next: function(s) {
            n(s), r.observers.delete(o), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              a.unsubscribe();
            }, 0);
          },
          error: i
        }, a = r.subscribe(o);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      var n = this;
      r === void 0 && (r = !0);
      var i = fe("getLastResult", function() {
        return n.getLastResult(!0);
      }), o = this.queryInfo.networkStatus || i && i.networkStatus || V.ready, a = v(v({}, i), { loading: lt(o), networkStatus: o }), s = this.options.fetchPolicy, u = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(qr(u) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var c = this.queryInfo.getDiff();
        (c.complete || this.options.returnPartialData) && (a.data = c.result), B(a.data, {}) && (a.data = void 0), c.complete ? (delete a.partial, c.complete && a.networkStatus === V.loading && (u === "cache-first" || u === "cache-only") && (a.networkStatus = V.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === V.ready && (a.error || a.errors) && (a.networkStatus = V.error), globalThis.__DEV__ !== !1 && !c.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && Ta(c.missing);
      }
      return r && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), o = this.queryManager.dataMasking, a = o ? i.nonReactiveQuery : this.query, s = o || i.hasNonreactiveDirective ? !aa(a, this.last.result, r, this.variables) : !B(this.last.result, r);
      return s || n && !B(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || B(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return globalThis.__DEV__ !== !1 && Xe("getLastResult", function() {
        globalThis.__DEV__ !== !1 && D.warn(24);
      }), this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return globalThis.__DEV__ !== !1 && Xe("getLastError", function() {
        globalThis.__DEV__ !== !1 && D.warn(25);
      }), this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && Xe("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && D.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && D.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, o = this.options.fetchPolicy;
      if (o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && hl.call(r, "variables")) {
        var a = Co(this.query), s = a.variableDefinitions;
        (!s || !s.some(function(u) {
          return u.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && D.warn(
          28,
          r,
          ((n = a.name) === null || n === void 0 ? void 0 : n.value) || a
        );
      }
      return r && !B(this.options.variables, r) && (i.variables = this.options.variables = v(v({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, V.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = v(v({}, r.query ? r : v(v(v(v({}, this.options), { query: this.options.query }), r), { variables: v(v({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var o = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var a = this.queryInfo, s = a.networkStatus;
      a.networkStatus = V.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var u = /* @__PURE__ */ new Set(), c = r == null ? void 0 : r.updateQuery, l = this.options.fetchPolicy !== "no-cache";
      return l || D(c, 29), this.queryManager.fetchQuery(o, i, V.fetchMore).then(function(h) {
        if (n.queryManager.removeQuery(o), a.networkStatus === V.fetchMore && (a.networkStatus = s), l)
          n.queryManager.cache.batch({
            update: function(p) {
              var m = r.updateQuery;
              m ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(g) {
                return m(g, {
                  fetchMoreResult: h.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: h.data
              });
            },
            onWatchUpdated: function(p) {
              u.add(p.query);
            }
          });
        else {
          var d = n.getLast("result"), f = c(d.data, {
            fetchMoreResult: h.data,
            variables: i.variables
          });
          n.reportResult(v(v({}, d), { networkStatus: s, loading: lt(s), data: f }), n.variables);
        }
        return n.maskResult(h);
      }).finally(function() {
        l && !u.has(n.query) && n.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(o) {
          var a = r.updateQuery;
          a && n.updateQuery(function(s, u) {
            return a(s, v({ subscriptionData: o }, u));
          });
        },
        error: function(o) {
          if (r.onError) {
            r.onError(o);
            return;
          }
          globalThis.__DEV__ !== !1 && D.error(30, o);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return globalThis.__DEV__ !== !1 && (ee(r, "canonizeResults", "setOptions"), Xe("setOptions", function() {
        globalThis.__DEV__ !== !1 && D.warn(31);
      })), this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = wt(this.options, r || {});
      Ui(this.options, n);
    }, t.prototype.setVariables = function(r) {
      var n = this;
      return B(this.variables, r) ? this.observers.size ? fe("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, V.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), o = i.result, a = i.complete, s = r(o, {
        variables: this.variables,
        complete: !!a,
        previousData: o
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, o = i === void 0 ? "cache-first" : i, a = n.initialFetchPolicy, s = a === void 0 ? o : a;
        o === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(o, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      var o = this._getOrCreateQuery();
      return o.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(o, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, o = n.options.pollInterval;
        if (!o || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === o)) {
          D(o, 32);
          var a = i || (this.pollingInfo = {});
          a.interval = o;
          var s = function() {
            var c, l;
            r.pollingInfo && (!lt(r.queryInfo.networkStatus) && !(!((l = (c = r.options).skipPollAttempt) === null || l === void 0) && l.call(c)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, V.poll).then(u, u) : u());
          }, u = function() {
            var c = r.pollingInfo;
            c && (clearTimeout(c.timeout), c.timeout = setTimeout(s, c.interval));
          };
          u();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var o = fe("getLastError", function() {
        return i.getLastError();
      });
      return o && this.last && !B(n, this.last.variables) && (o = void 0), this.last = v({ result: this.queryManager.assumeImmutableResults ? r : Xo(r), variables: n }, o ? { error: o } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var o = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === V.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === V.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === V.poll
      ), a = this.options.variables, s = this.options.fetchPolicy, u = wt(this.options, r || {}), c = o ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        u
      ) : Ui(this.options, u), l = this.transformDocument(c.query);
      this.lastQuery = l, o || (this.updatePolling(), r && r.variables && !B(r.variables, a) && // Don't mess with the fetchPolicy if it's currently "standby".
      c.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (c.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof c.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", c), n === void 0 && (n = V.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = qr(c.fetchPolicy));
      var h = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, d = c.variables && v({}, c.variables), f = this.fetch(c, n, l), p = f.concast, m = f.fromLink, g = {
        next: function(y) {
          B(i.variables, d) && (h(), i.reportResult(y, d));
        },
        error: function(y) {
          B(i.variables, d) && (na(y) || (y = new $e({ networkError: y })), h(), i.reportError(y, d));
        }
      };
      return !o && (m || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = g), p.addObserver(g), p;
    }, t.prototype.reobserve = function(r, n) {
      return ec(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = this.last;
      fe("resetLastResults", function() {
        return r.resetLastResults();
      });
      var a = this.subscribe.apply(this, n);
      return this.last = o, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this, o = fe("getLastError", function() {
        return i.getLastError();
      }), a = this.isDifferentFromLastResult(r, n);
      (o || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (o || a) && jt(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = this, o = v(v({}, fe("getLastResult", function() {
        return i.getLastResult();
      })), { error: r, errors: r.graphQLErrors, networkStatus: V.error, loading: !1 });
      this.updateLastResult(o, n), jt(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? v(v({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var r = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !lt(this.queryInfo.networkStatus))) {
        var r = this.queryInfo.getDiff();
        r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(o, a) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(o, a) : n;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new Tt(), t;
  })(Q)
);
ea(sr);
function dl(e) {
  globalThis.__DEV__ !== !1 && D.error(33, e.message, e.stack);
}
function Ta(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && D.debug(34, e);
}
function qr(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var ft = new (nt ? WeakMap : Map)();
function Zr(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return ft.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (ft.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
var Qr = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      ft.has(n) || (ft.set(n, 0), Zr(n, "evict"), Zr(n, "modify"), Zr(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || V.loading;
      return this.variables && this.networkStatus !== V.loading && !B(this.variables, t.variables) && (r = V.setVariables), B(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, r = this.getDiffOptions();
      if (this.lastDiff && B(r, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = fe("canonizeResults", function() {
        return t.cache.diff(r);
      });
      return this.updateLastDiff(i, r), i;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && fe("getLastError", function() {
        var o;
        return (o = r.observableQuery) === null || o === void 0 ? void 0 : o.getLastError();
      }) || (this.updateLastDiff(t), B(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var r = this.observableQuery;
        r && r.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = v(v({}, this.getDiffOptions(t)), { watcher: this, callback: function(o) {
          return r.setDiff(o);
        } });
        (!this.lastWatch || !B(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === ft.get(this.cache) && B(r, n.variables) && B(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var o = this, a, s = new Qe(), u = Ie(t.errors) ? t.errors.slice(0) : [];
      if ((a = this.observableQuery) === null || a === void 0 || a.resetNotifications(), "incremental" in t && Ie(t.incremental)) {
        var c = ta(this.getDiff().result, t);
        t.data = c;
      } else if ("hasNext" in t && t.hasNext) {
        var l = this.getDiff();
        t.data = s.merge(l.result, t.data);
      }
      this.graphQLErrors = u, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (mn(t, n.errorPolicy) ? this.cache.performTransaction(function(h) {
        if (o.shouldWrite(t, n.variables))
          h.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), o.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: ft.get(o.cache)
          };
        else if (o.lastDiff && o.lastDiff.diff.complete) {
          t.data = o.lastDiff.diff.result;
          return;
        }
        var d = o.getDiffOptions(n.variables), f = fe("canonizeResults", function() {
          return h.diff(d);
        });
        !o.stopped && B(o.variables, n.variables) && o.updateWatch(n.variables), o.updateLastDiff(f, d), f.complete && (t.data = f.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = V.ready;
    }, e.prototype.markError = function(t) {
      var r;
      return this.networkStatus = V.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function mn(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !ir(e);
  return !n && r && e.data && (n = !0), n;
}
var pl = Object.prototype.hasOwnProperty, Bi = /* @__PURE__ */ Object.create(null), vl = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new Do(
        Fe["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Ne(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new Bo(
        function(o) {
          return r.cache.transformDocument(o);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(ve(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return xe(this, arguments, void 0, function(r) {
        var n, i, o, a, s, u, c, l = r.mutation, h = r.variables, d = r.optimisticResponse, f = r.updateQueries, p = r.refetchQueries, m = p === void 0 ? [] : p, g = r.awaitRefetchQueries, y = g === void 0 ? !1 : g, b = r.update, w = r.onQueryUpdated, k = r.fetchPolicy, S = k === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.fetchPolicy) || "network-only" : k, T = r.errorPolicy, P = T === void 0 ? ((c = this.defaultOptions.mutate) === null || c === void 0 ? void 0 : c.errorPolicy) || "none" : T, R = r.keepRootFields, x = r.context;
        return Me(this, function(L) {
          switch (L.label) {
            case 0:
              return D(l, 36), D(S === "network-only" || S === "no-cache", 37), n = this.generateMutationId(), l = this.cache.transformForLink(this.transform(l)), i = this.getDocumentInfo(l).hasClientExports, h = this.getVariables(l, h), i ? [4, this.localState.addExportedVariables(l, h, x)] : [3, 2];
            case 1:
              h = L.sent(), L.label = 2;
            case 2:
              return o = this.mutationStore && (this.mutationStore[n] = {
                mutation: l,
                variables: h,
                loading: !0,
                error: null
              }), a = d && this.markMutationOptimistic(d, {
                mutationId: n,
                document: l,
                variables: h,
                fetchPolicy: S,
                errorPolicy: P,
                context: x,
                updateQueries: f,
                update: b,
                keepRootFields: R
              }), this.broadcastQueries(), s = this, [2, new Promise(function(Ee, me) {
                return Ar(s.getObservableFromLink(l, v(v({}, x), { optimisticResponse: a ? d : void 0 }), h, {}, !1), function(Y) {
                  if (ir(Y) && P === "none")
                    throw new $e({
                      graphQLErrors: an(Y)
                    });
                  o && (o.loading = !1, o.error = null);
                  var he = v({}, Y);
                  return typeof m == "function" && (m = m(he)), P === "ignore" && ir(he) && delete he.errors, s.markMutationResult({
                    mutationId: n,
                    result: he,
                    document: l,
                    variables: h,
                    fetchPolicy: S,
                    errorPolicy: P,
                    context: x,
                    update: b,
                    updateQueries: f,
                    awaitRefetchQueries: y,
                    refetchQueries: m,
                    removeOptimistic: a ? n : void 0,
                    onQueryUpdated: w,
                    keepRootFields: R
                  });
                }).subscribe({
                  next: function(Y) {
                    s.broadcastQueries(), (!("hasNext" in Y) || Y.hasNext === !1) && Ee(v(v({}, Y), { data: s.maskOperation({
                      document: l,
                      data: Y.data,
                      fetchPolicy: S,
                      id: n
                    }) }));
                  },
                  error: function(Y) {
                    o && (o.loading = !1, o.error = Y), a && s.cache.removeOptimistic(n), s.broadcastQueries(), me(Y instanceof $e ? Y : new $e({
                      networkError: Y
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, o = [], a = t.fetchPolicy === "no-cache";
      if (!a && mn(i, t.errorPolicy)) {
        if (pt(i) || o.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), pt(i) && Ie(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), u = void 0;
          s.result && (u = ta(s.result, i)), typeof u < "u" && (i.data = u, o.push({
            result: u,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var c = t.updateQueries;
        c && this.queries.forEach(function(h, d) {
          var f = h.observableQuery, p = f && f.queryName;
          if (!(!p || !pl.call(c, p))) {
            var m = c[p], g = n.queries.get(d), y = g.document, b = g.variables, w = r.diff({
              query: y,
              variables: b,
              returnPartialData: !0,
              optimistic: !1
            }), k = w.result, S = w.complete;
            if (S && k) {
              var T = m(k, {
                mutationResult: i,
                queryName: y && Nt(y) || void 0,
                queryVariables: b
              });
              T && o.push({
                result: T,
                dataId: "ROOT_QUERY",
                query: y,
                variables: b
              });
            }
          }
        });
      }
      if (o.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var l = [];
        if (this.refetchQueries({
          updateCache: function(h) {
            a || o.forEach(function(m) {
              return h.write(m);
            });
            var d = t.update, f = !oc(i) || pt(i) && !i.hasNext;
            if (d) {
              if (!a) {
                var p = h.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = v(v({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              f && d(h, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !a && !t.keepRootFields && f && h.modify({
              id: "ROOT_MUTATION",
              fields: function(m, g) {
                var y = g.fieldName, b = g.DELETE;
                return y === "__typename" ? m : b;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(h) {
          return l.push(h);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(l).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: Bi }) : t;
      return i === Bi ? !1 : (this.cache.recordOptimisticTransaction(function(o) {
        try {
          n.markMutationResult(v(v({}, r), { result: { data: i } }), o);
        } catch (a) {
          globalThis.__DEV__ !== !1 && D.error(a);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: Vs(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: Vt(["nonreactive"], t),
          nonReactiveQuery: Zu(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: Jo([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: On(et(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: v(v({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? v(v({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return v(v({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = v(v({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new Qr(this), i = new sr({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, sr.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), D(t.query, 38), D(t.query.kind === "Document", 39), D(!t.returnPartialData, 40), D(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(r, v(v({}, t), { query: i })).then(function(o) {
        return o && v(v({}, o), { data: n.maskOperation({
          document: i,
          data: o.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(ve(42)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = V.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), o.set(s, !1);
        else if (vu(s)) {
          var u = Le(r.transform(s));
          i.set(u, Nt(s)), o.set(u, !1);
        } else W(s) && s.query && a.add(s);
      }), this.queries.forEach(function(s, u) {
        var c = s.observableQuery, l = s.document;
        if (c) {
          if (t === "all") {
            n.set(u, c);
            return;
          }
          var h = c.queryName, d = c.options.fetchPolicy;
          if (d === "standby" || t === "active" && !c.hasObservers())
            return;
          (t === "active" || h && o.has(h) || l && o.has(Le(l))) && (n.set(u, c), h && o.set(h, !0), l && o.set(Le(l), !0));
        }
      }), a.size && a.forEach(function(s) {
        var u = Gr("legacyOneTimeQuery"), c = r.getOrCreateQuery(u).init({
          document: s.query,
          variables: s.variables
        }), l = new sr({
          queryManager: r,
          queryInfo: c,
          options: v(v({}, s), { fetchPolicy: "network-only" })
        });
        D(l.queryId === u), c.setObservableQuery(l), n.set(u, l);
      }), globalThis.__DEV__ !== !1 && o.size && o.forEach(function(s, u) {
        if (!s) {
          var c = i.get(u);
          c ? globalThis.__DEV__ !== !1 && D.warn(43, c) : globalThis.__DEV__ !== !1 && D.warn(44);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, o) {
        var a = i.options.fetchPolicy;
        fe("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || a !== "standby" && a !== "cache-only") && n.push(i.refetch()), (r.queries.get(o) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, o = t.fetchPolicy, a = t.errorPolicy, s = a === void 0 ? "none" : a, u = t.context, c = u === void 0 ? {} : u, l = t.extensions, h = l === void 0 ? {} : l;
      n = this.transform(n), i = this.getVariables(n, i);
      var d = function(p) {
        return r.getObservableFromLink(n, c, p, h).map(function(m) {
          o !== "no-cache" && (mn(m, s) && r.cache.write({
            query: n,
            result: m.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var g = ir(m), y = Oc(m);
          if (g || y) {
            var b = {};
            if (g && (b.graphQLErrors = m.errors), y && (b.protocolErrors = m.extensions[Nn]), s === "none" || y)
              throw new $e(b);
          }
          return s === "ignore" && delete m.errors, m;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var f = this.localState.addExportedVariables(n, i, c).then(d);
        return new Q(function(p) {
          var m = null;
          return f.then(function(g) {
            return m = g.subscribe(p);
          }, p.error), function() {
            return m && m.unsubscribe();
          };
        });
      }
      return d(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var r;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var r;
        return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, o) {
      var a = this, s;
      o === void 0 && (o = (s = r == null ? void 0 : r.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var u, c = this.getDocumentInfo(t), l = c.serverQuery, h = c.clientQuery;
      if (l) {
        var d = this, f = d.inFlightLinkObservables, p = d.link, m = {
          query: l,
          variables: n,
          operationName: Nt(l) || void 0,
          context: this.prepareContext(v(v({}, r), { forceFetch: !o })),
          extensions: i
        };
        if (r = m.context, o) {
          var g = Le(l), y = Ve(n), b = f.lookup(g, y);
          if (u = b.observable, !u) {
            var w = new st([
              cn(p, m)
            ]);
            u = b.observable = w, w.beforeNext(function k(S, T) {
              S === "next" && "hasNext" in T && T.hasNext ? w.beforeNext(k) : f.remove(g, y);
            });
          }
        } else
          u = new st([
            cn(p, m)
          ]);
      } else
        u = new st([Q.of({ data: {} })]), r = this.prepareContext(r);
      return h && (u = Ar(u, function(k) {
        return a.localState.runResolvers({
          document: h,
          remoteResult: k,
          context: r,
          variables: n
        });
      })), u;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(n.query);
      return Ar(this.getObservableFromLink(o, n.context, n.variables), function(a) {
        var s = an(a), u = s.length > 0, c = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (u && c === "none")
            throw t.markError(new $e({
              graphQLErrors: s
            }));
          t.markResult(a, o, n, r), t.markReady();
        }
        var l = {
          data: a.data,
          loading: !1,
          networkStatus: V.ready
        };
        return u && c === "none" && (l.data = void 0), u && c !== "ignore" && (l.errors = s, l.networkStatus = V.error), l;
      }, function(a) {
        var s = na(a) ? a : new $e({ networkError: a });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var o = this;
      n === void 0 && (n = V.loading), i === void 0 && (i = r.query);
      var a = this.getVariables(i, r.variables), s = this.defaultOptions.watchQuery, u = r.fetchPolicy, c = u === void 0 ? s && s.fetchPolicy || "cache-first" : u, l = r.errorPolicy, h = l === void 0 ? s && s.errorPolicy || "none" : l, d = r.returnPartialData, f = d === void 0 ? !1 : d, p = r.notifyOnNetworkStatusChange, m = p === void 0 ? !1 : p, g = r.context, y = g === void 0 ? {} : g, b = Object.assign({}, r, {
        query: i,
        variables: a,
        fetchPolicy: c,
        errorPolicy: h,
        returnPartialData: f,
        notifyOnNetworkStatusChange: m,
        context: y
      }), w = function(R) {
        b.variables = R;
        var x = o.fetchQueryByPolicy(t, b, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          b.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          x.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), x
        );
      }, k = function() {
        return o.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(R) {
        k(), setTimeout(function() {
          return S.cancel(R);
        });
      });
      var S, T;
      if (this.getDocumentInfo(b.query).hasClientExports)
        S = new st(this.localState.addExportedVariables(b.query, b.variables, b.context).then(w).then(function(R) {
          return R.sources;
        })), T = !0;
      else {
        var P = w(b.variables);
        T = P.fromLink, S = new st(P.sources);
      }
      return S.promise.then(k, k), {
        concast: S,
        fromLink: T
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, o = t.optimistic, a = o === void 0 ? !1 : o, s = t.removeOptimistic, u = s === void 0 ? a ? Gr("refetchQueries") : void 0 : s, c = t.onQueryUpdated, l = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(d, f) {
        l.set(f, {
          oq: d,
          lastDiff: (r.queries.get(f) || d.queryInfo).getDiff()
        });
      });
      var h = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: a && u || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: u,
        onWatchUpdated: function(d, f, p) {
          var m = d.watcher instanceof Qr && d.watcher.observableQuery;
          if (m) {
            if (c) {
              l.delete(m.queryId);
              var g = c(m, f, p);
              return g === !0 && (g = m.refetch()), g !== !1 && h.set(m, g), g;
            }
            c !== null && l.set(m.queryId, { oq: m, lastDiff: p, diff: f });
          }
        }
      }), l.size && l.forEach(function(d, f) {
        var p = d.oq, m = d.lastDiff, g = d.diff, y;
        c && (g || (g = fe("canonizeResults", function() {
          return r.cache.diff(p.queryInfo.getDiffOptions());
        })), y = c(p, g, m)), (!c || y === !0) && (y = p.refetch()), y !== !1 && h.set(p, y), f.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(f);
      }), u && this.cache.removeOptimistic(u), h;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, o = t.document, a = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, u = t.id, c = (r = et(o)) === null || r === void 0 ? void 0 : r.operation, l = ((n = c == null ? void 0 : c[0]) !== null && n !== void 0 ? n : "o") + u;
        this.dataMasking && s === "no-cache" && !Hs(o) && !this.noCacheWarningsByQueryId.has(l) && (this.noCacheWarningsByQueryId.add(l), globalThis.__DEV__ !== !1 && D.warn(
          45,
          (i = Nt(o)) !== null && i !== void 0 ? i : "Unnamed ".concat(c ?? "operation")
        ));
      }
      return this.dataMasking ? Gc(a, o, this.cache) : a;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? fa(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, o = r.query, a = r.variables, s = r.fetchPolicy, u = r.refetchWritePolicy, c = r.errorPolicy, l = r.returnPartialData, h = r.context, d = r.notifyOnNetworkStatusChange, f = t.networkStatus;
      t.init({
        document: o,
        variables: a,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, m = function(k, S) {
        S === void 0 && (S = t.networkStatus || V.loading);
        var T = k.result;
        globalThis.__DEV__ !== !1 && !l && !B(T, {}) && Ta(k.missing);
        var P = function(R) {
          return Q.of(v({ data: R, loading: lt(S), networkStatus: S }, k.complete ? null : { partial: !0 }));
        };
        return T && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
          document: o,
          remoteResult: { data: T },
          context: h,
          variables: a,
          onlyRunForcedResolvers: !0
        }).then(function(R) {
          return P(R.data || void 0);
        }) : c === "none" && S === V.refetch && Array.isArray(k.missing) ? P(void 0) : P(T);
      }, g = s === "no-cache" ? 0 : n === V.refetch && u !== "merge" ? 1 : 2, y = function() {
        return i.getResultsFromLink(t, g, {
          query: o,
          variables: a,
          context: h,
          fetchPolicy: s,
          errorPolicy: c
        });
      }, b = d && typeof f == "number" && f !== n && lt(n);
      switch (s) {
        default:
        case "cache-first": {
          var w = p();
          return w.complete ? {
            fromLink: !1,
            sources: [m(w, t.markReady())]
          } : l || b ? {
            fromLink: !0,
            sources: [m(w), y()]
          } : { fromLink: !0, sources: [y()] };
        }
        case "cache-and-network": {
          var w = p();
          return w.complete || l || b ? {
            fromLink: !0,
            sources: [m(w), y()]
          } : { fromLink: !0, sources: [y()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [m(p(), t.markReady())]
          };
        case "network-only":
          return b ? {
            fromLink: !0,
            sources: [m(p()), y()]
          } : { fromLink: !0, sources: [y()] };
        case "no-cache":
          return b ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [m(t.getDiff()), y()]
          } : { fromLink: !0, sources: [y()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Qr(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return v(v(v({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), ml = (
  /** @class */
  (function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, o = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = hi(r.resolvers, n);
      }) : this.resolvers = hi(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return xe(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, o = r.context, a = r.variables, s = r.onlyRunForcedResolvers, u = s === void 0 ? !1 : s;
        return Me(this, function(c) {
          return n ? [2, this.resolveDocument(n, i.data, o, a, this.fragmentMatcher, u).then(function(l) {
            return v(v({}, i), { data: l.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return Vt(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return Go(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return v(v({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return xe(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Me(this, function(o) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(a) {
            return v(v({}, n), a.exportedVariables);
          })] : [2, v({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return Te(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return br;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: qu(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return xe(this, arguments, void 0, function(n, i, o, a, s, u) {
        var c, l, h, d, f, p, m, g, y, b, w;
        return o === void 0 && (o = {}), a === void 0 && (a = {}), s === void 0 && (s = function() {
          return !0;
        }), u === void 0 && (u = !1), Me(this, function(k) {
          return c = Ot(n), l = St(n), h = Et(l), d = this.collectSelectionsToResolve(c, h), f = c.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", m = this, g = m.cache, y = m.client, b = {
            fragmentMap: h,
            context: v(v({}, o), { cache: g, client: y }),
            variables: a,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: d,
            onlyRunForcedResolvers: u
          }, w = !1, [2, this.resolveSelectionSet(c.selectionSet, w, i, b).then(function(S) {
            return {
              result: S,
              exportedVariables: b.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return xe(this, void 0, void 0, function() {
        var o, a, s, u, c, l = this;
        return Me(this, function(h) {
          return o = i.fragmentMap, a = i.context, s = i.variables, u = [n], c = function(d) {
            return xe(l, void 0, void 0, function() {
              var f, p;
              return Me(this, function(m) {
                return !r && !i.selectionsToResolve.has(d) ? [
                  2
                  /*return*/
                ] : Wt(d, s) ? qe(d) ? [2, this.resolveField(d, r, n, i).then(function(g) {
                  var y;
                  typeof g < "u" && u.push((y = {}, y[Ce(d)] = g, y));
                })] : (Du(d) ? f = d : (f = o[d.name.value], D(f, 21, d.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, i.fragmentMatcher(n, p, a)) ? [2, this.resolveSelectionSet(f.selectionSet, r, n, i).then(function(g) {
                  u.push(g);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(c)).then(function() {
            return Or(u);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return xe(this, void 0, void 0, function() {
        var o, a, s, u, c, l, h, d, f, p = this;
        return Me(this, function(m) {
          return n ? (o = i.variables, a = t.name.value, s = Ce(t), u = a !== s, c = n[s] || n[a], l = Promise.resolve(c), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (h = n.__typename || i.defaultOperationType, d = this.resolvers && this.resolvers[h], d && (f = d[u ? a : s], f && (l = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            xn.withValue(this.cache, f, [
              n,
              Er(t, o),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, l.then(function(g) {
            var y, b;
            if (g === void 0 && (g = c), t.directives && t.directives.forEach(function(k) {
              k.name.value === "export" && k.arguments && k.arguments.forEach(function(S) {
                S.name.value === "as" && S.value.kind === "StringValue" && (i.exportedVariables[S.value.value] = g);
              });
            }), !t.selectionSet || g == null)
              return g;
            var w = (b = (y = t.directives) === null || y === void 0 ? void 0 : y.some(function(k) {
              return k.name.value === "client";
            })) !== null && b !== void 0 ? b : !1;
            if (Array.isArray(g))
              return p.resolveSubSelectedArray(t, r || w, g, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || w, g, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var o = this;
      return Promise.all(n.map(function(a) {
        if (a === null)
          return null;
        if (Array.isArray(a))
          return o.resolveSubSelectedArray(t, r, a, i);
        if (t.selectionSet)
          return o.resolveSelectionSet(t.selectionSet, r, a, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(a) {
        return !Array.isArray(a);
      }, i = this.selectionsToResolveCache;
      function o(a) {
        if (!i.has(a)) {
          var s = /* @__PURE__ */ new Set();
          i.set(a, s), Te(a, {
            Directive: function(u, c, l, h, d) {
              u.name.value === "client" && d.forEach(function(f) {
                n(f) && ni(f) && s.add(f);
              });
            },
            FragmentSpread: function(u, c, l, h, d) {
              var f = r[u.name.value];
              D(f, 22, u.name.value);
              var p = o(f);
              p.size > 0 && (d.forEach(function(m) {
                n(m) && ni(m) && s.add(m);
              }), s.add(u), p.forEach(function(m) {
                s.add(m);
              }));
            }
          });
        }
        return i.get(a);
      }
      return o(t);
    }, e;
  })()
), Wi = !1, Da = (
  /** @class */
  (function() {
    function e(t) {
      var r = this, n, i, o;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw ve(16);
      var a = t.uri, s = t.credentials, u = t.headers, c = t.cache, l = t.documentTransform, h = t.ssrMode, d = h === void 0 ? !1 : h, f = t.ssrForceFetchDelay, p = f === void 0 ? 0 : f, m = t.connectToDevTools, g = t.queryDeduplication, y = g === void 0 ? !0 : g, b = t.defaultOptions, w = t.defaultContext, k = t.assumeImmutableResults, S = k === void 0 ? c.assumeImmutableResults : k, T = t.resolvers, P = t.typeDefs, R = t.fragmentMatcher, x = t.clientAwareness, L = t.name, Ee = t.version, me = t.devtools, Y = t.dataMasking;
      globalThis.__DEV__ !== !1 && (ee(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), ee(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), ee(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), ee(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), ee(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), ee(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), ee(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && D.warn(17));
      var he = t.link;
      he || (he = a ? new oa({ uri: a, credentials: s, headers: u }) : Be.empty()), this.link = he, this.cache = c, this.disableNetworkFetches = d || p > 0, this.queryDeduplication = y, this.defaultOptions = b || /* @__PURE__ */ Object.create(null), this.typeDefs = P, this.devtoolsConfig = v(v({}, me), { enabled: (n = me == null ? void 0 : me.enabled) !== null && n !== void 0 ? n : m }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), p && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, p), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = wn, this.localState = new ml({
        cache: c,
        client: this,
        resolvers: T,
        fragmentMatcher: R
      }), this.queryManager = new vl({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: w,
        documentTransform: l,
        queryDeduplication: y,
        ssrMode: d,
        dataMasking: !!Y,
        clientAwareness: {
          name: (i = x == null ? void 0 : x.name) !== null && i !== void 0 ? i : L,
          version: (o = x == null ? void 0 : x.version) !== null && o !== void 0 ? o : Ee
        },
        localState: this.localState,
        assumeImmutableResults: S,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !Wi && globalThis.__DEV__ !== !1 && (Wi = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, o = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? o = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (o = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), o && globalThis.__DEV__ !== !1 && D.log("Download the Apollo DevTools for a better development experience: %s", o);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = xr(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = v(v({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (ee(t, "canonizeResults", "client.watchQuery"), ee(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = xr(this.defaultOptions.query, t)), D(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = v(v({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (ee(t, "canonizeResults", "client.query"), ee(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && D.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = xr(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return v(v({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(v(v({}, t), (r = {}, r[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return cn(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(a, s) {
        n.push(s), i.push(a);
      });
      var o = Promise.all(i);
      return o.queries = n, o.results = i, o.catch(function(a) {
        globalThis.__DEV__ !== !1 && D.debug(20, a);
      }), o;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (Da.prototype.getMemoryInternals = au);
function yl(e) {
  return W(e) && "code" in e && "reason" in e;
}
function gl(e) {
  var t;
  return W(e) && ((t = e.target) === null || t === void 0 ? void 0 : t.readyState) === WebSocket.CLOSED;
}
var bl = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.client = r, n;
    }
    return t.prototype.request = function(r) {
      var n = this;
      return new Q(function(i) {
        return n.client.subscribe(v(v({}, r), { query: Le(r.query) }), {
          next: i.next.bind(i),
          complete: i.complete.bind(i),
          error: function(o) {
            if (o instanceof Error)
              return i.error(o);
            var a = yl(o);
            return a || gl(o) ? i.error(
              // reason will be available on clean closes
              new Error("Socket closed".concat(a ? " with event ".concat(o.code) : "").concat(a ? " ".concat(o.reason) : ""))
            ) : i.error(new $e({
              graphQLErrors: Array.isArray(o) ? o : [o]
            }));
          }
          // casting around a wrong type in graphql-ws, which incorrectly expects `Sink<ExecutionResult>`
        });
      });
    }, t;
  })(Be)
);
function ye(e) {
  return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
function He(e) {
  return ye(e) === "object";
}
function _l(e) {
  return Array.isArray(e) && // must be at least one error
  e.length > 0 && // error has at least a message
  e.every((t) => "message" in t);
}
function Ji(e, t) {
  return e.length < 124 ? e : t;
}
const wl = "graphql-transport-ws";
var be;
(function(e) {
  e[e.InternalServerError = 4500] = "InternalServerError", e[e.InternalClientError = 4005] = "InternalClientError", e[e.BadRequest = 4400] = "BadRequest", e[e.BadResponse = 4004] = "BadResponse", e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e[e.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", e[e.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", e[e.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", e[e.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", e[e.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(be || (be = {}));
var te;
(function(e) {
  e.ConnectionInit = "connection_init", e.ConnectionAck = "connection_ack", e.Ping = "ping", e.Pong = "pong", e.Subscribe = "subscribe", e.Next = "next", e.Error = "error", e.Complete = "complete";
})(te || (te = {}));
function Ia(e) {
  if (!He(e))
    throw new Error(`Message is expected to be an object, but got ${ye(e)}`);
  if (!e.type)
    throw new Error("Message is missing the 'type' property");
  if (typeof e.type != "string")
    throw new Error(`Message is expects the 'type' property to be a string, but got ${ye(e.type)}`);
  switch (e.type) {
    case te.ConnectionInit:
    case te.ConnectionAck:
    case te.Ping:
    case te.Pong: {
      if (e.payload != null && !He(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${e.payload}"`);
      break;
    }
    case te.Subscribe: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ye(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!He(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object, but got ${ye(e.payload)}`);
      if (typeof e.payload.query != "string")
        throw new Error(`"${e.type}" message payload expects the 'query' property to be a string, but got ${ye(e.payload.query)}`);
      if (e.payload.variables != null && !He(e.payload.variables))
        throw new Error(`"${e.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${ye(e.payload.variables)}`);
      if (e.payload.operationName != null && ye(e.payload.operationName) !== "string")
        throw new Error(`"${e.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${ye(e.payload.operationName)}`);
      if (e.payload.extensions != null && !He(e.payload.extensions))
        throw new Error(`"${e.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${ye(e.payload.extensions)}`);
      break;
    }
    case te.Next: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ye(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!He(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object, but got ${ye(e.payload)}`);
      break;
    }
    case te.Error: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ye(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!_l(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(e.payload)}`);
      break;
    }
    case te.Complete: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ye(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      break;
    }
    default:
      throw new Error(`Invalid message 'type' property "${e.type}"`);
  }
  return e;
}
function El(e, t) {
  return Ia(typeof e == "string" ? JSON.parse(e, t) : e);
}
function Ct(e, t) {
  return Ia(e), JSON.stringify(e, t);
}
var mt = function(e) {
  return this instanceof mt ? (this.v = e, this) : new mt(e);
}, kl = function(e, t, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(e, t || []), i, o = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), s("next"), s("throw"), s("return", a), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function a(f) {
    return function(p) {
      return Promise.resolve(p).then(f, h);
    };
  }
  function s(f, p) {
    n[f] && (i[f] = function(m) {
      return new Promise(function(g, y) {
        o.push([f, m, g, y]) > 1 || u(f, m);
      });
    }, p && (i[f] = p(i[f])));
  }
  function u(f, p) {
    try {
      c(n[f](p));
    } catch (m) {
      d(o[0][3], m);
    }
  }
  function c(f) {
    f.value instanceof mt ? Promise.resolve(f.value.v).then(l, h) : d(o[0][2], f);
  }
  function l(f) {
    u("next", f);
  }
  function h(f) {
    u("throw", f);
  }
  function d(f, p) {
    f(p), o.shift(), o.length && u(o[0][0], o[0][1]);
  }
};
function Sl(e) {
  const {
    url: t,
    connectionParams: r,
    lazy: n = !0,
    onNonLazyError: i = console.error,
    lazyCloseTimeout: o = 0,
    keepAlive: a = 0,
    disablePong: s,
    connectionAckWaitTimeout: u = 0,
    retryAttempts: c = 5,
    retryWait: l = async function(U) {
      let C = 1e3;
      for (let M = 0; M < U; M++)
        C *= 2;
      await new Promise((M) => setTimeout(M, C + // add random timeout from 300ms to 3s
      Math.floor(Math.random() * 2700 + 300)));
    },
    shouldRetry: h = Ur,
    isFatalConnectionProblem: d,
    on: f,
    webSocketImpl: p,
    /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */
    generateID: m = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (U) => {
        const C = Math.random() * 16 | 0;
        return (U == "x" ? C : C & 3 | 8).toString(16);
      });
    },
    jsonMessageReplacer: g,
    jsonMessageReviver: y
  } = e;
  let b;
  if (p) {
    if (!Tl(p))
      throw new Error("Invalid WebSocket implementation provided");
    b = p;
  } else typeof WebSocket < "u" ? b = WebSocket : typeof global < "u" ? b = global.WebSocket || // @ts-expect-error: Support more browsers
  global.MozWebSocket : typeof window < "u" && (b = window.WebSocket || // @ts-expect-error: Support more browsers
  window.MozWebSocket);
  if (!b)
    throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  const w = b, k = (() => {
    const N = /* @__PURE__ */ (() => {
      const C = {};
      return {
        on(M, A) {
          return C[M] = A, () => {
            delete C[M];
          };
        },
        emit(M) {
          var A;
          "id" in M && ((A = C[M.id]) === null || A === void 0 || A.call(C, M));
        }
      };
    })(), U = {
      connecting: f != null && f.connecting ? [f.connecting] : [],
      opened: f != null && f.opened ? [f.opened] : [],
      connected: f != null && f.connected ? [f.connected] : [],
      ping: f != null && f.ping ? [f.ping] : [],
      pong: f != null && f.pong ? [f.pong] : [],
      message: f != null && f.message ? [N.emit, f.message] : [N.emit],
      closed: f != null && f.closed ? [f.closed] : [],
      error: f != null && f.error ? [f.error] : []
    };
    return {
      onMessage: N.on,
      on(C, M) {
        const A = U[C];
        return A.push(M), () => {
          A.splice(A.indexOf(M), 1);
        };
      },
      emit(C, ...M) {
        for (const A of [...U[C]])
          A(...M);
      }
    };
  })();
  function S(N) {
    const U = [
      // errors are fatal and more critical than close events, throw them first
      k.on("error", (C) => {
        U.forEach((M) => M()), N(C);
      }),
      // closes can be graceful and not fatal, throw them second (if error didnt throw)
      k.on("closed", (C) => {
        U.forEach((M) => M()), N(C);
      })
    ];
  }
  let T, P = 0, R, x = !1, L = 0, Ee = !1;
  async function me() {
    clearTimeout(R);
    const [N, U] = await (T ?? (T = new Promise((A, ce) => (async () => {
      if (x) {
        if (await l(L), !P)
          return T = void 0, ce({ code: 1e3, reason: "All Subscriptions Gone" });
        L++;
      }
      k.emit("connecting", x);
      const $ = new w(typeof t == "function" ? await t() : t, wl);
      let de, Re;
      function Ge() {
        isFinite(a) && a > 0 && (clearTimeout(Re), Re = setTimeout(() => {
          $.readyState === w.OPEN && ($.send(Ct({ type: te.Ping })), k.emit("ping", !1, void 0));
        }, a));
      }
      S((le) => {
        T = void 0, clearTimeout(de), clearTimeout(Re), ce(le), le instanceof Gi && ($.close(4499, "Terminated"), $.onerror = null, $.onclose = null);
      }), $.onerror = (le) => k.emit("error", le), $.onclose = (le) => k.emit("closed", le), $.onopen = async () => {
        try {
          k.emit("opened", $);
          const le = typeof r == "function" ? await r() : r;
          if ($.readyState !== w.OPEN)
            return;
          $.send(Ct(le ? {
            type: te.ConnectionInit,
            payload: le
          } : {
            type: te.ConnectionInit
            // payload is completely absent if not provided
          }, g)), isFinite(u) && u > 0 && (de = setTimeout(() => {
            $.close(be.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
          }, u)), Ge();
        } catch (le) {
          k.emit("error", le), $.close(be.InternalClientError, Ji(le instanceof Error ? le.message : new Error(le).message, "Internal client error"));
        }
      };
      let ot = !1;
      $.onmessage = ({ data: le }) => {
        try {
          const oe = El(le, y);
          if (k.emit("message", oe), oe.type === "ping" || oe.type === "pong") {
            k.emit(oe.type, !0, oe.payload), oe.type === "pong" ? Ge() : s || ($.send(Ct(oe.payload ? {
              type: te.Pong,
              payload: oe.payload
            } : {
              type: te.Pong
              // payload is completely absent if not provided
            })), k.emit("pong", !1, oe.payload));
            return;
          }
          if (ot)
            return;
          if (oe.type !== te.ConnectionAck)
            throw new Error(`First message cannot be of type ${oe.type}`);
          clearTimeout(de), ot = !0, k.emit("connected", $, oe.payload, x), x = !1, L = 0, A([
            $,
            new Promise((gm, bs) => S(bs))
          ]);
        } catch (oe) {
          $.onmessage = null, k.emit("error", oe), $.close(be.BadResponse, Ji(oe instanceof Error ? oe.message : new Error(oe).message, "Bad response"));
        }
      };
    })())));
    N.readyState === w.CLOSING && await U;
    let C = () => {
    };
    const M = new Promise((A) => C = A);
    return [
      N,
      C,
      Promise.race([
        // wait for
        M.then(() => {
          if (!P) {
            const A = () => N.close(1e3, "Normal Closure");
            isFinite(o) && o > 0 ? R = setTimeout(() => {
              N.readyState === w.OPEN && A();
            }, o) : A();
          }
        }),
        // or
        U
      ])
    ];
  }
  function Y(N) {
    if (Ur(N) && (Ol(N.code) || [
      be.InternalServerError,
      be.InternalClientError,
      be.BadRequest,
      be.BadResponse,
      be.Unauthorized,
      // CloseCode.Forbidden, might grant access out after retry
      be.SubprotocolNotAcceptable,
      // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
      // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
      be.SubscriberAlreadyExists,
      be.TooManyInitialisationRequests
      // 4499, // Terminated, probably because the socket froze, we want to retry
    ].includes(N.code)))
      throw N;
    if (Ee)
      return !1;
    if (Ur(N) && N.code === 1e3)
      return P > 0;
    if (!c || L >= c || !h(N) || d != null && d(N))
      throw N;
    return x = !0;
  }
  n || (async () => {
    for (P++; ; )
      try {
        const [, , N] = await me();
        await N;
      } catch (N) {
        try {
          if (!Y(N))
            return;
        } catch (U) {
          return i == null ? void 0 : i(U);
        }
      }
  })();
  function he(N, U) {
    const C = m(N);
    let M = !1, A = !1, ce = () => {
      P--, M = !0;
    };
    return (async () => {
      for (P++; ; )
        try {
          const [$, de, Re] = await me();
          if (M)
            return de();
          const Ge = k.onMessage(C, (ot) => {
            switch (ot.type) {
              case te.Next: {
                U.next(ot.payload);
                return;
              }
              case te.Error: {
                A = !0, M = !0, U.error(ot.payload), ce();
                return;
              }
              case te.Complete: {
                M = !0, ce();
                return;
              }
            }
          });
          $.send(Ct({
            id: C,
            type: te.Subscribe,
            payload: N
          }, g)), ce = () => {
            !M && $.readyState === w.OPEN && $.send(Ct({
              id: C,
              type: te.Complete
            }, g)), P--, M = !0, de();
          }, await Re.finally(Ge);
          return;
        } catch ($) {
          if (!Y($))
            return;
        }
    })().then(() => {
      A || U.complete();
    }).catch(($) => {
      U.error($);
    }), () => {
      M || ce();
    };
  }
  return {
    on: k.on,
    subscribe: he,
    iterate(N) {
      const U = [], C = {
        done: !1,
        error: null,
        resolve: () => {
        }
      }, M = he(N, {
        next(ce) {
          U.push(ce), C.resolve();
        },
        error(ce) {
          C.done = !0, C.error = ce, C.resolve();
        },
        complete() {
          C.done = !0, C.resolve();
        }
      }), A = (function() {
        return kl(this, arguments, function* () {
          for (; ; ) {
            for (U.length || (yield mt(new Promise((de) => C.resolve = de))); U.length; )
              yield yield mt(U.shift());
            if (C.error)
              throw C.error;
            if (C.done)
              return yield mt(void 0);
          }
        });
      })();
      return A.throw = async (ce) => (C.done || (C.done = !0, C.error = ce, C.resolve()), { done: !0, value: void 0 }), A.return = async () => (M(), { done: !0, value: void 0 }), A;
    },
    async dispose() {
      if (Ee = !0, T) {
        const [N] = await T;
        N.close(1e3, "Normal Closure");
      }
    },
    terminate() {
      T && k.emit("closed", new Gi());
    }
  };
}
class Gi extends Error {
  constructor() {
    super(...arguments), this.name = "TerminatedCloseEvent", this.message = "4499: Terminated", this.code = 4499, this.reason = "Terminated", this.wasClean = !1;
  }
}
function Ur(e) {
  return He(e) && "code" in e && "reason" in e;
}
function Ol(e) {
  return [
    1e3,
    // Normal Closure is not an erroneous close code
    1001,
    // Going Away
    1006,
    // Abnormal Closure
    1005,
    // No Status Received
    1012,
    // Service Restart
    1013,
    // Try Again Later
    1014
    // Bad Gateway
  ].includes(e) ? !1 : e >= 1e3 && e <= 1999;
}
function Tl(e) {
  return typeof e == "function" && "constructor" in e && "CLOSED" in e && "CLOSING" in e && "CONNECTING" in e && "OPEN" in e;
}
const Dl = (e, t) => {
  const r = new oa({
    credentials: "include",
    uri: e
  }), n = new bl(Sl({
    url: t,
    lazy: !0
  })), i = pc(({ query: a }) => {
    const s = Ot(a);
    return s.kind === "OperationDefinition" && s.operation === "subscription";
  }, n, r);
  return new Da({
    cache: new Oa(),
    link: dc([i]),
    credentials: "include"
  });
};
class km {
  constructor(t, r) {
    It(this, "endpoint");
    It(this, "apolloClient");
    It(this, "uploadToS3", async (t, r, n) => {
      const i = {};
      return new Q((o) => {
        const a = new FormData(), { url: s } = i.data.presignedFormData, u = JSON.parse(i.data.presignedFormData.fields);
        Object.keys(u).forEach((l) => {
          a.append(l, u[l]);
        }), a.append("file", t);
        const c = new XMLHttpRequest();
        c.open("POST", s), c.upload.addEventListener("progress", (l) => {
          const h = l.loaded / l.total;
          o.next({ progress: h });
        }), c.upload.addEventListener("load", () => {
          c.upload.removeEventListener("progress", () => null), o.complete();
        }), c.send(a);
      });
    });
    this.endpoint = t;
    try {
      this.apolloClient = Dl(`${t}/graphql`, `${r}`);
    } catch (n) {
      throw console.error(n), new Error("Failed to create apollo client");
    }
  }
  downloadS3File(t, r = null) {
    return new Promise((n) => {
      const i = `${this.endpoint}/download?bucket=${t.bucket}&key=${t.key}&isFolder=${t.isFolder ? 1 : 0}${r ? `&limit=${r}` : ""}`, o = new XMLHttpRequest();
      o.withCredentials = !0, o.open("GET", i, !0), o.setRequestHeader("Content-Type", "application/json"), o.responseType = "blob", o.addEventListener("load", function() {
        return n(this.response);
      }), o.send(JSON.stringify({ ...t, limit: r }));
    });
  }
  async refreshToken() {
    fetch(`${this.endpoint}/refreshToken`, {
      method: "POST",
      credentials: "include"
    });
  }
}
function E(e, t, r) {
  function n(s, u) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: u,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, u);
    const c = a.prototype, l = Object.keys(c);
    for (let h = 0; h < l.length; h++) {
      const d = l[h];
      d in s || (s[d] = c[d].bind(s));
    }
  }
  const i = (r == null ? void 0 : r.Parent) ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var u;
    const c = r != null && r.Parent ? new o() : this;
    n(c, s), (u = c._zod).deferred ?? (u.deferred = []);
    for (const l of c._zod.deferred)
      l();
    return c;
  }
  return Object.defineProperty(a, "init", { value: n }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var u, c;
      return r != null && r.Parent && s instanceof r.Parent ? !0 : (c = (u = s == null ? void 0 : s._zod) == null ? void 0 : u.traits) == null ? void 0 : c.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class yt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class za extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Ra = {};
function tt(e) {
  return Ra;
}
function Pa(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, i]) => t.indexOf(+n) === -1).map(([n, i]) => i);
}
function yn(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ln(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Vn(e) {
  return e == null;
}
function qn(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function Il(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = t.toString();
  let i = (n.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(n)) {
    const u = n.match(/\d?e-(\d?)/);
    u != null && u[1] && (i = Number.parseInt(u[1]));
  }
  const o = r > i ? r : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const Ki = Symbol("evaluating");
function Z(e, t, r) {
  let n;
  Object.defineProperty(e, t, {
    get() {
      if (n !== Ki)
        return n === void 0 && (n = Ki, n = r()), n;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function it(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function We(...e) {
  const t = {};
  for (const r of e) {
    const n = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, n);
  }
  return Object.defineProperties({}, t);
}
function Hi(e) {
  return JSON.stringify(e);
}
function zl(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Fa = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function dr(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Rl = Ln(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Ut(e) {
  if (dr(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const r = t.prototype;
  return !(dr(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function Ca(e) {
  return Ut(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Pl = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Tr(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Je(e, t, r) {
  const n = new e._zod.constr(t ?? e._zod.def);
  return (!t || r != null && r.parent) && (n._zod.parent = e), n;
}
function F(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Fl(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const Cl = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Nl(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const o = We(e._zod.def, {
    get shape() {
      const a = {};
      for (const s in t) {
        if (!(s in r.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && (a[s] = r.shape[s]);
      }
      return it(this, "shape", a), a;
    },
    checks: []
  });
  return Je(e, o);
}
function Al(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const o = We(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape };
      for (const s in t) {
        if (!(s in r.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && delete a[s];
      }
      return it(this, "shape", a), a;
    },
    checks: []
  });
  return Je(e, o);
}
function xl(e, t) {
  if (!Ut(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0) {
    const o = e._zod.def.shape;
    for (const a in t)
      if (Object.getOwnPropertyDescriptor(o, a) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const i = We(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return it(this, "shape", o), o;
    }
  });
  return Je(e, i);
}
function Ml(e, t) {
  if (!Ut(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const r = We(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t };
      return it(this, "shape", n), n;
    }
  });
  return Je(e, r);
}
function jl(e, t) {
  const r = We(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t._zod.def.shape };
      return it(this, "shape", n), n;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Je(e, r);
}
function $l(e, t, r) {
  const i = t._zod.def.checks;
  if (i && i.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const a = We(t._zod.def, {
    get shape() {
      const s = t._zod.def.shape, u = { ...s };
      if (r)
        for (const c in r) {
          if (!(c in s))
            throw new Error(`Unrecognized key: "${c}"`);
          r[c] && (u[c] = e ? new e({
            type: "optional",
            innerType: s[c]
          }) : s[c]);
        }
      else
        for (const c in s)
          u[c] = e ? new e({
            type: "optional",
            innerType: s[c]
          }) : s[c];
      return it(this, "shape", u), u;
    },
    checks: []
  });
  return Je(t, a);
}
function Ll(e, t, r) {
  const n = We(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (r)
        for (const a in r) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          r[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return it(this, "shape", o), o;
    }
  });
  return Je(t, n);
}
function ht(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (((r = e.issues[n]) == null ? void 0 : r.continue) !== !0)
      return !0;
  return !1;
}
function Na(e, t) {
  return t.map((r) => {
    var n;
    return (n = r).path ?? (n.path = []), r.path.unshift(e), r;
  });
}
function Yt(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function rt(e, t, r) {
  var i, o, a, s, u, c;
  const n = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const l = Yt((a = (o = (i = e.inst) == null ? void 0 : i._zod.def) == null ? void 0 : o.error) == null ? void 0 : a.call(o, e)) ?? Yt((s = t == null ? void 0 : t.error) == null ? void 0 : s.call(t, e)) ?? Yt((u = r.customError) == null ? void 0 : u.call(r, e)) ?? Yt((c = r.localeError) == null ? void 0 : c.call(r, e)) ?? "Invalid input";
    n.message = l;
  }
  return delete n.inst, delete n.continue, t != null && t.reportInput || delete n.input, n;
}
function Zn(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Bt(...e) {
  const [t, r, n] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: n
  } : { ...t };
}
const Aa = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, yn, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, xa = E("$ZodError", Aa), Ma = E("$ZodError", Aa, { Parent: Error });
function Vl(e, t = (r) => r.message) {
  const r = {}, n = [];
  for (const i of e.issues)
    i.path.length > 0 ? (r[i.path[0]] = r[i.path[0]] || [], r[i.path[0]].push(t(i))) : n.push(t(i));
  return { formErrors: n, fieldErrors: r };
}
function ql(e, t = (r) => r.message) {
  const r = { _errors: [] }, n = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => n({ issues: a }));
      else if (o.code === "invalid_key")
        n({ issues: o.issues });
      else if (o.code === "invalid_element")
        n({ issues: o.issues });
      else if (o.path.length === 0)
        r._errors.push(t(o));
      else {
        let a = r, s = 0;
        for (; s < o.path.length; ) {
          const u = o.path[s];
          s === o.path.length - 1 ? (a[u] = a[u] || { _errors: [] }, a[u]._errors.push(t(o))) : a[u] = a[u] || { _errors: [] }, a = a[u], s++;
        }
      }
  };
  return n(e), r;
}
const Qn = (e) => (t, r, n, i) => {
  const o = n ? Object.assign(n, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: r, issues: [] }, o);
  if (a instanceof Promise)
    throw new yt();
  if (a.issues.length) {
    const s = new ((i == null ? void 0 : i.Err) ?? e)(a.issues.map((u) => rt(u, o, tt())));
    throw Fa(s, i == null ? void 0 : i.callee), s;
  }
  return a.value;
}, Un = (e) => async (t, r, n, i) => {
  const o = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: r, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new ((i == null ? void 0 : i.Err) ?? e)(a.issues.map((u) => rt(u, o, tt())));
    throw Fa(s, i == null ? void 0 : i.callee), s;
  }
  return a.value;
}, Dr = (e) => (t, r, n) => {
  const i = n ? { ...n, async: !1 } : { async: !1 }, o = t._zod.run({ value: r, issues: [] }, i);
  if (o instanceof Promise)
    throw new yt();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? xa)(o.issues.map((a) => rt(a, i, tt())))
  } : { success: !0, data: o.value };
}, Zl = /* @__PURE__ */ Dr(Ma), Ir = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: r, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => rt(a, i, tt())))
  } : { success: !0, data: o.value };
}, Ql = /* @__PURE__ */ Ir(Ma), Ul = (e) => (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Qn(e)(t, r, i);
}, Bl = (e) => (t, r, n) => Qn(e)(t, r, n), Wl = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Un(e)(t, r, i);
}, Jl = (e) => async (t, r, n) => Un(e)(t, r, n), Gl = (e) => (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Dr(e)(t, r, i);
}, Kl = (e) => (t, r, n) => Dr(e)(t, r, n), Hl = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Ir(e)(t, r, i);
}, Yl = (e) => async (t, r, n) => Ir(e)(t, r, n), Xl = /^[cC][^\s-]{8,}$/, ef = /^[0-9a-z]+$/, tf = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, rf = /^[0-9a-vA-V]{20}$/, nf = /^[A-Za-z0-9]{27}$/, of = /^[a-zA-Z0-9_-]{21}$/, af = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, sf = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Yi = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, uf = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, cf = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function lf() {
  return new RegExp(cf, "u");
}
const ff = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, hf = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, df = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, pf = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, vf = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, ja = /^[A-Za-z0-9_-]*$/, mf = /^\+[1-9]\d{6,14}$/, $a = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", yf = /* @__PURE__ */ new RegExp(`^${$a}$`);
function La(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function gf(e) {
  return new RegExp(`^${La(e)}$`);
}
function bf(e) {
  const t = La({ precision: e.precision }), r = ["Z"];
  e.local && r.push(""), e.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const n = `${t}(?:${r.join("|")})`;
  return new RegExp(`^${$a}T(?:${n})$`);
}
const _f = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, wf = /^-?\d+$/, Ef = /^-?\d+(?:\.\d+)?$/, kf = /^(?:true|false)$/i, Sf = /^[^A-Z]*$/, Of = /^[^a-z]*$/, ge = /* @__PURE__ */ E("$ZodCheck", (e, t) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = t, (r = e._zod).onattach ?? (r.onattach = []);
}), Va = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, qa = /* @__PURE__ */ E("$ZodCheckLessThan", (e, t) => {
  ge.init(e, t);
  const r = Va[typeof t.value];
  e._zod.onattach.push((n) => {
    const i = n._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (n) => {
    (t.inclusive ? n.value <= t.value : n.value < t.value) || n.issues.push({
      origin: r,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Za = /* @__PURE__ */ E("$ZodCheckGreaterThan", (e, t) => {
  ge.init(e, t);
  const r = Va[typeof t.value];
  e._zod.onattach.push((n) => {
    const i = n._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (n) => {
    (t.inclusive ? n.value >= t.value : n.value > t.value) || n.issues.push({
      origin: r,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Tf = /* @__PURE__ */ E("$ZodCheckMultipleOf", (e, t) => {
  ge.init(e, t), e._zod.onattach.push((r) => {
    var n;
    (n = r._zod.bag).multipleOf ?? (n.multipleOf = t.value);
  }), e._zod.check = (r) => {
    if (typeof r.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % t.value === BigInt(0) : Il(r.value, t.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Df = /* @__PURE__ */ E("$ZodCheckNumberFormat", (e, t) => {
  var a;
  ge.init(e, t), t.format = t.format || "float64";
  const r = (a = t.format) == null ? void 0 : a.includes("int"), n = r ? "int" : "number", [i, o] = Cl[t.format];
  e._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.format = t.format, u.minimum = i, u.maximum = o, r && (u.pattern = wf);
  }), e._zod.check = (s) => {
    const u = s.value;
    if (r) {
      if (!Number.isInteger(u)) {
        s.issues.push({
          expected: n,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: u,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(u)) {
        u > 0 ? s.issues.push({
          input: u,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: u,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    u < i && s.issues.push({
      origin: "number",
      input: u,
      code: "too_small",
      minimum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), u > o && s.issues.push({
      origin: "number",
      input: u,
      code: "too_big",
      maximum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), If = /* @__PURE__ */ E("$ZodCheckMaxLength", (e, t) => {
  var r;
  ge.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Vn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (n._zod.bag.maximum = t.maximum);
  }), e._zod.check = (n) => {
    const i = n.value;
    if (i.length <= t.maximum)
      return;
    const a = Zn(i);
    n.issues.push({
      origin: a,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), zf = /* @__PURE__ */ E("$ZodCheckMinLength", (e, t) => {
  var r;
  ge.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Vn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (n._zod.bag.minimum = t.minimum);
  }), e._zod.check = (n) => {
    const i = n.value;
    if (i.length >= t.minimum)
      return;
    const a = Zn(i);
    n.issues.push({
      origin: a,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Rf = /* @__PURE__ */ E("$ZodCheckLengthEquals", (e, t) => {
  var r;
  ge.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Vn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (n) => {
    const i = n.value, o = i.length;
    if (o === t.length)
      return;
    const a = Zn(i), s = o > t.length;
    n.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), zr = /* @__PURE__ */ E("$ZodCheckStringFormat", (e, t) => {
  var r, n;
  ge.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (r = e._zod).check ?? (r.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (n = e._zod).check ?? (n.check = () => {
  });
}), Pf = /* @__PURE__ */ E("$ZodCheckRegex", (e, t) => {
  zr.init(e, t), e._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Ff = /* @__PURE__ */ E("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Sf), zr.init(e, t);
}), Cf = /* @__PURE__ */ E("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Of), zr.init(e, t);
}), Nf = /* @__PURE__ */ E("$ZodCheckIncludes", (e, t) => {
  ge.init(e, t);
  const r = Tr(t.includes), n = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${r}` : r);
  t.pattern = n, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Af = /* @__PURE__ */ E("$ZodCheckStartsWith", (e, t) => {
  ge.init(e, t);
  const r = new RegExp(`^${Tr(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.startsWith(t.prefix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), xf = /* @__PURE__ */ E("$ZodCheckEndsWith", (e, t) => {
  ge.init(e, t);
  const r = new RegExp(`.*${Tr(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.endsWith(t.suffix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Mf = /* @__PURE__ */ E("$ZodCheckOverwrite", (e, t) => {
  ge.init(e, t), e._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
});
class jf {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((a) => a), i = Math.min(...n.map((a) => a.length - a.trimStart().length)), o = n.map((a) => a.slice(i)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of o)
      this.content.push(a);
  }
  compile() {
    const t = Function, r = this == null ? void 0 : this.args, i = [...((this == null ? void 0 : this.content) ?? [""]).map((o) => `  ${o}`)];
    return new t(...r, i.join(`
`));
  }
}
const $f = {
  major: 4,
  minor: 3,
  patch: 6
}, re = /* @__PURE__ */ E("$ZodType", (e, t) => {
  var i;
  var r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = $f;
  const n = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && n.unshift(e);
  for (const o of n)
    for (const a of o._zod.onattach)
      a(e);
  if (n.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (i = e._zod.deferred) == null || i.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, u, c) => {
      let l = ht(s), h;
      for (const d of u) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (l)
          continue;
        const f = s.issues.length, p = d._zod.check(s);
        if (p instanceof Promise && (c == null ? void 0 : c.async) === !1)
          throw new yt();
        if (h || p instanceof Promise)
          h = (h ?? Promise.resolve()).then(async () => {
            await p, s.issues.length !== f && (l || (l = ht(s, f)));
          });
        else {
          if (s.issues.length === f)
            continue;
          l || (l = ht(s, f));
        }
      }
      return h ? h.then(() => s) : s;
    }, a = (s, u, c) => {
      if (ht(s))
        return s.aborted = !0, s;
      const l = o(u, n, c);
      if (l instanceof Promise) {
        if (c.async === !1)
          throw new yt();
        return l.then((h) => e._zod.parse(h, c));
      }
      return e._zod.parse(l, c);
    };
    e._zod.run = (s, u) => {
      if (u.skipChecks)
        return e._zod.parse(s, u);
      if (u.direction === "backward") {
        const l = e._zod.parse({ value: s.value, issues: [] }, { ...u, skipChecks: !0 });
        return l instanceof Promise ? l.then((h) => a(h, s, u)) : a(l, s, u);
      }
      const c = e._zod.parse(s, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new yt();
        return c.then((l) => o(l, n, u));
      }
      return o(c, n, u);
    };
  }
  Z(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = Zl(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return Ql(e, o).then((u) => {
          var c;
          return u.success ? { value: u.data } : { issues: (c = u.error) == null ? void 0 : c.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Bn = /* @__PURE__ */ E("$ZodString", (e, t) => {
  var r;
  re.init(e, t), e._zod.pattern = [...((r = e == null ? void 0 : e._zod.bag) == null ? void 0 : r.patterns) ?? []].pop() ?? _f(e._zod.bag), e._zod.parse = (n, i) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), J = /* @__PURE__ */ E("$ZodStringFormat", (e, t) => {
  zr.init(e, t), Bn.init(e, t);
}), Lf = /* @__PURE__ */ E("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = sf), J.init(e, t);
}), Vf = /* @__PURE__ */ E("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Yi(n));
  } else
    t.pattern ?? (t.pattern = Yi());
  J.init(e, t);
}), qf = /* @__PURE__ */ E("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = uf), J.init(e, t);
}), Zf = /* @__PURE__ */ E("$ZodURL", (e, t) => {
  J.init(e, t), e._zod.check = (r) => {
    try {
      const n = r.value.trim(), i = new URL(n);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? r.value = i.href : r.value = n;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Qf = /* @__PURE__ */ E("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = lf()), J.init(e, t);
}), Uf = /* @__PURE__ */ E("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = of), J.init(e, t);
}), Bf = /* @__PURE__ */ E("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Xl), J.init(e, t);
}), Wf = /* @__PURE__ */ E("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = ef), J.init(e, t);
}), Jf = /* @__PURE__ */ E("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = tf), J.init(e, t);
}), Gf = /* @__PURE__ */ E("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = rf), J.init(e, t);
}), Kf = /* @__PURE__ */ E("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = nf), J.init(e, t);
}), Hf = /* @__PURE__ */ E("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = bf(t)), J.init(e, t);
}), Yf = /* @__PURE__ */ E("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = yf), J.init(e, t);
}), Xf = /* @__PURE__ */ E("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = gf(t)), J.init(e, t);
}), eh = /* @__PURE__ */ E("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = af), J.init(e, t);
}), th = /* @__PURE__ */ E("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = ff), J.init(e, t), e._zod.bag.format = "ipv4";
}), rh = /* @__PURE__ */ E("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = hf), J.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), nh = /* @__PURE__ */ E("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = df), J.init(e, t);
}), ih = /* @__PURE__ */ E("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = pf), J.init(e, t), e._zod.check = (r) => {
    const n = r.value.split("/");
    try {
      if (n.length !== 2)
        throw new Error();
      const [i, o] = n;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Qa(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const oh = /* @__PURE__ */ E("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = vf), J.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (r) => {
    Qa(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function ah(e) {
  if (!ja.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (n) => n === "-" ? "+" : "/"), r = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Qa(r);
}
const sh = /* @__PURE__ */ E("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = ja), J.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (r) => {
    ah(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), uh = /* @__PURE__ */ E("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = mf), J.init(e, t);
});
function ch(e, t = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [n] = r;
    if (!n)
      return !1;
    const i = JSON.parse(atob(n));
    return !("typ" in i && (i == null ? void 0 : i.typ) !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const lh = /* @__PURE__ */ E("$ZodJWT", (e, t) => {
  J.init(e, t), e._zod.check = (r) => {
    ch(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ua = /* @__PURE__ */ E("$ZodNumber", (e, t) => {
  re.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Ef, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const i = r.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return r;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), r;
  };
}), fh = /* @__PURE__ */ E("$ZodNumberFormat", (e, t) => {
  Df.init(e, t), Ua.init(e, t);
}), hh = /* @__PURE__ */ E("$ZodBoolean", (e, t) => {
  re.init(e, t), e._zod.pattern = kf, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = !!r.value;
      } catch {
      }
    const i = r.value;
    return typeof i == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), r;
  };
}), dh = /* @__PURE__ */ E("$ZodUnknown", (e, t) => {
  re.init(e, t), e._zod.parse = (r) => r;
}), ph = /* @__PURE__ */ E("$ZodNever", (e, t) => {
  re.init(e, t), e._zod.parse = (r, n) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
});
function Xi(e, t, r) {
  e.issues.length && t.issues.push(...Na(r, e.issues)), t.value[r] = e.value;
}
const vh = /* @__PURE__ */ E("$ZodArray", (e, t) => {
  re.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value;
    if (!Array.isArray(i))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), r;
    r.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], u = t.element._zod.run({
        value: s,
        issues: []
      }, n);
      u instanceof Promise ? o.push(u.then((c) => Xi(c, r, a))) : Xi(u, r, a);
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
});
function pr(e, t, r, n, i) {
  if (e.issues.length) {
    if (i && !(r in n))
      return;
    t.issues.push(...Na(r, e.issues));
  }
  e.value === void 0 ? r in n && (t.value[r] = void 0) : t.value[r] = e.value;
}
function Ba(e) {
  var n, i, o, a;
  const t = Object.keys(e.shape);
  for (const s of t)
    if (!((a = (o = (i = (n = e.shape) == null ? void 0 : n[s]) == null ? void 0 : i._zod) == null ? void 0 : o.traits) != null && a.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const r = Fl(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(r)
  };
}
function Wa(e, t, r, n, i, o) {
  const a = [], s = i.keySet, u = i.catchall._zod, c = u.def.type, l = u.optout === "optional";
  for (const h in t) {
    if (s.has(h))
      continue;
    if (c === "never") {
      a.push(h);
      continue;
    }
    const d = u.run({ value: t[h], issues: [] }, n);
    d instanceof Promise ? e.push(d.then((f) => pr(f, r, h, t, l))) : pr(d, r, h, t, l);
  }
  return a.length && r.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => r) : r;
}
const mh = /* @__PURE__ */ E("$ZodObject", (e, t) => {
  re.init(e, t);
  const r = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(r != null && r.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const u = { ...s };
        return Object.defineProperty(t, "shape", {
          value: u
        }), u;
      }
    });
  }
  const n = Ln(() => Ba(t));
  Z(e._zod, "propValues", () => {
    const s = t.shape, u = {};
    for (const c in s) {
      const l = s[c]._zod;
      if (l.values) {
        u[c] ?? (u[c] = /* @__PURE__ */ new Set());
        for (const h of l.values)
          u[c].add(h);
      }
    }
    return u;
  });
  const i = dr, o = t.catchall;
  let a;
  e._zod.parse = (s, u) => {
    a ?? (a = n.value);
    const c = s.value;
    if (!i(c))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: c,
        inst: e
      }), s;
    s.value = {};
    const l = [], h = a.shape;
    for (const d of a.keys) {
      const f = h[d], p = f._zod.optout === "optional", m = f._zod.run({ value: c[d], issues: [] }, u);
      m instanceof Promise ? l.push(m.then((g) => pr(g, s, d, c, p))) : pr(m, s, d, c, p);
    }
    return o ? Wa(l, c, s, u, n.value, e) : l.length ? Promise.all(l).then(() => s) : s;
  };
}), yh = /* @__PURE__ */ E("$ZodObjectJIT", (e, t) => {
  mh.init(e, t);
  const r = e._zod.parse, n = Ln(() => Ba(t)), i = (d) => {
    var w;
    const f = new jf(["shape", "payload", "ctx"]), p = n.value, m = (k) => {
      const S = Hi(k);
      return `shape[${S}]._zod.run({ value: input[${S}], issues: [] }, ctx)`;
    };
    f.write("const input = payload.value;");
    const g = /* @__PURE__ */ Object.create(null);
    let y = 0;
    for (const k of p.keys)
      g[k] = `key_${y++}`;
    f.write("const newResult = {};");
    for (const k of p.keys) {
      const S = g[k], T = Hi(k), P = d[k], R = ((w = P == null ? void 0 : P._zod) == null ? void 0 : w.optout) === "optional";
      f.write(`const ${S} = ${m(k)};`), R ? f.write(`
        if (${S}.issues.length) {
          if (${T} in input) {
            payload.issues = payload.issues.concat(${S}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${T}, ...iss.path] : [${T}]
            })));
          }
        }
        
        if (${S}.value === undefined) {
          if (${T} in input) {
            newResult[${T}] = undefined;
          }
        } else {
          newResult[${T}] = ${S}.value;
        }
        
      `) : f.write(`
        if (${S}.issues.length) {
          payload.issues = payload.issues.concat(${S}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${T}, ...iss.path] : [${T}]
          })));
        }
        
        if (${S}.value === undefined) {
          if (${T} in input) {
            newResult[${T}] = undefined;
          }
        } else {
          newResult[${T}] = ${S}.value;
        }
        
      `);
    }
    f.write("payload.value = newResult;"), f.write("return payload;");
    const b = f.compile();
    return (k, S) => b(d, k, S);
  };
  let o;
  const a = dr, s = !Ra.jitless, c = s && Rl.value, l = t.catchall;
  let h;
  e._zod.parse = (d, f) => {
    h ?? (h = n.value);
    const p = d.value;
    return a(p) ? s && c && (f == null ? void 0 : f.async) === !1 && f.jitless !== !0 ? (o || (o = i(t.shape)), d = o(d, f), l ? Wa([], p, d, f, h, e) : d) : r(d, f) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), d);
  };
});
function eo(e, t, r, n) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !ht(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: e.map((o) => o.issues.map((a) => rt(a, n, tt())))
  }), t);
}
const gh = /* @__PURE__ */ E("$ZodUnion", (e, t) => {
  re.init(e, t), Z(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), Z(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), Z(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), Z(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => qn(o.source)).join("|")})$`);
    }
  });
  const r = t.options.length === 1, n = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (r)
      return n(i, o);
    let a = !1;
    const s = [];
    for (const u of t.options) {
      const c = u._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (c instanceof Promise)
        s.push(c), a = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return a ? Promise.all(s).then((u) => eo(u, i, e, o)) : eo(s, i, e, o);
  };
}), bh = /* @__PURE__ */ E("$ZodIntersection", (e, t) => {
  re.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value, o = t.left._zod.run({ value: i, issues: [] }, n), a = t.right._zod.run({ value: i, issues: [] }, n);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([u, c]) => to(r, u, c)) : to(r, o, a);
  };
});
function gn(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Ut(e) && Ut(t)) {
    const r = Object.keys(t), n = Object.keys(e).filter((o) => r.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of n) {
      const a = gn(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n], o = t[n], a = gn(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [n, ...a.mergeErrorPath]
        };
      r.push(a.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function to(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const u of s.keys)
        n.has(u) || n.set(u, {}), n.get(u).l = !0;
    } else
      e.issues.push(s);
  for (const s of r.issues)
    if (s.code === "unrecognized_keys")
      for (const u of s.keys)
        n.has(u) || n.set(u, {}), n.get(u).r = !0;
    else
      e.issues.push(s);
  const o = [...n].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), ht(e))
    return e;
  const a = gn(t.value, r.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const _h = /* @__PURE__ */ E("$ZodEnum", (e, t) => {
  re.init(e, t);
  const r = Pa(t.entries), n = new Set(r);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${r.filter((i) => Pl.has(typeof i)).map((i) => typeof i == "string" ? Tr(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return n.has(a) || i.issues.push({
      code: "invalid_value",
      values: r,
      input: a,
      inst: e
    }), i;
  };
}), wh = /* @__PURE__ */ E("$ZodTransform", (e, t) => {
  re.init(e, t), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      throw new za(e.constructor.name);
    const i = t.transform(r.value, r);
    if (n.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((a) => (r.value = a, r));
    if (i instanceof Promise)
      throw new yt();
    return r.value = i, r;
  };
});
function ro(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Ja = /* @__PURE__ */ E("$ZodOptional", (e, t) => {
  re.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Z(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Z(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${qn(r.source)})?$`) : void 0;
  }), e._zod.parse = (r, n) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(r, n);
      return i instanceof Promise ? i.then((o) => ro(o, r.value)) : ro(i, r.value);
    }
    return r.value === void 0 ? r : t.innerType._zod.run(r, n);
  };
}), Eh = /* @__PURE__ */ E("$ZodExactOptional", (e, t) => {
  Ja.init(e, t), Z(e._zod, "values", () => t.innerType._zod.values), Z(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (r, n) => t.innerType._zod.run(r, n);
}), kh = /* @__PURE__ */ E("$ZodNullable", (e, t) => {
  re.init(e, t), Z(e._zod, "optin", () => t.innerType._zod.optin), Z(e._zod, "optout", () => t.innerType._zod.optout), Z(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${qn(r.source)}|null)$`) : void 0;
  }), Z(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (r, n) => r.value === null ? r : t.innerType._zod.run(r, n);
}), Sh = /* @__PURE__ */ E("$ZodDefault", (e, t) => {
  re.init(e, t), e._zod.optin = "optional", Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => no(o, t)) : no(i, t);
  };
});
function no(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Oh = /* @__PURE__ */ E("$ZodPrefault", (e, t) => {
  re.init(e, t), e._zod.optin = "optional", Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => (n.direction === "backward" || r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, n));
}), Th = /* @__PURE__ */ E("$ZodNonOptional", (e, t) => {
  re.init(e, t), Z(e._zod, "values", () => {
    const r = t.innerType._zod.values;
    return r ? new Set([...r].filter((n) => n !== void 0)) : void 0;
  }), e._zod.parse = (r, n) => {
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => io(o, e)) : io(i, e);
  };
});
function io(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Dh = /* @__PURE__ */ E("$ZodCatch", (e, t) => {
  re.init(e, t), Z(e._zod, "optin", () => t.innerType._zod.optin), Z(e._zod, "optout", () => t.innerType._zod.optout), Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => (r.value = o.value, o.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: o.issues.map((a) => rt(a, n, tt()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = i.value, i.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: i.issues.map((o) => rt(o, n, tt()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), Ih = /* @__PURE__ */ E("$ZodPipe", (e, t) => {
  re.init(e, t), Z(e._zod, "values", () => t.in._zod.values), Z(e._zod, "optin", () => t.in._zod.optin), Z(e._zod, "optout", () => t.out._zod.optout), Z(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (r, n) => {
    if (n.direction === "backward") {
      const o = t.out._zod.run(r, n);
      return o instanceof Promise ? o.then((a) => Xt(a, t.in, n)) : Xt(o, t.in, n);
    }
    const i = t.in._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => Xt(o, t.out, n)) : Xt(i, t.out, n);
  };
});
function Xt(e, t, r) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, r);
}
const zh = /* @__PURE__ */ E("$ZodReadonly", (e, t) => {
  re.init(e, t), Z(e._zod, "propValues", () => t.innerType._zod.propValues), Z(e._zod, "values", () => t.innerType._zod.values), Z(e._zod, "optin", () => {
    var r, n;
    return (n = (r = t.innerType) == null ? void 0 : r._zod) == null ? void 0 : n.optin;
  }), Z(e._zod, "optout", () => {
    var r, n;
    return (n = (r = t.innerType) == null ? void 0 : r._zod) == null ? void 0 : n.optout;
  }), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then(oo) : oo(i);
  };
});
function oo(e) {
  return e.value = Object.freeze(e.value), e;
}
const Rh = /* @__PURE__ */ E("$ZodCustom", (e, t) => {
  ge.init(e, t), re.init(e, t), e._zod.parse = (r, n) => r, e._zod.check = (r) => {
    const n = r.value, i = t.fn(n);
    if (i instanceof Promise)
      return i.then((o) => ao(o, r, n, e));
    ao(i, r, n, e);
  };
});
function ao(e, t, r, n) {
  if (!e) {
    const i = {
      code: "custom",
      input: r,
      inst: n,
      // incorporates params.error into issue reporting
      path: [...n._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !n._zod.def.abort
      // params: inst._zod.def.params,
    };
    n._zod.def.params && (i.params = n._zod.def.params), t.issues.push(Bt(i));
  }
}
var so;
class Ph {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...r) {
    const n = r[0];
    return this._map.set(t, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const r = this._map.get(t);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(t), this;
  }
  get(t) {
    const r = t._zod.parent;
    if (r) {
      const n = { ...this.get(r) ?? {} };
      delete n.id;
      const i = { ...n, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Fh() {
  return new Ph();
}
(so = globalThis).__zod_globalRegistry ?? (so.__zod_globalRegistry = Fh());
const xt = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function Ch(e, t) {
  return new e({
    type: "string",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Nh(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function uo(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ah(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Mh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $h(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Lh(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Vh(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qh(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Zh(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Qh(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Uh(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bh(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wh(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Jh(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Gh(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Kh(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Hh(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Yh(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Xh(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ed(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function td(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rd(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nd(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function id(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function od(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ad(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sd(e, t) {
  return new e({
    type: "boolean",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ud(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function cd(e, t) {
  return new e({
    type: "never",
    ...F(t)
  });
}
// @__NO_SIDE_EFFECTS__
function co(e, t) {
  return new qa({
    check: "less_than",
    ...F(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Br(e, t) {
  return new qa({
    check: "less_than",
    ...F(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function lo(e, t) {
  return new Za({
    check: "greater_than",
    ...F(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Wr(e, t) {
  return new Za({
    check: "greater_than",
    ...F(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function fo(e, t) {
  return new Tf({
    check: "multiple_of",
    ...F(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ga(e, t) {
  return new If({
    check: "max_length",
    ...F(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function vr(e, t) {
  return new zf({
    check: "min_length",
    ...F(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ka(e, t) {
  return new Rf({
    check: "length_equals",
    ...F(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function ld(e, t) {
  return new Pf({
    check: "string_format",
    format: "regex",
    ...F(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function fd(e) {
  return new Ff({
    check: "string_format",
    format: "lowercase",
    ...F(e)
  });
}
// @__NO_SIDE_EFFECTS__
function hd(e) {
  return new Cf({
    check: "string_format",
    format: "uppercase",
    ...F(e)
  });
}
// @__NO_SIDE_EFFECTS__
function dd(e, t) {
  return new Nf({
    check: "string_format",
    format: "includes",
    ...F(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function pd(e, t) {
  return new Af({
    check: "string_format",
    format: "starts_with",
    ...F(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function vd(e, t) {
  return new xf({
    check: "string_format",
    format: "ends_with",
    ...F(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Dt(e) {
  return new Mf({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function md(e) {
  return /* @__PURE__ */ Dt((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function yd() {
  return /* @__PURE__ */ Dt((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function gd() {
  return /* @__PURE__ */ Dt((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function bd() {
  return /* @__PURE__ */ Dt((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function _d() {
  return /* @__PURE__ */ Dt((e) => zl(e));
}
// @__NO_SIDE_EFFECTS__
function wd(e, t, r) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...F(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Ed(e, t, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...F(r)
  });
}
// @__NO_SIDE_EFFECTS__
function kd(e) {
  const t = /* @__PURE__ */ Sd((r) => (r.addIssue = (n) => {
    if (typeof n == "string")
      r.issues.push(Bt(n, r.value, t._zod.def));
    else {
      const i = n;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = r.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), r.issues.push(Bt(i));
    }
  }, e(r.value, r)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Sd(e, t) {
  const r = new ge({
    check: "custom",
    ...F(t)
  });
  return r._zod.check = e, r;
}
function Ha(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? xt,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function ue(e, t, r = { path: [], schemaPath: [] }) {
  var l, h;
  var n;
  const i = e._zod.def, o = t.seen.get(e);
  if (o)
    return o.count++, r.schemaPath.includes(e) && (o.cycle = r.path), o.schema;
  const a = { schema: {}, count: 1, cycle: void 0, path: r.path };
  t.seen.set(e, a);
  const s = (h = (l = e._zod).toJSONSchema) == null ? void 0 : h.call(l);
  if (s)
    a.schema = s;
  else {
    const d = {
      ...r,
      schemaPath: [...r.schemaPath, e],
      path: r.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, a.schema, d);
    else {
      const p = a.schema, m = t.processors[i.type];
      if (!m)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
      m(e, t, p, d);
    }
    const f = e._zod.parent;
    f && (a.ref || (a.ref = f), ue(f, t, d), t.seen.get(f).isParent = !0);
  }
  const u = t.metadataRegistry.get(e);
  return u && Object.assign(a.schema, u), t.io === "input" && pe(e) && (delete a.schema.examples, delete a.schema.default), t.io === "input" && a.schema._prefault && ((n = a.schema).default ?? (n.default = a.schema._prefault)), delete a.schema._prefault, t.seen.get(e).schema;
}
function Ya(e, t) {
  var a, s, u, c;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = /* @__PURE__ */ new Map();
  for (const l of e.seen.entries()) {
    const h = (a = e.metadataRegistry.get(l[0])) == null ? void 0 : a.id;
    if (h) {
      const d = n.get(h);
      if (d && d !== l[0])
        throw new Error(`Duplicate schema id "${h}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      n.set(h, l[0]);
    }
  }
  const i = (l) => {
    var m;
    const h = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const g = (m = e.external.registry.get(l[0])) == null ? void 0 : m.id, y = e.external.uri ?? ((w) => w);
      if (g)
        return { ref: y(g) };
      const b = l[1].defId ?? l[1].schema.id ?? `schema${e.counter++}`;
      return l[1].defId = b, { defId: b, ref: `${y("__shared")}#/${h}/${b}` };
    }
    if (l[1] === r)
      return { ref: "#" };
    const f = `#/${h}/`, p = l[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: p, ref: f + p };
  }, o = (l) => {
    if (l[1].schema.$ref)
      return;
    const h = l[1], { ref: d, defId: f } = i(l);
    h.def = { ...h.schema }, f && (h.defId = f);
    const p = h.schema;
    for (const m in p)
      delete p[m];
    p.$ref = d;
  };
  if (e.cycles === "throw")
    for (const l of e.seen.entries()) {
      const h = l[1];
      if (h.cycle)
        throw new Error(`Cycle detected: #/${(s = h.cycle) == null ? void 0 : s.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const l of e.seen.entries()) {
    const h = l[1];
    if (t === l[0]) {
      o(l);
      continue;
    }
    if (e.external) {
      const f = (u = e.external.registry.get(l[0])) == null ? void 0 : u.id;
      if (t !== l[0] && f) {
        o(l);
        continue;
      }
    }
    if ((c = e.metadataRegistry.get(l[0])) == null ? void 0 : c.id) {
      o(l);
      continue;
    }
    if (h.cycle) {
      o(l);
      continue;
    }
    if (h.count > 1 && e.reused === "ref") {
      o(l);
      continue;
    }
  }
}
function Xa(e, t) {
  var a, s, u;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = (c) => {
    const l = e.seen.get(c);
    if (l.ref === null)
      return;
    const h = l.def ?? l.schema, d = { ...h }, f = l.ref;
    if (l.ref = null, f) {
      n(f);
      const m = e.seen.get(f), g = m.schema;
      if (g.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (h.allOf = h.allOf ?? [], h.allOf.push(g)) : Object.assign(h, g), Object.assign(h, d), c._zod.parent === f)
        for (const b in h)
          b === "$ref" || b === "allOf" || b in d || delete h[b];
      if (g.$ref && m.def)
        for (const b in h)
          b === "$ref" || b === "allOf" || b in m.def && JSON.stringify(h[b]) === JSON.stringify(m.def[b]) && delete h[b];
    }
    const p = c._zod.parent;
    if (p && p !== f) {
      n(p);
      const m = e.seen.get(p);
      if (m != null && m.schema.$ref && (h.$ref = m.schema.$ref, m.def))
        for (const g in h)
          g === "$ref" || g === "allOf" || g in m.def && JSON.stringify(h[g]) === JSON.stringify(m.def[g]) && delete h[g];
    }
    e.override({
      zodSchema: c,
      jsonSchema: h,
      path: l.path ?? []
    });
  };
  for (const c of [...e.seen.entries()].reverse())
    n(c[0]);
  const i = {};
  if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (a = e.external) != null && a.uri) {
    const c = (s = e.external.registry.get(t)) == null ? void 0 : s.id;
    if (!c)
      throw new Error("Schema is missing an `id` property");
    i.$id = e.external.uri(c);
  }
  Object.assign(i, r.def ?? r.schema);
  const o = ((u = e.external) == null ? void 0 : u.defs) ?? {};
  for (const c of e.seen.entries()) {
    const l = c[1];
    l.def && l.defId && (o[l.defId] = l.def);
  }
  e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
  try {
    const c = JSON.parse(JSON.stringify(i));
    return Object.defineProperty(c, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: mr(t, "input", e.processors),
          output: mr(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), c;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function pe(e, t) {
  const r = t ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e))
    return !1;
  r.seen.add(e);
  const n = e._zod.def;
  if (n.type === "transform")
    return !0;
  if (n.type === "array")
    return pe(n.element, r);
  if (n.type === "set")
    return pe(n.valueType, r);
  if (n.type === "lazy")
    return pe(n.getter(), r);
  if (n.type === "promise" || n.type === "optional" || n.type === "nonoptional" || n.type === "nullable" || n.type === "readonly" || n.type === "default" || n.type === "prefault")
    return pe(n.innerType, r);
  if (n.type === "intersection")
    return pe(n.left, r) || pe(n.right, r);
  if (n.type === "record" || n.type === "map")
    return pe(n.keyType, r) || pe(n.valueType, r);
  if (n.type === "pipe")
    return pe(n.in, r) || pe(n.out, r);
  if (n.type === "object") {
    for (const i in n.shape)
      if (pe(n.shape[i], r))
        return !0;
    return !1;
  }
  if (n.type === "union") {
    for (const i of n.options)
      if (pe(i, r))
        return !0;
    return !1;
  }
  if (n.type === "tuple") {
    for (const i of n.items)
      if (pe(i, r))
        return !0;
    return !!(n.rest && pe(n.rest, r));
  }
  return !1;
}
const Od = (e, t = {}) => (r) => {
  const n = Ha({ ...r, processors: t });
  return ue(e, n), Ya(n, e), Xa(n, e);
}, mr = (e, t, r = {}) => (n) => {
  const { libraryOptions: i, target: o } = n ?? {}, a = Ha({ ...i ?? {}, target: o, io: t, processors: r });
  return ue(e, a), Ya(a, e), Xa(a, e);
}, Td = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Dd = (e, t, r, n) => {
  const i = r;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: u, contentEncoding: c } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = Td[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), c && (i.contentEncoding = c), u && u.size > 0) {
    const l = [...u];
    l.length === 1 ? i.pattern = l[0].source : l.length > 1 && (i.allOf = [
      ...l.map((h) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: h.source
      }))
    ]);
  }
}, Id = (e, t, r, n) => {
  const i = r, { minimum: o, maximum: a, format: s, multipleOf: u, exclusiveMaximum: c, exclusiveMinimum: l } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof l == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = l, i.exclusiveMinimum = !0) : i.exclusiveMinimum = l), typeof o == "number" && (i.minimum = o, typeof l == "number" && t.target !== "draft-04" && (l >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = c, i.exclusiveMaximum = !0) : i.exclusiveMaximum = c), typeof a == "number" && (i.maximum = a, typeof c == "number" && t.target !== "draft-04" && (c <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof u == "number" && (i.multipleOf = u);
}, zd = (e, t, r, n) => {
  r.type = "boolean";
}, Rd = (e, t, r, n) => {
  r.not = {};
}, Pd = (e, t, r, n) => {
}, Fd = (e, t, r, n) => {
  const i = e._zod.def, o = Pa(i.entries);
  o.every((a) => typeof a == "number") && (r.type = "number"), o.every((a) => typeof a == "string") && (r.type = "string"), r.enum = o;
}, Cd = (e, t, r, n) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Nd = (e, t, r, n) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Ad = (e, t, r, n) => {
  const i = r, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = ue(o.element, t, { ...n, path: [...n.path, "items"] });
}, xd = (e, t, r, n) => {
  var c;
  const i = r, o = e._zod.def;
  i.type = "object", i.properties = {};
  const a = o.shape;
  for (const l in a)
    i.properties[l] = ue(a[l], t, {
      ...n,
      path: [...n.path, "properties", l]
    });
  const s = new Set(Object.keys(a)), u = new Set([...s].filter((l) => {
    const h = o.shape[l]._zod;
    return t.io === "input" ? h.optin === void 0 : h.optout === void 0;
  }));
  u.size > 0 && (i.required = Array.from(u)), ((c = o.catchall) == null ? void 0 : c._zod.def.type) === "never" ? i.additionalProperties = !1 : o.catchall ? o.catchall && (i.additionalProperties = ue(o.catchall, t, {
    ...n,
    path: [...n.path, "additionalProperties"]
  })) : t.io === "output" && (i.additionalProperties = !1);
}, Md = (e, t, r, n) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, u) => ue(s, t, {
    ...n,
    path: [...n.path, o ? "oneOf" : "anyOf", u]
  }));
  o ? r.oneOf = a : r.anyOf = a;
}, jd = (e, t, r, n) => {
  const i = e._zod.def, o = ue(i.left, t, {
    ...n,
    path: [...n.path, "allOf", 0]
  }), a = ue(i.right, t, {
    ...n,
    path: [...n.path, "allOf", 1]
  }), s = (c) => "allOf" in c && Object.keys(c).length === 1, u = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  r.allOf = u;
}, $d = (e, t, r, n) => {
  const i = e._zod.def, o = ue(i.innerType, t, n), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, r.nullable = !0) : r.anyOf = [o, { type: "null" }];
}, Ld = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Vd = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.default = JSON.parse(JSON.stringify(i.defaultValue));
}, qd = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (r._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Zd = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  r.default = a;
}, Qd = (e, t, r, n) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  ue(o, t, n);
  const a = t.seen.get(e);
  a.ref = o;
}, Ud = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.readOnly = !0;
}, es = (e, t, r, n) => {
  const i = e._zod.def;
  ue(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Bd = /* @__PURE__ */ E("ZodISODateTime", (e, t) => {
  Hf.init(e, t), H.init(e, t);
});
function Wd(e) {
  return /* @__PURE__ */ td(Bd, e);
}
const Jd = /* @__PURE__ */ E("ZodISODate", (e, t) => {
  Yf.init(e, t), H.init(e, t);
});
function Gd(e) {
  return /* @__PURE__ */ rd(Jd, e);
}
const Kd = /* @__PURE__ */ E("ZodISOTime", (e, t) => {
  Xf.init(e, t), H.init(e, t);
});
function Hd(e) {
  return /* @__PURE__ */ nd(Kd, e);
}
const Yd = /* @__PURE__ */ E("ZodISODuration", (e, t) => {
  eh.init(e, t), H.init(e, t);
});
function Xd(e) {
  return /* @__PURE__ */ id(Yd, e);
}
const ep = (e, t) => {
  xa.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (r) => ql(e, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => Vl(e, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => {
        e.issues.push(r), e.message = JSON.stringify(e.issues, yn, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (r) => {
        e.issues.push(...r), e.message = JSON.stringify(e.issues, yn, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, we = E("ZodError", ep, {
  Parent: Error
}), tp = /* @__PURE__ */ Qn(we), rp = /* @__PURE__ */ Un(we), np = /* @__PURE__ */ Dr(we), ip = /* @__PURE__ */ Ir(we), op = /* @__PURE__ */ Ul(we), ap = /* @__PURE__ */ Bl(we), sp = /* @__PURE__ */ Wl(we), up = /* @__PURE__ */ Jl(we), cp = /* @__PURE__ */ Gl(we), lp = /* @__PURE__ */ Kl(we), fp = /* @__PURE__ */ Hl(we), hp = /* @__PURE__ */ Yl(we), ne = /* @__PURE__ */ E("ZodType", (e, t) => (re.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: mr(e, "input"),
    output: mr(e, "output")
  }
}), e.toJSONSchema = Od(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...r) => e.clone(We(t, {
  checks: [
    ...t.checks ?? [],
    ...r.map((n) => typeof n == "function" ? { _zod: { check: n, def: { check: "custom" }, onattach: [] } } : n)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (r, n) => Je(e, r, n), e.brand = () => e, e.register = ((r, n) => (r.add(e, n), e)), e.parse = (r, n) => tp(e, r, n, { callee: e.parse }), e.safeParse = (r, n) => np(e, r, n), e.parseAsync = async (r, n) => rp(e, r, n, { callee: e.parseAsync }), e.safeParseAsync = async (r, n) => ip(e, r, n), e.spa = e.safeParseAsync, e.encode = (r, n) => op(e, r, n), e.decode = (r, n) => ap(e, r, n), e.encodeAsync = async (r, n) => sp(e, r, n), e.decodeAsync = async (r, n) => up(e, r, n), e.safeEncode = (r, n) => cp(e, r, n), e.safeDecode = (r, n) => lp(e, r, n), e.safeEncodeAsync = async (r, n) => fp(e, r, n), e.safeDecodeAsync = async (r, n) => hp(e, r, n), e.refine = (r, n) => e.check(iv(r, n)), e.superRefine = (r) => e.check(ov(r)), e.overwrite = (r) => e.check(/* @__PURE__ */ Dt(r)), e.optional = () => vo(e), e.exactOptional = () => Up(e), e.nullable = () => mo(e), e.nullish = () => vo(mo(e)), e.nonoptional = (r) => Hp(e, r), e.array = () => j(e), e.or = (r) => $p([e, r]), e.and = (r) => Vp(e, r), e.transform = (r) => yo(e, Zp(r)), e.default = (r) => Jp(e, r), e.prefault = (r) => Kp(e, r), e.catch = (r) => Xp(e, r), e.pipe = (r) => yo(e, r), e.readonly = () => rv(e), e.describe = (r) => {
  const n = e.clone();
  return xt.add(n, { description: r }), n;
}, Object.defineProperty(e, "description", {
  get() {
    var r;
    return (r = xt.get(e)) == null ? void 0 : r.description;
  },
  configurable: !0
}), e.meta = (...r) => {
  if (r.length === 0)
    return xt.get(e);
  const n = e.clone();
  return xt.add(n, r[0]), n;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (r) => r(e), e)), ts = /* @__PURE__ */ E("_ZodString", (e, t) => {
  Bn.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (n, i, o) => Dd(e, n, i);
  const r = e._zod.bag;
  e.format = r.format ?? null, e.minLength = r.minimum ?? null, e.maxLength = r.maximum ?? null, e.regex = (...n) => e.check(/* @__PURE__ */ ld(...n)), e.includes = (...n) => e.check(/* @__PURE__ */ dd(...n)), e.startsWith = (...n) => e.check(/* @__PURE__ */ pd(...n)), e.endsWith = (...n) => e.check(/* @__PURE__ */ vd(...n)), e.min = (...n) => e.check(/* @__PURE__ */ vr(...n)), e.max = (...n) => e.check(/* @__PURE__ */ Ga(...n)), e.length = (...n) => e.check(/* @__PURE__ */ Ka(...n)), e.nonempty = (...n) => e.check(/* @__PURE__ */ vr(1, ...n)), e.lowercase = (n) => e.check(/* @__PURE__ */ fd(n)), e.uppercase = (n) => e.check(/* @__PURE__ */ hd(n)), e.trim = () => e.check(/* @__PURE__ */ yd()), e.normalize = (...n) => e.check(/* @__PURE__ */ md(...n)), e.toLowerCase = () => e.check(/* @__PURE__ */ gd()), e.toUpperCase = () => e.check(/* @__PURE__ */ bd()), e.slugify = () => e.check(/* @__PURE__ */ _d());
}), dp = /* @__PURE__ */ E("ZodString", (e, t) => {
  Bn.init(e, t), ts.init(e, t), e.email = (r) => e.check(/* @__PURE__ */ Nh(pp, r)), e.url = (r) => e.check(/* @__PURE__ */ $h(vp, r)), e.jwt = (r) => e.check(/* @__PURE__ */ ed(Rp, r)), e.emoji = (r) => e.check(/* @__PURE__ */ Lh(mp, r)), e.guid = (r) => e.check(/* @__PURE__ */ uo(ho, r)), e.uuid = (r) => e.check(/* @__PURE__ */ Ah(er, r)), e.uuidv4 = (r) => e.check(/* @__PURE__ */ xh(er, r)), e.uuidv6 = (r) => e.check(/* @__PURE__ */ Mh(er, r)), e.uuidv7 = (r) => e.check(/* @__PURE__ */ jh(er, r)), e.nanoid = (r) => e.check(/* @__PURE__ */ Vh(yp, r)), e.guid = (r) => e.check(/* @__PURE__ */ uo(ho, r)), e.cuid = (r) => e.check(/* @__PURE__ */ qh(gp, r)), e.cuid2 = (r) => e.check(/* @__PURE__ */ Zh(bp, r)), e.ulid = (r) => e.check(/* @__PURE__ */ Qh(_p, r)), e.base64 = (r) => e.check(/* @__PURE__ */ Hh(Dp, r)), e.base64url = (r) => e.check(/* @__PURE__ */ Yh(Ip, r)), e.xid = (r) => e.check(/* @__PURE__ */ Uh(wp, r)), e.ksuid = (r) => e.check(/* @__PURE__ */ Bh(Ep, r)), e.ipv4 = (r) => e.check(/* @__PURE__ */ Wh(kp, r)), e.ipv6 = (r) => e.check(/* @__PURE__ */ Jh(Sp, r)), e.cidrv4 = (r) => e.check(/* @__PURE__ */ Gh(Op, r)), e.cidrv6 = (r) => e.check(/* @__PURE__ */ Kh(Tp, r)), e.e164 = (r) => e.check(/* @__PURE__ */ Xh(zp, r)), e.datetime = (r) => e.check(Wd(r)), e.date = (r) => e.check(Gd(r)), e.time = (r) => e.check(Hd(r)), e.duration = (r) => e.check(Xd(r));
});
function _(e) {
  return /* @__PURE__ */ Ch(dp, e);
}
const H = /* @__PURE__ */ E("ZodStringFormat", (e, t) => {
  J.init(e, t), ts.init(e, t);
}), pp = /* @__PURE__ */ E("ZodEmail", (e, t) => {
  qf.init(e, t), H.init(e, t);
}), ho = /* @__PURE__ */ E("ZodGUID", (e, t) => {
  Lf.init(e, t), H.init(e, t);
}), er = /* @__PURE__ */ E("ZodUUID", (e, t) => {
  Vf.init(e, t), H.init(e, t);
}), vp = /* @__PURE__ */ E("ZodURL", (e, t) => {
  Zf.init(e, t), H.init(e, t);
}), mp = /* @__PURE__ */ E("ZodEmoji", (e, t) => {
  Qf.init(e, t), H.init(e, t);
}), yp = /* @__PURE__ */ E("ZodNanoID", (e, t) => {
  Uf.init(e, t), H.init(e, t);
}), gp = /* @__PURE__ */ E("ZodCUID", (e, t) => {
  Bf.init(e, t), H.init(e, t);
}), bp = /* @__PURE__ */ E("ZodCUID2", (e, t) => {
  Wf.init(e, t), H.init(e, t);
}), _p = /* @__PURE__ */ E("ZodULID", (e, t) => {
  Jf.init(e, t), H.init(e, t);
}), wp = /* @__PURE__ */ E("ZodXID", (e, t) => {
  Gf.init(e, t), H.init(e, t);
}), Ep = /* @__PURE__ */ E("ZodKSUID", (e, t) => {
  Kf.init(e, t), H.init(e, t);
}), kp = /* @__PURE__ */ E("ZodIPv4", (e, t) => {
  th.init(e, t), H.init(e, t);
}), Sp = /* @__PURE__ */ E("ZodIPv6", (e, t) => {
  rh.init(e, t), H.init(e, t);
}), Op = /* @__PURE__ */ E("ZodCIDRv4", (e, t) => {
  nh.init(e, t), H.init(e, t);
}), Tp = /* @__PURE__ */ E("ZodCIDRv6", (e, t) => {
  ih.init(e, t), H.init(e, t);
}), Dp = /* @__PURE__ */ E("ZodBase64", (e, t) => {
  oh.init(e, t), H.init(e, t);
}), Ip = /* @__PURE__ */ E("ZodBase64URL", (e, t) => {
  sh.init(e, t), H.init(e, t);
}), zp = /* @__PURE__ */ E("ZodE164", (e, t) => {
  uh.init(e, t), H.init(e, t);
}), Rp = /* @__PURE__ */ E("ZodJWT", (e, t) => {
  lh.init(e, t), H.init(e, t);
}), rs = /* @__PURE__ */ E("ZodNumber", (e, t) => {
  Ua.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (n, i, o) => Id(e, n, i), e.gt = (n, i) => e.check(/* @__PURE__ */ lo(n, i)), e.gte = (n, i) => e.check(/* @__PURE__ */ Wr(n, i)), e.min = (n, i) => e.check(/* @__PURE__ */ Wr(n, i)), e.lt = (n, i) => e.check(/* @__PURE__ */ co(n, i)), e.lte = (n, i) => e.check(/* @__PURE__ */ Br(n, i)), e.max = (n, i) => e.check(/* @__PURE__ */ Br(n, i)), e.int = (n) => e.check(po(n)), e.safe = (n) => e.check(po(n)), e.positive = (n) => e.check(/* @__PURE__ */ lo(0, n)), e.nonnegative = (n) => e.check(/* @__PURE__ */ Wr(0, n)), e.negative = (n) => e.check(/* @__PURE__ */ co(0, n)), e.nonpositive = (n) => e.check(/* @__PURE__ */ Br(0, n)), e.multipleOf = (n, i) => e.check(/* @__PURE__ */ fo(n, i)), e.step = (n, i) => e.check(/* @__PURE__ */ fo(n, i)), e.finite = () => e;
  const r = e._zod.bag;
  e.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), e.isFinite = !0, e.format = r.format ?? null;
});
function I(e) {
  return /* @__PURE__ */ od(rs, e);
}
const Pp = /* @__PURE__ */ E("ZodNumberFormat", (e, t) => {
  fh.init(e, t), rs.init(e, t);
});
function po(e) {
  return /* @__PURE__ */ ad(Pp, e);
}
const Fp = /* @__PURE__ */ E("ZodBoolean", (e, t) => {
  hh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => zd(e, r, n);
});
function _e(e) {
  return /* @__PURE__ */ sd(Fp, e);
}
const Cp = /* @__PURE__ */ E("ZodUnknown", (e, t) => {
  dh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Pd();
});
function yr() {
  return /* @__PURE__ */ ud(Cp);
}
const Np = /* @__PURE__ */ E("ZodNever", (e, t) => {
  ph.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Rd(e, r, n);
});
function Ap(e) {
  return /* @__PURE__ */ cd(Np, e);
}
const xp = /* @__PURE__ */ E("ZodArray", (e, t) => {
  vh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ad(e, r, n, i), e.element = t.element, e.min = (r, n) => e.check(/* @__PURE__ */ vr(r, n)), e.nonempty = (r) => e.check(/* @__PURE__ */ vr(1, r)), e.max = (r, n) => e.check(/* @__PURE__ */ Ga(r, n)), e.length = (r, n) => e.check(/* @__PURE__ */ Ka(r, n)), e.unwrap = () => e.element;
});
function j(e, t) {
  return /* @__PURE__ */ wd(xp, e, t);
}
const Mp = /* @__PURE__ */ E("ZodObject", (e, t) => {
  yh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => xd(e, r, n, i), Z(e, "shape", () => t.shape), e.keyof = () => ze(Object.keys(e._zod.def.shape)), e.catchall = (r) => e.clone({ ...e._zod.def, catchall: r }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: yr() }), e.loose = () => e.clone({ ...e._zod.def, catchall: yr() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Ap() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (r) => xl(e, r), e.safeExtend = (r) => Ml(e, r), e.merge = (r) => jl(e, r), e.pick = (r) => Nl(e, r), e.omit = (r) => Al(e, r), e.partial = (...r) => $l(ns, e, r[0]), e.required = (...r) => Ll(is, e, r[0]);
});
function O(e, t) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...F(t)
  };
  return new Mp(r);
}
const jp = /* @__PURE__ */ E("ZodUnion", (e, t) => {
  gh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Md(e, r, n, i), e.options = t.options;
});
function $p(e, t) {
  return new jp({
    type: "union",
    options: e,
    ...F(t)
  });
}
const Lp = /* @__PURE__ */ E("ZodIntersection", (e, t) => {
  bh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => jd(e, r, n, i);
});
function Vp(e, t) {
  return new Lp({
    type: "intersection",
    left: e,
    right: t
  });
}
const bn = /* @__PURE__ */ E("ZodEnum", (e, t) => {
  _h.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (n, i, o) => Fd(e, n, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const r = new Set(Object.keys(t.entries));
  e.extract = (n, i) => {
    const o = {};
    for (const a of n)
      if (r.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new bn({
      ...t,
      checks: [],
      ...F(i),
      entries: o
    });
  }, e.exclude = (n, i) => {
    const o = { ...t.entries };
    for (const a of n)
      if (r.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new bn({
      ...t,
      checks: [],
      ...F(i),
      entries: o
    });
  };
});
function ze(e, t) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((n) => [n, n])) : e;
  return new bn({
    type: "enum",
    entries: r,
    ...F(t)
  });
}
const qp = /* @__PURE__ */ E("ZodTransform", (e, t) => {
  wh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Nd(e, r), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      throw new za(e.constructor.name);
    r.addIssue = (o) => {
      if (typeof o == "string")
        r.issues.push(Bt(o, r.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = r.value), a.inst ?? (a.inst = e), r.issues.push(Bt(a));
      }
    };
    const i = t.transform(r.value, r);
    return i instanceof Promise ? i.then((o) => (r.value = o, r)) : (r.value = i, r);
  };
});
function Zp(e) {
  return new qp({
    type: "transform",
    transform: e
  });
}
const ns = /* @__PURE__ */ E("ZodOptional", (e, t) => {
  Ja.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => es(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function vo(e) {
  return new ns({
    type: "optional",
    innerType: e
  });
}
const Qp = /* @__PURE__ */ E("ZodExactOptional", (e, t) => {
  Eh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => es(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function Up(e) {
  return new Qp({
    type: "optional",
    innerType: e
  });
}
const Bp = /* @__PURE__ */ E("ZodNullable", (e, t) => {
  kh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => $d(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function mo(e) {
  return new Bp({
    type: "nullable",
    innerType: e
  });
}
const Wp = /* @__PURE__ */ E("ZodDefault", (e, t) => {
  Sh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Vd(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Jp(e, t) {
  return new Wp({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Ca(t);
    }
  });
}
const Gp = /* @__PURE__ */ E("ZodPrefault", (e, t) => {
  Oh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => qd(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function Kp(e, t) {
  return new Gp({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Ca(t);
    }
  });
}
const is = /* @__PURE__ */ E("ZodNonOptional", (e, t) => {
  Th.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ld(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function Hp(e, t) {
  return new is({
    type: "nonoptional",
    innerType: e,
    ...F(t)
  });
}
const Yp = /* @__PURE__ */ E("ZodCatch", (e, t) => {
  Dh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Zd(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Xp(e, t) {
  return new Yp({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const ev = /* @__PURE__ */ E("ZodPipe", (e, t) => {
  Ih.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Qd(e, r, n, i), e.in = t.in, e.out = t.out;
});
function yo(e, t) {
  return new ev({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const tv = /* @__PURE__ */ E("ZodReadonly", (e, t) => {
  zh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ud(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function rv(e) {
  return new tv({
    type: "readonly",
    innerType: e
  });
}
const nv = /* @__PURE__ */ E("ZodCustom", (e, t) => {
  Rh.init(e, t), ne.init(e, t), e._zod.processJSONSchema = (r, n, i) => Cd(e, r);
});
function iv(e, t = {}) {
  return /* @__PURE__ */ Ed(nv, e, t);
}
function ov(e) {
  return /* @__PURE__ */ kd(e);
}
const os = O({
  id: _(),
  name: _(),
  slug: _(),
  status: ze(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: O({}).partial().passthrough(),
  output: O({}).partial().passthrough().nullable(),
  createdAt: _(),
  startedAt: _().nullable(),
  endedAt: _().nullable()
}).passthrough(), av = O({ analyses: j(os) }).passthrough(), sv = O({
  name: _().min(1).max(100),
  outputLocation: O({ s3BucketId: I(), path: _().optional() }).passthrough(),
  analysisSchemaId: I().int().gt(0),
  version: I(),
  input: yr()
}).passthrough(), uv = O({
  analysisId: _().nullable(),
  analysisSlug: _().nullable(),
  success: _e()
}).passthrough(), as = O({ id: I(), name: _(), versions: j(I()) }).passthrough(), cv = O({ analysisSchemas: j(as) }).passthrough(), Wn = O({
  id: I(),
  name: _(),
  schema: O({}).partial().passthrough()
}).passthrough(), _n = O({ id: I(), name: _(), valueSchema: Wn }).passthrough(), ss = O({
  analysisSchemaId: I(),
  version: I(),
  createdAt: _(),
  description: O({ short: _().nullable(), long: _().nullable() }).partial().passthrough(),
  inputs: j(_n),
  outputs: j(_n)
}).passthrough(), lv = O({ versions: j(ss) }).passthrough(), fv = O({ logs: j(_()) }).passthrough(), us = O({
  id: _(),
  name: _(),
  status: _(),
  analysisId: _(),
  startedAt: _(),
  endedAt: _(),
  memory: I(),
  vcpus: I(),
  cost: I()
}).passthrough(), hv = O({ tasks: j(us) }).passthrough(), dv = O({
  totalCost: I(),
  tasks: j(O({ name: _(), cost: I() }).passthrough()),
  runner: I()
}).passthrough(), cs = O({
  analysisSchemaId: I(),
  version: I(),
  name: _()
}).passthrough(), pv = O({ next: j(cs) }).passthrough(), vv = O({ valueSchemas: j(Wn) }).passthrough(), ls = ze([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), Jn = ze([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update"
]), Gn = O({
  id: _(),
  firstname: _().nullable(),
  lastname: _().nullable(),
  email: _().nullable(),
  keyPairId: I(),
  roles: j(ls),
  permissions: j(Jn)
}).passthrough(), mv = O({ user: Gn }).partial().passthrough(), yv = O({ email: _() }).passthrough(), gv = O({ success: _e() }).passthrough(), bv = O({ otp: _() }).passthrough(), _v = O({ success: _e() }).passthrough(), wv = O({ success: _e() }).passthrough(), Ev = O({ token: _() }).passthrough(), kv = O({ token: _() }).passthrough(), Sv = O({ valid: _e() }).passthrough(), Ov = O({ name: _(), permissions: j(Jn) }).passthrough(), fs = O({
  id: I(),
  instanceProfile: _().nullable(),
  securityGroup: _().nullable()
}).passthrough(), Jt = O({
  id: I(),
  name: _(),
  labId: I().nullish(),
  userId: _().nullish(),
  status: ze([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: _().nullish(),
  lastLogin: _().nullish(),
  keypairId: I().nullish()
}).passthrough(), Tv = O({
  infra: j(fs),
  keyPairs: j(_()),
  tinkerBoxes: j(Jt)
}).passthrough(), Dv = O({ count: I().gte(1).lte(15) }).passthrough(), Iv = O({
  firstname: _().min(1),
  lastname: _().min(1),
  email: _().email(),
  password: _().min(8)
}).passthrough(), zv = O({ users: j(Gn) }).passthrough(), Rv = O({
  firstname: _().nullable(),
  lastname: _().nullable(),
  email: _().nullable()
}).partial().passthrough(), hs = O({ tinkerBox: Jt, keyMaterial: _() }).passthrough(), Pv = O({ tinkerBoxes: j(hs) }).passthrough(), ds = O({
  labName: _(),
  ec2Cost: I(),
  s3Cost: I(),
  efsCost: I(),
  totalCost: I()
}).passthrough(), Fv = O({ clients: j(ds) }).passthrough(), ps = O({
  name: _(),
  labName: _(),
  usage: _(),
  cost: I()
}).passthrough(), Cv = O({ tinkerBoxes: j(ps) }).passthrough(), Nv = O({ tinkerboxes: j(Jt) }).passthrough(), Av = O({ tinkerBox: Jt }).passthrough(), xv = O({ name: _() }).passthrough(), vs = O({
  id: I(),
  date: _(),
  tinkerBoxName: _(),
  lastLoginDate: _().nullable(),
  lastCommandDate: _().nullable(),
  lastCommand: _().nullable(),
  activeProcesses: _e(),
  status: ze([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  tinkerBoxId: I(),
  autoStopTime: _().nullable()
}).passthrough(), Mv = O({ allLastActivity: j(vs) }).passthrough(), jv = O({ name: _().nullable() }).partial().passthrough(), ms = O({
  id: I(),
  name: _(),
  s3BucketId: I(),
  keyPairId: I()
}).passthrough(), $v = O({ labs: j(ms) }).passthrough(), Lv = O({
  name: _(),
  numTinkerBoxes: I().optional().default(1)
}).passthrough(), Vv = O({ labId: I(), taskId: _() }).passthrough(), qv = O({ id: _(), labId: I(), logs: _() }).passthrough(), Kn = O({
  id: I(),
  labId: I(),
  userId: _(),
  role: ze(["OWNER", "MEMBER"]),
  user: O({
    firstname: _().nullable(),
    lastname: _().nullable(),
    email: _().nullable(),
    id: _()
  }).partial().passthrough()
}).passthrough(), Zv = O({ labMember: Kn.nullable() }).passthrough(), Qv = O({ labMembers: j(Kn) }).passthrough(), Uv = O({
  labMember: O({
    id: I().int(),
    labId: I().int(),
    userId: _(),
    role: ze(["OWNER", "MEMBER"])
  }).passthrough()
}).passthrough(), Bv = O({ role: _() }).passthrough(), Wv = O({ labMemberId: I(), role: _() }).passthrough(), Jv = O({ success: _e() }).passthrough(), Gv = O({
  client_secret: _().nullable(),
  status: _().nullable(),
  payment_status: _()
}).passthrough(), Kv = O({ name: _(), email: _().email(), message: _() }).passthrough(), Hv = O({ path: _(), s3BucketId: I().optional() }).passthrough(), Yv = O({ success: _e() }).passthrough(), Xv = O({ url: _() }).passthrough(), ys = O({
  isFolder: _e(),
  bucketId: I().optional(),
  path: _()
}).passthrough(), em = O({ contents: j(ys) }).passthrough(), tm = O({ files: j(_()) }).passthrough(), rm = O({
  buckets: j(O({
    id: I().int(),
    bucket: _(),
    region: _(),
    prefix: _().nullish()
  }).passthrough())
}).passthrough(), nm = O({
  source: O({
    isFolder: _e(),
    bucketId: I().optional(),
    path: _()
  }).passthrough(),
  target: O({
    isFolder: _e(),
    bucketId: I().optional(),
    path: _()
  }).passthrough()
}).passthrough(), im = O({
  fileTransfers: j(O({
    id: I().int(),
    name: _(),
    userId: _(),
    progress: I()
  }).passthrough())
}).passthrough(), gs = O({
  id: I(),
  name: _(),
  analysisSchemaId: I(),
  analysisSchemaVersion: I(),
  config: O({}).partial().passthrough()
}).passthrough(), om = O({ templates: j(gs) }).passthrough(), am = O({
  name: _().min(1).max(255),
  analysisSchemaId: I().int(),
  analysisSchemaVersion: I().int().gt(0),
  triggerLocation: O({
    bucketId: I().int().gt(0),
    folderPath: _().max(2048)
  }).passthrough(),
  config: yr()
}).passthrough(), sm = O({
  id: I(),
  name: _(),
  s3BucketId: I(),
  triggerFolder: _(),
  analysisSchemaId: I(),
  analysisSchemaVersion: I(),
  config: O({}).partial().passthrough()
}).passthrough(), um = O({ name: _(), enabled: _e() }).passthrough(), cm = O({
  id: I(),
  name: _(),
  schema: O({}).partial().passthrough()
}).passthrough(), lm = O({
  id: I(),
  formId: I(),
  data: O({}).partial().passthrough(),
  dateCreated: _()
}).passthrough(), fm = O({
  id: I(),
  name: _(),
  displayName: _(),
  hichip: _(),
  source: _(),
  bucket: _(),
  bedpeKey: _(),
  hicKey: _(),
  category: _()
}).passthrough(), hm = O({
  id: I(),
  sampleId: I(),
  cluster: _(),
  chr: _(),
  start: I(),
  end: I(),
  size: I(),
  genes: _()
}).passthrough(), dm = O({
  plotId: _(),
  status: ze(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: _(),
  outputKey: _(),
  inputs: O({}).partial().passthrough(),
  endedAt: _().nullable(),
  downloadUrl: _().nullable()
}).passthrough(), pm = O({
  sample: _(),
  range: _(),
  genomeBuild: ze(["hg19", "hg38"]),
  color: _().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: _(),
  flank: I(),
  bedpe: _()
}).passthrough(), Hn = O({
  id: I(),
  title: _(),
  content: _(),
  createdAt: _(),
  updatedAt: _(),
  isActive: _e()
}).passthrough(), vm = O({ announcements: j(Hn) }).passthrough(), mm = O({ announcement: Hn.nullable() }).passthrough(), go = {
  AnalysisDto: os,
  AnalysesDto: av,
  CreateAnalysisBodyDto: sv,
  CreateAndLaunchAnalysisResponseDto: uv,
  AnalysisSchemaDto: as,
  AnalysisSchemasDto: cv,
  ValueSchemaDto: Wn,
  AnalysisSchemaInputOutput: _n,
  AnalysisSchemaVersionDto: ss,
  AnalysisSchemaVersionsDto: lv,
  AnalysisLogsDto: fv,
  TaskDto: us,
  TasksDto: hv,
  AnalysisCostBreakdownDto: dv,
  AnalysisNextDto: cs,
  AnalysisNextListDto: pv,
  ValueSchemasDto: vv,
  UserRole: ls,
  Permission: Jn,
  UserDto: Gn,
  MeResponse: mv,
  RequestOtpBody: yv,
  RequestOtpResponse: gv,
  LoginBody: bv,
  LoginResponse: _v,
  SuccessDto: wv,
  LoginCliResponse: Ev,
  VerifyTokenBody: kv,
  VerifyTokenResponse: Sv,
  RoleDto: Ov,
  Infra: fs,
  TinkerBox: Jt,
  InfraPool: Tv,
  CreateInfraPoolBody: Dv,
  CreateUserBody: Iv,
  UsersDto: zv,
  UpdateUserBody: Rv,
  TinkerBoxInventory: hs,
  TinkerBoxInventoryList: Pv,
  ClientUsage: ds,
  ClientsUsage: Fv,
  TinkerBoxWithUsage: ps,
  TinkerBoxesWithUsage: Cv,
  GetTinkerBoxesResponse: Nv,
  LaunchTinkerBoxResponse: Av,
  UpdateTinkerBoxBodyDto: xv,
  TinkerBoxLastActivityDto: vs,
  AllLastActivityDto: Mv,
  LaunchLabTinkerBoxBody: jv,
  Lab: ms,
  LabsResponse: $v,
  CreateLabBody: Lv,
  CreateLabResponse: Vv,
  GetLabCreationTaskResponse: qv,
  LabMemberDto: Kn,
  LabMemberResponse: Zv,
  LabMembersResponse: Qv,
  AddLabMemberResponse: Uv,
  UpdateLabMemberBody: Bv,
  UpdateLabMemberResponse: Wv,
  DeleteLabMemberResponse: Jv,
  CheckoutSession: Gv,
  ContactBody: Kv,
  CreateDirectoryBody: Hv,
  CreateDirectoryResponse: Yv,
  PresignedUrlResponse: Xv,
  FilePath: ys,
  ContentsResponse: em,
  DeleteFilesResponse: tm,
  GetBucketsResponse: rm,
  MoveFileBody: nm,
  FileTransfersResponse: im,
  ActionTemplateDto: gs,
  ActionTemplatesDto: om,
  CreateActionBodyDto: am,
  ActionDto: sm,
  FeatureFlagDto: um,
  FormSchema: cm,
  FormSubmission: lm,
  SampleDto: fm,
  SampleClusterDto: hm,
  PlotDto: dm,
  PlotContactsArgs: pm,
  Announcement: Hn,
  ActiveAnnouncements: vm,
  LatestAnnouncement: mm
};
class Sm {
  constructor(t) {
    It(this, "fetch");
    this.fetch = t;
  }
  async download(t, r, n = null, i = !0) {
    let a = `/files/presigned/${encodeURIComponent(r)}/url?method=download`;
    t && (a += `&bucket=${t}`), n && (a += `&limit=${n}`);
    const u = (await this.fetch(a, { method: "GET" }, go.PresignedUrlResponse)).url;
    if (i) {
      const c = document.createElement("a");
      c.href = u, c.download = "", c.target = "_blank", c.click(), document.body.appendChild(c), c.click(), setTimeout(() => {
        document.body.removeChild(c);
      });
    }
    return u;
  }
  async upload(t, r, n) {
    const i = [];
    let a = `/files/presigned/${encodeURIComponent(n)}/url?method=upload`;
    r && (a = a += `&bucket=${r}`);
    const u = (await this.fetch(a, { method: "GET" }, go.PresignedUrlResponse)).url, c = new XMLHttpRequest();
    return c.open("PUT", u), c.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), c.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, c.upload.addEventListener("progress", (l) => {
      const h = l.loaded / l.total;
      for (const d of i)
        d.onProgress(h);
    }), c.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      c.upload.removeEventListener("progress", () => null);
    }), c.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
const ym = async (e) => {
  if (!(await fetch(e, {
    method: "GET",
    credentials: "include"
  })).ok)
    throw new Error("Failed to refresh token");
};
function Om(e) {
  async function t(r, n = {}, i, o = !0) {
    const a = { "Content-Type": "application/json", ...n.headers }, s = await fetch(`${e}${r}`, {
      ...n,
      headers: a,
      credentials: "include"
    });
    if ((s.status === 401 || s.status === 403) && o)
      return await ym(`${e}/auth/token/refresh`), t(r, { headers: a, ...n, credentials: "include" }, i, !1);
    if (!s.ok) {
      const u = await s.text();
      throw new Error(u);
    }
    if (i) {
      const u = await s.json();
      return i.parse(u);
    } else
      return s;
  }
  return t;
}
export {
  km as APIClient,
  Sm as S3,
  Om as createFetch,
  ym as refreshToken,
  go as schemas
};
//# sourceMappingURL=client.js.map
